!(function (t) {
  var e = {};

  function i(n) {
    if (e[n]) return e[n].exports;
    var o = (e[n] = {
      i: n,
      l: !1,
      exports: {},
    });
    return t[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
  }
  (i.m = t),
    (i.c = e),
    (i.d = function (t, e, n) {
      i.o(t, e) ||
        Object.defineProperty(t, e, {
          enumerable: !0,
          get: n,
        });
    }),
    (i.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, {
          value: 'Module',
        }),
        Object.defineProperty(t, '__esModule', {
          value: !0,
        });
    }),
    (i.t = function (t, e) {
      if ((1 & e && (t = i(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (
        (i.r(n),
        Object.defineProperty(n, 'default', {
          enumerable: !0,
          value: t,
        }),
        2 & e && 'string' != typeof t)
      )
        for (var o in t)
          i.d(
            n,
            o,
            function (e) {
              return t[e];
            }.bind(null, o)
          );
      return n;
    }),
    (i.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return i.d(e, 'a', e), e;
    }),
    (i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (i.p = ''),
    i((i.s = 14));
})([
  function (t, e) {
    t.exports = jQuery;
  },
  function (t, e, i) {
    (function (t, i) {
      var n;
      !(function () {
        var o =
            ('object' == typeof self && self.self === self && self) ||
            ('object' == typeof t && t.global === t && t) ||
            this ||
            {},
          s = o._,
          r = Array.prototype,
          a = Object.prototype,
          l = 'undefined' != typeof Symbol ? Symbol.prototype : null,
          c = r.push,
          d = r.slice,
          u = a.toString,
          h = a.hasOwnProperty,
          p = Array.isArray,
          f = Object.keys,
          v = Object.create,
          m = function () {},
          g = function (t) {
            return t instanceof g
              ? t
              : this instanceof g
              ? void (this._wrapped = t)
              : new g(t);
          };
        e.nodeType
          ? (o._ = g)
          : (!i.nodeType && i.exports && (e = i.exports = g), (e._ = g)),
          (g.VERSION = '1.9.1');
        var y,
          w = function (t, e, i) {
            if (void 0 === e) return t;
            switch (null == i ? 3 : i) {
              case 1:
                return function (i) {
                  return t.call(e, i);
                };
              case 3:
                return function (i, n, o) {
                  return t.call(e, i, n, o);
                };
              case 4:
                return function (i, n, o, s) {
                  return t.call(e, i, n, o, s);
                };
            }
            return function () {
              return t.apply(e, arguments);
            };
          },
          b = function (t, e, i) {
            return g.iteratee !== y
              ? g.iteratee(t, e)
              : null == t
              ? g.identity
              : g.isFunction(t)
              ? w(t, e, i)
              : g.isObject(t) && !g.isArray(t)
              ? g.matcher(t)
              : g.property(t);
          };
        g.iteratee = y = function (t, e) {
          return b(t, e, 1 / 0);
        };
        var $ = function (t, e) {
            return (
              (e = null == e ? t.length - 1 : +e),
              function () {
                for (
                  var i = Math.max(arguments.length - e, 0),
                    n = Array(i),
                    o = 0;
                  o < i;
                  o++
                )
                  n[o] = arguments[o + e];
                switch (e) {
                  case 0:
                    return t.call(this, n);
                  case 1:
                    return t.call(this, arguments[0], n);
                  case 2:
                    return t.call(this, arguments[0], arguments[1], n);
                }
                var s = Array(e + 1);
                for (o = 0; o < e; o++) s[o] = arguments[o];
                return (s[e] = n), t.apply(this, s);
              }
            );
          },
          k = function (t) {
            if (!g.isObject(t)) return {};
            if (v) return v(t);
            m.prototype = t;
            var e = new m();
            return (m.prototype = null), e;
          },
          S = function (t) {
            return function (e) {
              return null == e ? void 0 : e[t];
            };
          },
          C = function (t, e) {
            return null != t && h.call(t, e);
          },
          T = function (t, e) {
            for (var i = e.length, n = 0; n < i; n++) {
              if (null == t) return;
              t = t[e[n]];
            }
            return i ? t : void 0;
          },
          x = Math.pow(2, 53) - 1,
          O = S('length'),
          _ = function (t) {
            var e = O(t);
            return 'number' == typeof e && e >= 0 && e <= x;
          };
        (g.each = g.forEach =
          function (t, e, i) {
            var n, o;
            if (((e = w(e, i)), _(t)))
              for (n = 0, o = t.length; n < o; n++) e(t[n], n, t);
            else {
              var s = g.keys(t);
              for (n = 0, o = s.length; n < o; n++) e(t[s[n]], s[n], t);
            }
            return t;
          }),
          (g.map = g.collect =
            function (t, e, i) {
              e = b(e, i);
              for (
                var n = !_(t) && g.keys(t),
                  o = (n || t).length,
                  s = Array(o),
                  r = 0;
                r < o;
                r++
              ) {
                var a = n ? n[r] : r;
                s[r] = e(t[a], a, t);
              }
              return s;
            });
        var I = function (t) {
          var e = function (e, i, n, o) {
            var s = !_(e) && g.keys(e),
              r = (s || e).length,
              a = t > 0 ? 0 : r - 1;
            for (
              o || ((n = e[s ? s[a] : a]), (a += t));
              a >= 0 && a < r;
              a += t
            ) {
              var l = s ? s[a] : a;
              n = i(n, e[l], l, e);
            }
            return n;
          };
          return function (t, i, n, o) {
            var s = arguments.length >= 3;
            return e(t, w(i, o, 4), n, s);
          };
        };
        (g.reduce = g.foldl = g.inject = I(1)),
          (g.reduceRight = g.foldr = I(-1)),
          (g.find = g.detect =
            function (t, e, i) {
              var n = (_(t) ? g.findIndex : g.findKey)(t, e, i);
              if (void 0 !== n && -1 !== n) return t[n];
            }),
          (g.filter = g.select =
            function (t, e, i) {
              var n = [];
              return (
                (e = b(e, i)),
                g.each(t, function (t, i, o) {
                  e(t, i, o) && n.push(t);
                }),
                n
              );
            }),
          (g.reject = function (t, e, i) {
            return g.filter(t, g.negate(b(e)), i);
          }),
          (g.every = g.all =
            function (t, e, i) {
              e = b(e, i);
              for (
                var n = !_(t) && g.keys(t), o = (n || t).length, s = 0;
                s < o;
                s++
              ) {
                var r = n ? n[s] : s;
                if (!e(t[r], r, t)) return !1;
              }
              return !0;
            }),
          (g.some = g.any =
            function (t, e, i) {
              e = b(e, i);
              for (
                var n = !_(t) && g.keys(t), o = (n || t).length, s = 0;
                s < o;
                s++
              ) {
                var r = n ? n[s] : s;
                if (e(t[r], r, t)) return !0;
              }
              return !1;
            }),
          (g.contains =
            g.includes =
            g.include =
              function (t, e, i, n) {
                return (
                  _(t) || (t = g.values(t)),
                  ('number' != typeof i || n) && (i = 0),
                  g.indexOf(t, e, i) >= 0
                );
              }),
          (g.invoke = $(function (t, e, i) {
            var n, o;
            return (
              g.isFunction(e)
                ? (o = e)
                : g.isArray(e) && ((n = e.slice(0, -1)), (e = e[e.length - 1])),
              g.map(t, function (t) {
                var s = o;
                if (!s) {
                  if ((n && n.length && (t = T(t, n)), null == t)) return;
                  s = t[e];
                }
                return null == s ? s : s.apply(t, i);
              })
            );
          })),
          (g.pluck = function (t, e) {
            return g.map(t, g.property(e));
          }),
          (g.where = function (t, e) {
            return g.filter(t, g.matcher(e));
          }),
          (g.findWhere = function (t, e) {
            return g.find(t, g.matcher(e));
          }),
          (g.max = function (t, e, i) {
            var n,
              o,
              s = -1 / 0,
              r = -1 / 0;
            if (
              null == e ||
              ('number' == typeof e && 'object' != typeof t[0] && null != t)
            )
              for (
                var a = 0, l = (t = _(t) ? t : g.values(t)).length;
                a < l;
                a++
              )
                null != (n = t[a]) && n > s && (s = n);
            else
              (e = b(e, i)),
                g.each(t, function (t, i, n) {
                  ((o = e(t, i, n)) > r || (o === -1 / 0 && s === -1 / 0)) &&
                    ((s = t), (r = o));
                });
            return s;
          }),
          (g.min = function (t, e, i) {
            var n,
              o,
              s = 1 / 0,
              r = 1 / 0;
            if (
              null == e ||
              ('number' == typeof e && 'object' != typeof t[0] && null != t)
            )
              for (
                var a = 0, l = (t = _(t) ? t : g.values(t)).length;
                a < l;
                a++
              )
                null != (n = t[a]) && n < s && (s = n);
            else
              (e = b(e, i)),
                g.each(t, function (t, i, n) {
                  ((o = e(t, i, n)) < r || (o === 1 / 0 && s === 1 / 0)) &&
                    ((s = t), (r = o));
                });
            return s;
          }),
          (g.shuffle = function (t) {
            return g.sample(t, 1 / 0);
          }),
          (g.sample = function (t, e, i) {
            if (null == e || i)
              return _(t) || (t = g.values(t)), t[g.random(t.length - 1)];
            var n = _(t) ? g.clone(t) : g.values(t),
              o = O(n);
            e = Math.max(Math.min(e, o), 0);
            for (var s = o - 1, r = 0; r < e; r++) {
              var a = g.random(r, s),
                l = n[r];
              (n[r] = n[a]), (n[a] = l);
            }
            return n.slice(0, e);
          }),
          (g.sortBy = function (t, e, i) {
            var n = 0;
            return (
              (e = b(e, i)),
              g.pluck(
                g
                  .map(t, function (t, i, o) {
                    return {
                      value: t,
                      index: n++,
                      criteria: e(t, i, o),
                    };
                  })
                  .sort(function (t, e) {
                    var i = t.criteria,
                      n = e.criteria;
                    if (i !== n) {
                      if (i > n || void 0 === i) return 1;
                      if (i < n || void 0 === n) return -1;
                    }
                    return t.index - e.index;
                  }),
                'value'
              )
            );
          });
        var z = function (t, e) {
          return function (i, n, o) {
            var s = e ? [[], []] : {};
            return (
              (n = b(n, o)),
              g.each(i, function (e, o) {
                var r = n(e, o, i);
                t(s, e, r);
              }),
              s
            );
          };
        };
        (g.groupBy = z(function (t, e, i) {
          C(t, i) ? t[i].push(e) : (t[i] = [e]);
        })),
          (g.indexBy = z(function (t, e, i) {
            t[i] = e;
          })),
          (g.countBy = z(function (t, e, i) {
            C(t, i) ? t[i]++ : (t[i] = 1);
          }));
        var A =
          /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
        (g.toArray = function (t) {
          return t
            ? g.isArray(t)
              ? d.call(t)
              : g.isString(t)
              ? t.match(A)
              : _(t)
              ? g.map(t, g.identity)
              : g.values(t)
            : [];
        }),
          (g.size = function (t) {
            return null == t ? 0 : _(t) ? t.length : g.keys(t).length;
          }),
          (g.partition = z(function (t, e, i) {
            t[i ? 0 : 1].push(e);
          }, !0)),
          (g.first =
            g.head =
            g.take =
              function (t, e, i) {
                return null == t || t.length < 1
                  ? null == e
                    ? void 0
                    : []
                  : null == e || i
                  ? t[0]
                  : g.initial(t, t.length - e);
              }),
          (g.initial = function (t, e, i) {
            return d.call(
              t,
              0,
              Math.max(0, t.length - (null == e || i ? 1 : e))
            );
          }),
          (g.last = function (t, e, i) {
            return null == t || t.length < 1
              ? null == e
                ? void 0
                : []
              : null == e || i
              ? t[t.length - 1]
              : g.rest(t, Math.max(0, t.length - e));
          }),
          (g.rest =
            g.tail =
            g.drop =
              function (t, e, i) {
                return d.call(t, null == e || i ? 1 : e);
              }),
          (g.compact = function (t) {
            return g.filter(t, Boolean);
          });
        var M = function (t, e, i, n) {
          for (var o = (n = n || []).length, s = 0, r = O(t); s < r; s++) {
            var a = t[s];
            if (_(a) && (g.isArray(a) || g.isArguments(a)))
              if (e) for (var l = 0, c = a.length; l < c; ) n[o++] = a[l++];
              else M(a, e, i, n), (o = n.length);
            else i || (n[o++] = a);
          }
          return n;
        };
        (g.flatten = function (t, e) {
          return M(t, e, !1);
        }),
          (g.without = $(function (t, e) {
            return g.difference(t, e);
          })),
          (g.uniq = g.unique =
            function (t, e, i, n) {
              g.isBoolean(e) || ((n = i), (i = e), (e = !1)),
                null != i && (i = b(i, n));
              for (var o = [], s = [], r = 0, a = O(t); r < a; r++) {
                var l = t[r],
                  c = i ? i(l, r, t) : l;
                e && !i
                  ? ((r && s === c) || o.push(l), (s = c))
                  : i
                  ? g.contains(s, c) || (s.push(c), o.push(l))
                  : g.contains(o, l) || o.push(l);
              }
              return o;
            }),
          (g.union = $(function (t) {
            return g.uniq(M(t, !0, !0));
          })),
          (g.intersection = function (t) {
            for (
              var e = [], i = arguments.length, n = 0, o = O(t);
              n < o;
              n++
            ) {
              var s = t[n];
              if (!g.contains(e, s)) {
                var r;
                for (r = 1; r < i && g.contains(arguments[r], s); r++);
                r === i && e.push(s);
              }
            }
            return e;
          }),
          (g.difference = $(function (t, e) {
            return (
              (e = M(e, !0, !0)),
              g.filter(t, function (t) {
                return !g.contains(e, t);
              })
            );
          })),
          (g.unzip = function (t) {
            for (
              var e = (t && g.max(t, O).length) || 0, i = Array(e), n = 0;
              n < e;
              n++
            )
              i[n] = g.pluck(t, n);
            return i;
          }),
          (g.zip = $(g.unzip)),
          (g.object = function (t, e) {
            for (var i = {}, n = 0, o = O(t); n < o; n++)
              e ? (i[t[n]] = e[n]) : (i[t[n][0]] = t[n][1]);
            return i;
          });
        var j = function (t) {
          return function (e, i, n) {
            i = b(i, n);
            for (var o = O(e), s = t > 0 ? 0 : o - 1; s >= 0 && s < o; s += t)
              if (i(e[s], s, e)) return s;
            return -1;
          };
        };
        (g.findIndex = j(1)),
          (g.findLastIndex = j(-1)),
          (g.sortedIndex = function (t, e, i, n) {
            for (var o = (i = b(i, n, 1))(e), s = 0, r = O(t); s < r; ) {
              var a = Math.floor((s + r) / 2);
              i(t[a]) < o ? (s = a + 1) : (r = a);
            }
            return s;
          });
        var P = function (t, e, i) {
          return function (n, o, s) {
            var r = 0,
              a = O(n);
            if ('number' == typeof s)
              t > 0
                ? (r = s >= 0 ? s : Math.max(s + a, r))
                : (a = s >= 0 ? Math.min(s + 1, a) : s + a + 1);
            else if (i && s && a) return n[(s = i(n, o))] === o ? s : -1;
            if (o != o)
              return (s = e(d.call(n, r, a), g.isNaN)) >= 0 ? s + r : -1;
            for (s = t > 0 ? r : a - 1; s >= 0 && s < a; s += t)
              if (n[s] === o) return s;
            return -1;
          };
        };
        (g.indexOf = P(1, g.findIndex, g.sortedIndex)),
          (g.lastIndexOf = P(-1, g.findLastIndex)),
          (g.range = function (t, e, i) {
            null == e && ((e = t || 0), (t = 0)), i || (i = e < t ? -1 : 1);
            for (
              var n = Math.max(Math.ceil((e - t) / i), 0), o = Array(n), s = 0;
              s < n;
              s++, t += i
            )
              o[s] = t;
            return o;
          }),
          (g.chunk = function (t, e) {
            if (null == e || e < 1) return [];
            for (var i = [], n = 0, o = t.length; n < o; )
              i.push(d.call(t, n, (n += e)));
            return i;
          });
        var E = function (t, e, i, n, o) {
          if (!(n instanceof e)) return t.apply(i, o);
          var s = k(t.prototype),
            r = t.apply(s, o);
          return g.isObject(r) ? r : s;
        };
        (g.bind = $(function (t, e, i) {
          if (!g.isFunction(t))
            throw new TypeError('Bind must be called on a function');
          var n = $(function (o) {
            return E(t, n, e, this, i.concat(o));
          });
          return n;
        })),
          (g.partial = $(function (t, e) {
            var i = g.partial.placeholder,
              n = function () {
                for (var o = 0, s = e.length, r = Array(s), a = 0; a < s; a++)
                  r[a] = e[a] === i ? arguments[o++] : e[a];
                for (; o < arguments.length; ) r.push(arguments[o++]);
                return E(t, n, this, this, r);
              };
            return n;
          })),
          (g.partial.placeholder = g),
          (g.bindAll = $(function (t, e) {
            var i = (e = M(e, !1, !1)).length;
            if (i < 1) throw new Error('bindAll must be passed function names');
            for (; i--; ) {
              var n = e[i];
              t[n] = g.bind(t[n], t);
            }
          })),
          (g.memoize = function (t, e) {
            var i = function (n) {
              var o = i.cache,
                s = '' + (e ? e.apply(this, arguments) : n);
              return C(o, s) || (o[s] = t.apply(this, arguments)), o[s];
            };
            return (i.cache = {}), i;
          }),
          (g.delay = $(function (t, e, i) {
            return setTimeout(function () {
              return t.apply(null, i);
            }, e);
          })),
          (g.defer = g.partial(g.delay, g, 1)),
          (g.throttle = function (t, e, i) {
            var n,
              o,
              s,
              r,
              a = 0;
            i || (i = {});
            var l = function () {
                (a = !1 === i.leading ? 0 : g.now()),
                  (n = null),
                  (r = t.apply(o, s)),
                  n || (o = s = null);
              },
              c = function () {
                var c = g.now();
                a || !1 !== i.leading || (a = c);
                var d = e - (c - a);
                return (
                  (o = this),
                  (s = arguments),
                  d <= 0 || d > e
                    ? (n && (clearTimeout(n), (n = null)),
                      (a = c),
                      (r = t.apply(o, s)),
                      n || (o = s = null))
                    : n || !1 === i.trailing || (n = setTimeout(l, d)),
                  r
                );
              };
            return (
              (c.cancel = function () {
                clearTimeout(n), (a = 0), (n = o = s = null);
              }),
              c
            );
          }),
          (g.debounce = function (t, e, i) {
            var n,
              o,
              s = function (e, i) {
                (n = null), i && (o = t.apply(e, i));
              },
              r = $(function (r) {
                if ((n && clearTimeout(n), i)) {
                  var a = !n;
                  (n = setTimeout(s, e)), a && (o = t.apply(this, r));
                } else n = g.delay(s, e, this, r);
                return o;
              });
            return (
              (r.cancel = function () {
                clearTimeout(n), (n = null);
              }),
              r
            );
          }),
          (g.wrap = function (t, e) {
            return g.partial(e, t);
          }),
          (g.negate = function (t) {
            return function () {
              return !t.apply(this, arguments);
            };
          }),
          (g.compose = function () {
            var t = arguments,
              e = t.length - 1;
            return function () {
              for (var i = e, n = t[e].apply(this, arguments); i--; )
                n = t[i].call(this, n);
              return n;
            };
          }),
          (g.after = function (t, e) {
            return function () {
              if (--t < 1) return e.apply(this, arguments);
            };
          }),
          (g.before = function (t, e) {
            var i;
            return function () {
              return (
                --t > 0 && (i = e.apply(this, arguments)),
                t <= 1 && (e = null),
                i
              );
            };
          }),
          (g.once = g.partial(g.before, 2)),
          (g.restArguments = $);
        var H = !{
            toString: null,
          }.propertyIsEnumerable('toString'),
          F = [
            'valueOf',
            'isPrototypeOf',
            'toString',
            'propertyIsEnumerable',
            'hasOwnProperty',
            'toLocaleString',
          ],
          L = function (t, e) {
            var i = F.length,
              n = t.constructor,
              o = (g.isFunction(n) && n.prototype) || a,
              s = 'constructor';
            for (C(t, s) && !g.contains(e, s) && e.push(s); i--; )
              (s = F[i]) in t &&
                t[s] !== o[s] &&
                !g.contains(e, s) &&
                e.push(s);
          };
        (g.keys = function (t) {
          if (!g.isObject(t)) return [];
          if (f) return f(t);
          var e = [];
          for (var i in t) C(t, i) && e.push(i);
          return H && L(t, e), e;
        }),
          (g.allKeys = function (t) {
            if (!g.isObject(t)) return [];
            var e = [];
            for (var i in t) e.push(i);
            return H && L(t, e), e;
          }),
          (g.values = function (t) {
            for (
              var e = g.keys(t), i = e.length, n = Array(i), o = 0;
              o < i;
              o++
            )
              n[o] = t[e[o]];
            return n;
          }),
          (g.mapObject = function (t, e, i) {
            e = b(e, i);
            for (var n = g.keys(t), o = n.length, s = {}, r = 0; r < o; r++) {
              var a = n[r];
              s[a] = e(t[a], a, t);
            }
            return s;
          }),
          (g.pairs = function (t) {
            for (
              var e = g.keys(t), i = e.length, n = Array(i), o = 0;
              o < i;
              o++
            )
              n[o] = [e[o], t[e[o]]];
            return n;
          }),
          (g.invert = function (t) {
            for (var e = {}, i = g.keys(t), n = 0, o = i.length; n < o; n++)
              e[t[i[n]]] = i[n];
            return e;
          }),
          (g.functions = g.methods =
            function (t) {
              var e = [];
              for (var i in t) g.isFunction(t[i]) && e.push(i);
              return e.sort();
            });
        var N = function (t, e) {
          return function (i) {
            var n = arguments.length;
            if ((e && (i = Object(i)), n < 2 || null == i)) return i;
            for (var o = 1; o < n; o++)
              for (
                var s = arguments[o], r = t(s), a = r.length, l = 0;
                l < a;
                l++
              ) {
                var c = r[l];
                (e && void 0 !== i[c]) || (i[c] = s[c]);
              }
            return i;
          };
        };
        (g.extend = N(g.allKeys)),
          (g.extendOwn = g.assign = N(g.keys)),
          (g.findKey = function (t, e, i) {
            e = b(e, i);
            for (var n, o = g.keys(t), s = 0, r = o.length; s < r; s++)
              if (e(t[(n = o[s])], n, t)) return n;
          });
        var R,
          D,
          W = function (t, e, i) {
            return e in i;
          };
        (g.pick = $(function (t, e) {
          var i = {},
            n = e[0];
          if (null == t) return i;
          g.isFunction(n)
            ? (e.length > 1 && (n = w(n, e[1])), (e = g.allKeys(t)))
            : ((n = W), (e = M(e, !1, !1)), (t = Object(t)));
          for (var o = 0, s = e.length; o < s; o++) {
            var r = e[o],
              a = t[r];
            n(a, r, t) && (i[r] = a);
          }
          return i;
        })),
          (g.omit = $(function (t, e) {
            var i,
              n = e[0];
            return (
              g.isFunction(n)
                ? ((n = g.negate(n)), e.length > 1 && (i = e[1]))
                : ((e = g.map(M(e, !1, !1), String)),
                  (n = function (t, i) {
                    return !g.contains(e, i);
                  })),
              g.pick(t, n, i)
            );
          })),
          (g.defaults = N(g.allKeys, !0)),
          (g.create = function (t, e) {
            var i = k(t);
            return e && g.extendOwn(i, e), i;
          }),
          (g.clone = function (t) {
            return g.isObject(t)
              ? g.isArray(t)
                ? t.slice()
                : g.extend({}, t)
              : t;
          }),
          (g.tap = function (t, e) {
            return e(t), t;
          }),
          (g.isMatch = function (t, e) {
            var i = g.keys(e),
              n = i.length;
            if (null == t) return !n;
            for (var o = Object(t), s = 0; s < n; s++) {
              var r = i[s];
              if (e[r] !== o[r] || !(r in o)) return !1;
            }
            return !0;
          }),
          (R = function (t, e, i, n) {
            if (t === e) return 0 !== t || 1 / t == 1 / e;
            if (null == t || null == e) return !1;
            if (t != t) return e != e;
            var o = typeof t;
            return (
              ('function' === o || 'object' === o || 'object' == typeof e) &&
              D(t, e, i, n)
            );
          }),
          (D = function (t, e, i, n) {
            t instanceof g && (t = t._wrapped),
              e instanceof g && (e = e._wrapped);
            var o = u.call(t);
            if (o !== u.call(e)) return !1;
            switch (o) {
              case '[object RegExp]':
              case '[object String]':
                return '' + t == '' + e;
              case '[object Number]':
                return +t != +t
                  ? +e != +e
                  : 0 == +t
                  ? 1 / +t == 1 / e
                  : +t == +e;
              case '[object Date]':
              case '[object Boolean]':
                return +t == +e;
              case '[object Symbol]':
                return l.valueOf.call(t) === l.valueOf.call(e);
            }
            var s = '[object Array]' === o;
            if (!s) {
              if ('object' != typeof t || 'object' != typeof e) return !1;
              var r = t.constructor,
                a = e.constructor;
              if (
                r !== a &&
                !(
                  g.isFunction(r) &&
                  r instanceof r &&
                  g.isFunction(a) &&
                  a instanceof a
                ) &&
                'constructor' in t &&
                'constructor' in e
              )
                return !1;
            }
            n = n || [];
            for (var c = (i = i || []).length; c--; )
              if (i[c] === t) return n[c] === e;
            if ((i.push(t), n.push(e), s)) {
              if ((c = t.length) !== e.length) return !1;
              for (; c--; ) if (!R(t[c], e[c], i, n)) return !1;
            } else {
              var d,
                h = g.keys(t);
              if (((c = h.length), g.keys(e).length !== c)) return !1;
              for (; c--; )
                if (((d = h[c]), !C(e, d) || !R(t[d], e[d], i, n))) return !1;
            }
            return i.pop(), n.pop(), !0;
          }),
          (g.isEqual = function (t, e) {
            return R(t, e);
          }),
          (g.isEmpty = function (t) {
            return (
              null == t ||
              (_(t) && (g.isArray(t) || g.isString(t) || g.isArguments(t))
                ? 0 === t.length
                : 0 === g.keys(t).length)
            );
          }),
          (g.isElement = function (t) {
            return !(!t || 1 !== t.nodeType);
          }),
          (g.isArray =
            p ||
            function (t) {
              return '[object Array]' === u.call(t);
            }),
          (g.isObject = function (t) {
            var e = typeof t;
            return 'function' === e || ('object' === e && !!t);
          }),
          g.each(
            [
              'Arguments',
              'Function',
              'String',
              'Number',
              'Date',
              'RegExp',
              'Error',
              'Symbol',
              'Map',
              'WeakMap',
              'Set',
              'WeakSet',
            ],
            function (t) {
              g['is' + t] = function (e) {
                return u.call(e) === '[object ' + t + ']';
              };
            }
          ),
          g.isArguments(arguments) ||
            (g.isArguments = function (t) {
              return C(t, 'callee');
            });
        var U = o.document && o.document.childNodes;
        'object' != typeof Int8Array &&
          'function' != typeof U &&
          (g.isFunction = function (t) {
            return 'function' == typeof t || !1;
          }),
          (g.isFinite = function (t) {
            return !g.isSymbol(t) && isFinite(t) && !isNaN(parseFloat(t));
          }),
          (g.isNaN = function (t) {
            return g.isNumber(t) && isNaN(t);
          }),
          (g.isBoolean = function (t) {
            return !0 === t || !1 === t || '[object Boolean]' === u.call(t);
          }),
          (g.isNull = function (t) {
            return null === t;
          }),
          (g.isUndefined = function (t) {
            return void 0 === t;
          }),
          (g.has = function (t, e) {
            if (!g.isArray(e)) return C(t, e);
            for (var i = e.length, n = 0; n < i; n++) {
              var o = e[n];
              if (null == t || !h.call(t, o)) return !1;
              t = t[o];
            }
            return !!i;
          }),
          (g.noConflict = function () {
            return (o._ = s), this;
          }),
          (g.identity = function (t) {
            return t;
          }),
          (g.constant = function (t) {
            return function () {
              return t;
            };
          }),
          (g.noop = function () {}),
          (g.property = function (t) {
            return g.isArray(t)
              ? function (e) {
                  return T(e, t);
                }
              : S(t);
          }),
          (g.propertyOf = function (t) {
            return null == t
              ? function () {}
              : function (e) {
                  return g.isArray(e) ? T(t, e) : t[e];
                };
          }),
          (g.matcher = g.matches =
            function (t) {
              return (
                (t = g.extendOwn({}, t)),
                function (e) {
                  return g.isMatch(e, t);
                }
              );
            }),
          (g.times = function (t, e, i) {
            var n = Array(Math.max(0, t));
            e = w(e, i, 1);
            for (var o = 0; o < t; o++) n[o] = e(o);
            return n;
          }),
          (g.random = function (t, e) {
            return (
              null == e && ((e = t), (t = 0)),
              t + Math.floor(Math.random() * (e - t + 1))
            );
          }),
          (g.now =
            Date.now ||
            function () {
              return new Date().getTime();
            });
        var B = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '`': '&#x60;',
          },
          q = g.invert(B),
          V = function (t) {
            var e = function (e) {
                return t[e];
              },
              i = '(?:' + g.keys(t).join('|') + ')',
              n = RegExp(i),
              o = RegExp(i, 'g');
            return function (t) {
              return (
                (t = null == t ? '' : '' + t), n.test(t) ? t.replace(o, e) : t
              );
            };
          };
        (g.escape = V(B)),
          (g.unescape = V(q)),
          (g.result = function (t, e, i) {
            g.isArray(e) || (e = [e]);
            var n = e.length;
            if (!n) return g.isFunction(i) ? i.call(t) : i;
            for (var o = 0; o < n; o++) {
              var s = null == t ? void 0 : t[e[o]];
              void 0 === s && ((s = i), (o = n)),
                (t = g.isFunction(s) ? s.call(t) : s);
            }
            return t;
          });
        var J = 0;
        (g.uniqueId = function (t) {
          var e = ++J + '';
          return t ? t + e : e;
        }),
          (g.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g,
          });
        var X = /(.)^/,
          Y = {
            "'": "'",
            '\\': '\\',
            '\r': 'r',
            '\n': 'n',
            '\u2028': 'u2028',
            '\u2029': 'u2029',
          },
          G = /\\|'|\r|\n|\u2028|\u2029/g,
          Q = function (t) {
            return '\\' + Y[t];
          };
        (g.template = function (t, e, i) {
          !e && i && (e = i), (e = g.defaults({}, e, g.templateSettings));
          var n,
            o = RegExp(
              [
                (e.escape || X).source,
                (e.interpolate || X).source,
                (e.evaluate || X).source,
              ].join('|') + '|$',
              'g'
            ),
            s = 0,
            r = "__p+='";
          t.replace(o, function (e, i, n, o, a) {
            return (
              (r += t.slice(s, a).replace(G, Q)),
              (s = a + e.length),
              i
                ? (r += "'+\n((__t=(" + i + "))==null?'':_.escape(__t))+\n'")
                : n
                ? (r += "'+\n((__t=(" + n + "))==null?'':__t)+\n'")
                : o && (r += "';\n" + o + "\n__p+='"),
              e
            );
          }),
            (r += "';\n"),
            e.variable || (r = 'with(obj||{}){\n' + r + '}\n'),
            (r =
              "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" +
              r +
              'return __p;\n');
          try {
            n = new Function(e.variable || 'obj', '_', r);
          } catch (t) {
            throw ((t.source = r), t);
          }
          var a = function (t) {
              return n.call(this, t, g);
            },
            l = e.variable || 'obj';
          return (a.source = 'function(' + l + '){\n' + r + '}'), a;
        }),
          (g.chain = function (t) {
            var e = g(t);
            return (e._chain = !0), e;
          });
        var Z = function (t, e) {
          return t._chain ? g(e).chain() : e;
        };
        (g.mixin = function (t) {
          return (
            g.each(g.functions(t), function (e) {
              var i = (g[e] = t[e]);
              g.prototype[e] = function () {
                var t = [this._wrapped];
                return c.apply(t, arguments), Z(this, i.apply(g, t));
              };
            }),
            g
          );
        }),
          g.mixin(g),
          g.each(
            ['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'],
            function (t) {
              var e = r[t];
              g.prototype[t] = function () {
                var i = this._wrapped;
                return (
                  e.apply(i, arguments),
                  ('shift' !== t && 'splice' !== t) ||
                    0 !== i.length ||
                    delete i[0],
                  Z(this, i)
                );
              };
            }
          ),
          g.each(['concat', 'join', 'slice'], function (t) {
            var e = r[t];
            g.prototype[t] = function () {
              return Z(this, e.apply(this._wrapped, arguments));
            };
          }),
          (g.prototype.value = function () {
            return this._wrapped;
          }),
          (g.prototype.valueOf = g.prototype.toJSON = g.prototype.value),
          (g.prototype.toString = function () {
            return String(this._wrapped);
          }),
          void 0 ===
            (n = function () {
              return g;
            }.apply(e, [])) || (i.exports = n);
      })();
    }.call(this, i(6), i(9)(t)));
  },
  function (t, e, i) {
    (function (n) {
      var o, s, r;
      (r =
        ('object' == typeof self && self.self === self && self) ||
        ('object' == typeof n && n.global === n && n)),
        (o = [i(1), i(0), e]),
        void 0 ===
          (s = function (t, e, i) {
            r.Backbone = (function (t, e, i, n) {
              var o = t.Backbone,
                s = Array.prototype.slice;
              (e.VERSION = '1.4.0'),
                (e.$ = n),
                (e.noConflict = function () {
                  return (t.Backbone = o), this;
                }),
                (e.emulateHTTP = !1),
                (e.emulateJSON = !1);
              var r,
                a = (e.Events = {}),
                l = /\s+/,
                c = function (t, e, n, o, s) {
                  var r,
                    a = 0;
                  if (n && 'object' == typeof n) {
                    void 0 !== o &&
                      'context' in s &&
                      void 0 === s.context &&
                      (s.context = o);
                    for (r = i.keys(n); a < r.length; a++)
                      e = c(t, e, r[a], n[r[a]], s);
                  } else if (n && l.test(n))
                    for (r = n.split(l); a < r.length; a++)
                      e = t(e, r[a], o, s);
                  else e = t(e, n, o, s);
                  return e;
                };
              (a.on = function (t, e, i) {
                return (
                  (this._events = c(d, this._events || {}, t, e, {
                    context: i,
                    ctx: this,
                    listening: r,
                  })),
                  r &&
                    (((this._listeners || (this._listeners = {}))[r.id] = r),
                    (r.interop = !1)),
                  this
                );
              }),
                (a.listenTo = function (t, e, n) {
                  if (!t) return this;
                  var o = t._listenId || (t._listenId = i.uniqueId('l')),
                    s = this._listeningTo || (this._listeningTo = {}),
                    a = (r = s[o]);
                  a ||
                    (this._listenId || (this._listenId = i.uniqueId('l')),
                    (a = r = s[o] = new m(this, t)));
                  var l = u(t, e, n, this);
                  if (((r = void 0), l)) throw l;
                  return a.interop && a.on(e, n), this;
                });
              var d = function (t, e, i, n) {
                  if (i) {
                    var o = t[e] || (t[e] = []),
                      s = n.context,
                      r = n.ctx,
                      a = n.listening;
                    a && a.count++,
                      o.push({
                        callback: i,
                        context: s,
                        ctx: s || r,
                        listening: a,
                      });
                  }
                  return t;
                },
                u = function (t, e, i, n) {
                  try {
                    t.on(e, i, n);
                  } catch (t) {
                    return t;
                  }
                };
              (a.off = function (t, e, i) {
                return this._events
                  ? ((this._events = c(h, this._events, t, e, {
                      context: i,
                      listeners: this._listeners,
                    })),
                    this)
                  : this;
              }),
                (a.stopListening = function (t, e, n) {
                  var o = this._listeningTo;
                  if (!o) return this;
                  for (
                    var s = t ? [t._listenId] : i.keys(o), r = 0;
                    r < s.length;
                    r++
                  ) {
                    var a = o[s[r]];
                    if (!a) break;
                    a.obj.off(e, n, this), a.interop && a.off(e, n);
                  }
                  return i.isEmpty(o) && (this._listeningTo = void 0), this;
                });
              var h = function (t, e, n, o) {
                if (t) {
                  var s,
                    r = o.context,
                    a = o.listeners,
                    l = 0;
                  if (e || r || n) {
                    for (s = e ? [e] : i.keys(t); l < s.length; l++) {
                      var c = t[(e = s[l])];
                      if (!c) break;
                      for (var d = [], u = 0; u < c.length; u++) {
                        var h = c[u];
                        if (
                          (n &&
                            n !== h.callback &&
                            n !== h.callback._callback) ||
                          (r && r !== h.context)
                        )
                          d.push(h);
                        else {
                          var p = h.listening;
                          p && p.off(e, n);
                        }
                      }
                      d.length ? (t[e] = d) : delete t[e];
                    }
                    return t;
                  }
                  for (s = i.keys(a); l < s.length; l++) a[s[l]].cleanup();
                }
              };
              (a.once = function (t, e, i) {
                var n = c(p, {}, t, e, this.off.bind(this));
                return (
                  'string' == typeof t && null == i && (e = void 0),
                  this.on(n, e, i)
                );
              }),
                (a.listenToOnce = function (t, e, i) {
                  var n = c(p, {}, e, i, this.stopListening.bind(this, t));
                  return this.listenTo(t, n);
                });
              var p = function (t, e, n, o) {
                if (n) {
                  var s = (t[e] = i.once(function () {
                    o(e, s), n.apply(this, arguments);
                  }));
                  s._callback = n;
                }
                return t;
              };
              a.trigger = function (t) {
                if (!this._events) return this;
                for (
                  var e = Math.max(0, arguments.length - 1),
                    i = Array(e),
                    n = 0;
                  n < e;
                  n++
                )
                  i[n] = arguments[n + 1];
                return c(f, this._events, t, void 0, i), this;
              };
              var f = function (t, e, i, n) {
                  if (t) {
                    var o = t[e],
                      s = t.all;
                    o && s && (s = s.slice()),
                      o && v(o, n),
                      s && v(s, [e].concat(n));
                  }
                  return t;
                },
                v = function (t, e) {
                  var i,
                    n = -1,
                    o = t.length,
                    s = e[0],
                    r = e[1],
                    a = e[2];
                  switch (e.length) {
                    case 0:
                      for (; ++n < o; ) (i = t[n]).callback.call(i.ctx);
                      return;
                    case 1:
                      for (; ++n < o; ) (i = t[n]).callback.call(i.ctx, s);
                      return;
                    case 2:
                      for (; ++n < o; ) (i = t[n]).callback.call(i.ctx, s, r);
                      return;
                    case 3:
                      for (; ++n < o; )
                        (i = t[n]).callback.call(i.ctx, s, r, a);
                      return;
                    default:
                      for (; ++n < o; ) (i = t[n]).callback.apply(i.ctx, e);
                      return;
                  }
                },
                m = function (t, e) {
                  (this.id = t._listenId),
                    (this.listener = t),
                    (this.obj = e),
                    (this.interop = !0),
                    (this.count = 0),
                    (this._events = void 0);
                };
              (m.prototype.on = a.on),
                (m.prototype.off = function (t, e) {
                  var i;
                  this.interop
                    ? ((this._events = c(h, this._events, t, e, {
                        context: void 0,
                        listeners: void 0,
                      })),
                      (i = !this._events))
                    : (this.count--, (i = 0 === this.count)),
                    i && this.cleanup();
                }),
                (m.prototype.cleanup = function () {
                  delete this.listener._listeningTo[this.obj._listenId],
                    this.interop || delete this.obj._listeners[this.id];
                }),
                (a.bind = a.on),
                (a.unbind = a.off),
                i.extend(e, a);
              var g = (e.Model = function (t, e) {
                var n = t || {};
                e || (e = {}),
                  this.preinitialize.apply(this, arguments),
                  (this.cid = i.uniqueId(this.cidPrefix)),
                  (this.attributes = {}),
                  e.collection && (this.collection = e.collection),
                  e.parse && (n = this.parse(n, e) || {});
                var o = i.result(this, 'defaults');
                (n = i.defaults(i.extend({}, o, n), o)),
                  this.set(n, e),
                  (this.changed = {}),
                  this.initialize.apply(this, arguments);
              });
              i.extend(g.prototype, a, {
                changed: null,
                validationError: null,
                idAttribute: 'id',
                cidPrefix: 'c',
                preinitialize: function () {},
                initialize: function () {},
                toJSON: function (t) {
                  return i.clone(this.attributes);
                },
                sync: function () {
                  return e.sync.apply(this, arguments);
                },
                get: function (t) {
                  return this.attributes[t];
                },
                escape: function (t) {
                  return i.escape(this.get(t));
                },
                has: function (t) {
                  return null != this.get(t);
                },
                matches: function (t) {
                  return !!i.iteratee(t, this)(this.attributes);
                },
                set: function (t, e, n) {
                  if (null == t) return this;
                  var o;
                  if (
                    ('object' == typeof t
                      ? ((o = t), (n = e))
                      : ((o = {})[t] = e),
                    n || (n = {}),
                    !this._validate(o, n))
                  )
                    return !1;
                  var s = n.unset,
                    r = n.silent,
                    a = [],
                    l = this._changing;
                  (this._changing = !0),
                    l ||
                      ((this._previousAttributes = i.clone(this.attributes)),
                      (this.changed = {}));
                  var c = this.attributes,
                    d = this.changed,
                    u = this._previousAttributes;
                  for (var h in o)
                    (e = o[h]),
                      i.isEqual(c[h], e) || a.push(h),
                      i.isEqual(u[h], e) ? delete d[h] : (d[h] = e),
                      s ? delete c[h] : (c[h] = e);
                  if (
                    (this.idAttribute in o &&
                      (this.id = this.get(this.idAttribute)),
                    !r)
                  ) {
                    a.length && (this._pending = n);
                    for (var p = 0; p < a.length; p++)
                      this.trigger('change:' + a[p], this, c[a[p]], n);
                  }
                  if (l) return this;
                  if (!r)
                    for (; this._pending; )
                      (n = this._pending),
                        (this._pending = !1),
                        this.trigger('change', this, n);
                  return (this._pending = !1), (this._changing = !1), this;
                },
                unset: function (t, e) {
                  return this.set(
                    t,
                    void 0,
                    i.extend({}, e, {
                      unset: !0,
                    })
                  );
                },
                clear: function (t) {
                  var e = {};
                  for (var n in this.attributes) e[n] = void 0;
                  return this.set(
                    e,
                    i.extend({}, t, {
                      unset: !0,
                    })
                  );
                },
                hasChanged: function (t) {
                  return null == t
                    ? !i.isEmpty(this.changed)
                    : i.has(this.changed, t);
                },
                changedAttributes: function (t) {
                  if (!t) return !!this.hasChanged() && i.clone(this.changed);
                  var e,
                    n = this._changing
                      ? this._previousAttributes
                      : this.attributes,
                    o = {};
                  for (var s in t) {
                    var r = t[s];
                    i.isEqual(n[s], r) || ((o[s] = r), (e = !0));
                  }
                  return !!e && o;
                },
                previous: function (t) {
                  return null != t && this._previousAttributes
                    ? this._previousAttributes[t]
                    : null;
                },
                previousAttributes: function () {
                  return i.clone(this._previousAttributes);
                },
                fetch: function (t) {
                  t = i.extend(
                    {
                      parse: !0,
                    },
                    t
                  );
                  var e = this,
                    n = t.success;
                  return (
                    (t.success = function (i) {
                      var o = t.parse ? e.parse(i, t) : i;
                      if (!e.set(o, t)) return !1;
                      n && n.call(t.context, e, i, t),
                        e.trigger('sync', e, i, t);
                    }),
                    B(this, t),
                    this.sync('read', this, t)
                  );
                },
                save: function (t, e, n) {
                  var o;
                  null == t || 'object' == typeof t
                    ? ((o = t), (n = e))
                    : ((o = {})[t] = e);
                  var s = (n = i.extend(
                    {
                      validate: !0,
                      parse: !0,
                    },
                    n
                  )).wait;
                  if (o && !s) {
                    if (!this.set(o, n)) return !1;
                  } else if (!this._validate(o, n)) return !1;
                  var r = this,
                    a = n.success,
                    l = this.attributes;
                  (n.success = function (t) {
                    r.attributes = l;
                    var e = n.parse ? r.parse(t, n) : t;
                    if ((s && (e = i.extend({}, o, e)), e && !r.set(e, n)))
                      return !1;
                    a && a.call(n.context, r, t, n), r.trigger('sync', r, t, n);
                  }),
                    B(this, n),
                    o && s && (this.attributes = i.extend({}, l, o));
                  var c = this.isNew()
                    ? 'create'
                    : n.patch
                    ? 'patch'
                    : 'update';
                  'patch' !== c || n.attrs || (n.attrs = o);
                  var d = this.sync(c, this, n);
                  return (this.attributes = l), d;
                },
                destroy: function (t) {
                  t = t ? i.clone(t) : {};
                  var e = this,
                    n = t.success,
                    o = t.wait,
                    s = function () {
                      e.stopListening(),
                        e.trigger('destroy', e, e.collection, t);
                    };
                  t.success = function (i) {
                    o && s(t),
                      n && n.call(t.context, e, i, t),
                      e.isNew() || e.trigger('sync', e, i, t);
                  };
                  var r = !1;
                  return (
                    this.isNew()
                      ? i.defer(t.success)
                      : (B(this, t), (r = this.sync('delete', this, t))),
                    o || s(t),
                    r
                  );
                },
                url: function () {
                  var t =
                    i.result(this, 'urlRoot') ||
                    i.result(this.collection, 'url') ||
                    U();
                  if (this.isNew()) return t;
                  var e = this.get(this.idAttribute);
                  return t.replace(/[^\/]$/, '$&/') + encodeURIComponent(e);
                },
                parse: function (t, e) {
                  return t;
                },
                clone: function () {
                  return new this.constructor(this.attributes);
                },
                isNew: function () {
                  return !this.has(this.idAttribute);
                },
                isValid: function (t) {
                  return this._validate(
                    {},
                    i.extend({}, t, {
                      validate: !0,
                    })
                  );
                },
                _validate: function (t, e) {
                  if (!e.validate || !this.validate) return !0;
                  t = i.extend({}, this.attributes, t);
                  var n = (this.validationError = this.validate(t, e) || null);
                  return (
                    !n ||
                    (this.trigger(
                      'invalid',
                      this,
                      n,
                      i.extend(e, {
                        validationError: n,
                      })
                    ),
                    !1)
                  );
                },
              });
              var y = (e.Collection = function (t, e) {
                  e || (e = {}),
                    this.preinitialize.apply(this, arguments),
                    e.model && (this.model = e.model),
                    void 0 !== e.comparator && (this.comparator = e.comparator),
                    this._reset(),
                    this.initialize.apply(this, arguments),
                    t &&
                      this.reset(
                        t,
                        i.extend(
                          {
                            silent: !0,
                          },
                          e
                        )
                      );
                }),
                w = {
                  add: !0,
                  remove: !0,
                  merge: !0,
                },
                b = {
                  add: !0,
                  remove: !1,
                },
                $ = function (t, e, i) {
                  i = Math.min(Math.max(i, 0), t.length);
                  var n,
                    o = Array(t.length - i),
                    s = e.length;
                  for (n = 0; n < o.length; n++) o[n] = t[n + i];
                  for (n = 0; n < s; n++) t[n + i] = e[n];
                  for (n = 0; n < o.length; n++) t[n + s + i] = o[n];
                };
              i.extend(y.prototype, a, {
                model: g,
                preinitialize: function () {},
                initialize: function () {},
                toJSON: function (t) {
                  return this.map(function (e) {
                    return e.toJSON(t);
                  });
                },
                sync: function () {
                  return e.sync.apply(this, arguments);
                },
                add: function (t, e) {
                  return this.set(
                    t,
                    i.extend(
                      {
                        merge: !1,
                      },
                      e,
                      b
                    )
                  );
                },
                remove: function (t, e) {
                  e = i.extend({}, e);
                  var n = !i.isArray(t);
                  t = n ? [t] : t.slice();
                  var o = this._removeModels(t, e);
                  return (
                    !e.silent &&
                      o.length &&
                      ((e.changes = {
                        added: [],
                        merged: [],
                        removed: o,
                      }),
                      this.trigger('update', this, e)),
                    n ? o[0] : o
                  );
                },
                set: function (t, e) {
                  if (null != t) {
                    (e = i.extend({}, w, e)).parse &&
                      !this._isModel(t) &&
                      (t = this.parse(t, e) || []);
                    var n = !i.isArray(t);
                    t = n ? [t] : t.slice();
                    var o = e.at;
                    null != o && (o = +o),
                      o > this.length && (o = this.length),
                      o < 0 && (o += this.length + 1);
                    var s,
                      r,
                      a = [],
                      l = [],
                      c = [],
                      d = [],
                      u = {},
                      h = e.add,
                      p = e.merge,
                      f = e.remove,
                      v = !1,
                      m = this.comparator && null == o && !1 !== e.sort,
                      g = i.isString(this.comparator) ? this.comparator : null;
                    for (r = 0; r < t.length; r++) {
                      s = t[r];
                      var y = this.get(s);
                      if (y) {
                        if (p && s !== y) {
                          var b = this._isModel(s) ? s.attributes : s;
                          e.parse && (b = y.parse(b, e)),
                            y.set(b, e),
                            c.push(y),
                            m && !v && (v = y.hasChanged(g));
                        }
                        u[y.cid] || ((u[y.cid] = !0), a.push(y)), (t[r] = y);
                      } else
                        h &&
                          (s = t[r] = this._prepareModel(s, e)) &&
                          (l.push(s),
                          this._addReference(s, e),
                          (u[s.cid] = !0),
                          a.push(s));
                    }
                    if (f) {
                      for (r = 0; r < this.length; r++)
                        u[(s = this.models[r]).cid] || d.push(s);
                      d.length && this._removeModels(d, e);
                    }
                    var k = !1,
                      S = !m && h && f;
                    if (
                      (a.length && S
                        ? ((k =
                            this.length !== a.length ||
                            i.some(this.models, function (t, e) {
                              return t !== a[e];
                            })),
                          (this.models.length = 0),
                          $(this.models, a, 0),
                          (this.length = this.models.length))
                        : l.length &&
                          (m && (v = !0),
                          $(this.models, l, null == o ? this.length : o),
                          (this.length = this.models.length)),
                      v &&
                        this.sort({
                          silent: !0,
                        }),
                      !e.silent)
                    ) {
                      for (r = 0; r < l.length; r++)
                        null != o && (e.index = o + r),
                          (s = l[r]).trigger('add', s, this, e);
                      (v || k) && this.trigger('sort', this, e),
                        (l.length || d.length || c.length) &&
                          ((e.changes = {
                            added: l,
                            removed: d,
                            merged: c,
                          }),
                          this.trigger('update', this, e));
                    }
                    return n ? t[0] : t;
                  }
                },
                reset: function (t, e) {
                  e = e ? i.clone(e) : {};
                  for (var n = 0; n < this.models.length; n++)
                    this._removeReference(this.models[n], e);
                  return (
                    (e.previousModels = this.models),
                    this._reset(),
                    (t = this.add(
                      t,
                      i.extend(
                        {
                          silent: !0,
                        },
                        e
                      )
                    )),
                    e.silent || this.trigger('reset', this, e),
                    t
                  );
                },
                push: function (t, e) {
                  return this.add(
                    t,
                    i.extend(
                      {
                        at: this.length,
                      },
                      e
                    )
                  );
                },
                pop: function (t) {
                  var e = this.at(this.length - 1);
                  return this.remove(e, t);
                },
                unshift: function (t, e) {
                  return this.add(
                    t,
                    i.extend(
                      {
                        at: 0,
                      },
                      e
                    )
                  );
                },
                shift: function (t) {
                  var e = this.at(0);
                  return this.remove(e, t);
                },
                slice: function () {
                  return s.apply(this.models, arguments);
                },
                get: function (t) {
                  if (null != t)
                    return (
                      this._byId[t] ||
                      this._byId[
                        this.modelId(this._isModel(t) ? t.attributes : t)
                      ] ||
                      (t.cid && this._byId[t.cid])
                    );
                },
                has: function (t) {
                  return null != this.get(t);
                },
                at: function (t) {
                  return t < 0 && (t += this.length), this.models[t];
                },
                where: function (t, e) {
                  return this[e ? 'find' : 'filter'](t);
                },
                findWhere: function (t) {
                  return this.where(t, !0);
                },
                sort: function (t) {
                  var e = this.comparator;
                  if (!e)
                    throw new Error('Cannot sort a set without a comparator');
                  t || (t = {});
                  var n = e.length;
                  return (
                    i.isFunction(e) && (e = e.bind(this)),
                    1 === n || i.isString(e)
                      ? (this.models = this.sortBy(e))
                      : this.models.sort(e),
                    t.silent || this.trigger('sort', this, t),
                    this
                  );
                },
                pluck: function (t) {
                  return this.map(t + '');
                },
                fetch: function (t) {
                  var e = (t = i.extend(
                      {
                        parse: !0,
                      },
                      t
                    )).success,
                    n = this;
                  return (
                    (t.success = function (i) {
                      var o = t.reset ? 'reset' : 'set';
                      n[o](i, t),
                        e && e.call(t.context, n, i, t),
                        n.trigger('sync', n, i, t);
                    }),
                    B(this, t),
                    this.sync('read', this, t)
                  );
                },
                create: function (t, e) {
                  var n = (e = e ? i.clone(e) : {}).wait;
                  if (!(t = this._prepareModel(t, e))) return !1;
                  n || this.add(t, e);
                  var o = this,
                    s = e.success;
                  return (
                    (e.success = function (t, e, i) {
                      n && o.add(t, i), s && s.call(i.context, t, e, i);
                    }),
                    t.save(null, e),
                    t
                  );
                },
                parse: function (t, e) {
                  return t;
                },
                clone: function () {
                  return new this.constructor(this.models, {
                    model: this.model,
                    comparator: this.comparator,
                  });
                },
                modelId: function (t) {
                  return t[this.model.prototype.idAttribute || 'id'];
                },
                values: function () {
                  return new S(this, C);
                },
                keys: function () {
                  return new S(this, T);
                },
                entries: function () {
                  return new S(this, x);
                },
                _reset: function () {
                  (this.length = 0), (this.models = []), (this._byId = {});
                },
                _prepareModel: function (t, e) {
                  if (this._isModel(t))
                    return t.collection || (t.collection = this), t;
                  (e = e ? i.clone(e) : {}).collection = this;
                  var n = new this.model(t, e);
                  return n.validationError
                    ? (this.trigger('invalid', this, n.validationError, e), !1)
                    : n;
                },
                _removeModels: function (t, e) {
                  for (var i = [], n = 0; n < t.length; n++) {
                    var o = this.get(t[n]);
                    if (o) {
                      var s = this.indexOf(o);
                      this.models.splice(s, 1),
                        this.length--,
                        delete this._byId[o.cid];
                      var r = this.modelId(o.attributes);
                      null != r && delete this._byId[r],
                        e.silent ||
                          ((e.index = s), o.trigger('remove', o, this, e)),
                        i.push(o),
                        this._removeReference(o, e);
                    }
                  }
                  return i;
                },
                _isModel: function (t) {
                  return t instanceof g;
                },
                _addReference: function (t, e) {
                  this._byId[t.cid] = t;
                  var i = this.modelId(t.attributes);
                  null != i && (this._byId[i] = t),
                    t.on('all', this._onModelEvent, this);
                },
                _removeReference: function (t, e) {
                  delete this._byId[t.cid];
                  var i = this.modelId(t.attributes);
                  null != i && delete this._byId[i],
                    this === t.collection && delete t.collection,
                    t.off('all', this._onModelEvent, this);
                },
                _onModelEvent: function (t, e, i, n) {
                  if (e) {
                    if (('add' === t || 'remove' === t) && i !== this) return;
                    if (
                      ('destroy' === t && this.remove(e, n), 'change' === t)
                    ) {
                      var o = this.modelId(e.previousAttributes()),
                        s = this.modelId(e.attributes);
                      o !== s &&
                        (null != o && delete this._byId[o],
                        null != s && (this._byId[s] = e));
                    }
                  }
                  this.trigger.apply(this, arguments);
                },
              });
              var k = 'function' == typeof Symbol && Symbol.iterator;
              k && (y.prototype[k] = y.prototype.values);
              var S = function (t, e) {
                  (this._collection = t), (this._kind = e), (this._index = 0);
                },
                C = 1,
                T = 2,
                x = 3;
              k &&
                (S.prototype[k] = function () {
                  return this;
                }),
                (S.prototype.next = function () {
                  if (this._collection) {
                    if (this._index < this._collection.length) {
                      var t,
                        e = this._collection.at(this._index);
                      if ((this._index++, this._kind === C)) t = e;
                      else {
                        var i = this._collection.modelId(e.attributes);
                        t = this._kind === T ? i : [i, e];
                      }
                      return {
                        value: t,
                        done: !1,
                      };
                    }
                    this._collection = void 0;
                  }
                  return {
                    value: void 0,
                    done: !0,
                  };
                });
              var O = (e.View = function (t) {
                  (this.cid = i.uniqueId('view')),
                    this.preinitialize.apply(this, arguments),
                    i.extend(this, i.pick(t, I)),
                    this._ensureElement(),
                    this.initialize.apply(this, arguments);
                }),
                _ = /^(\S+)\s*(.*)$/,
                I = [
                  'model',
                  'collection',
                  'el',
                  'id',
                  'attributes',
                  'className',
                  'tagName',
                  'events',
                ];
              i.extend(O.prototype, a, {
                tagName: 'div',
                $: function (t) {
                  return this.$el.find(t);
                },
                preinitialize: function () {},
                initialize: function () {},
                render: function () {
                  return this;
                },
                remove: function () {
                  return this._removeElement(), this.stopListening(), this;
                },
                _removeElement: function () {
                  this.$el.remove();
                },
                setElement: function (t) {
                  return (
                    this.undelegateEvents(),
                    this._setElement(t),
                    this.delegateEvents(),
                    this
                  );
                },
                _setElement: function (t) {
                  (this.$el = t instanceof e.$ ? t : e.$(t)),
                    (this.el = this.$el[0]);
                },
                delegateEvents: function (t) {
                  if ((t || (t = i.result(this, 'events')), !t)) return this;
                  for (var e in (this.undelegateEvents(), t)) {
                    var n = t[e];
                    if ((i.isFunction(n) || (n = this[n]), n)) {
                      var o = e.match(_);
                      this.delegate(o[1], o[2], n.bind(this));
                    }
                  }
                  return this;
                },
                delegate: function (t, e, i) {
                  return (
                    this.$el.on(t + '.delegateEvents' + this.cid, e, i), this
                  );
                },
                undelegateEvents: function () {
                  return (
                    this.$el && this.$el.off('.delegateEvents' + this.cid), this
                  );
                },
                undelegate: function (t, e, i) {
                  return (
                    this.$el.off(t + '.delegateEvents' + this.cid, e, i), this
                  );
                },
                _createElement: function (t) {
                  return document.createElement(t);
                },
                _ensureElement: function () {
                  if (this.el) this.setElement(i.result(this, 'el'));
                  else {
                    var t = i.extend({}, i.result(this, 'attributes'));
                    this.id && (t.id = i.result(this, 'id')),
                      this.className && (t.class = i.result(this, 'className')),
                      this.setElement(
                        this._createElement(i.result(this, 'tagName'))
                      ),
                      this._setAttributes(t);
                  }
                },
                _setAttributes: function (t) {
                  this.$el.attr(t);
                },
              });
              var z = function (t, e, n, o) {
                  i.each(n, function (i, n) {
                    e[n] &&
                      (t.prototype[n] = (function (t, e, i, n) {
                        switch (e) {
                          case 1:
                            return function () {
                              return t[i](this[n]);
                            };
                          case 2:
                            return function (e) {
                              return t[i](this[n], e);
                            };
                          case 3:
                            return function (e, o) {
                              return t[i](this[n], A(e, this), o);
                            };
                          case 4:
                            return function (e, o, s) {
                              return t[i](this[n], A(e, this), o, s);
                            };
                          default:
                            return function () {
                              var e = s.call(arguments);
                              return e.unshift(this[n]), t[i].apply(t, e);
                            };
                        }
                      })(e, i, n, o));
                  });
                },
                A = function (t, e) {
                  return i.isFunction(t)
                    ? t
                    : i.isObject(t) && !e._isModel(t)
                    ? M(t)
                    : i.isString(t)
                    ? function (e) {
                        return e.get(t);
                      }
                    : t;
                },
                M = function (t) {
                  var e = i.matches(t);
                  return function (t) {
                    return e(t.attributes);
                  };
                };
              i.each(
                [
                  [
                    y,
                    {
                      forEach: 3,
                      each: 3,
                      map: 3,
                      collect: 3,
                      reduce: 0,
                      foldl: 0,
                      inject: 0,
                      reduceRight: 0,
                      foldr: 0,
                      find: 3,
                      detect: 3,
                      filter: 3,
                      select: 3,
                      reject: 3,
                      every: 3,
                      all: 3,
                      some: 3,
                      any: 3,
                      include: 3,
                      includes: 3,
                      contains: 3,
                      invoke: 0,
                      max: 3,
                      min: 3,
                      toArray: 1,
                      size: 1,
                      first: 3,
                      head: 3,
                      take: 3,
                      initial: 3,
                      rest: 3,
                      tail: 3,
                      drop: 3,
                      last: 3,
                      without: 0,
                      difference: 0,
                      indexOf: 3,
                      shuffle: 1,
                      lastIndexOf: 3,
                      isEmpty: 1,
                      chain: 1,
                      sample: 3,
                      partition: 3,
                      groupBy: 3,
                      countBy: 3,
                      sortBy: 3,
                      indexBy: 3,
                      findIndex: 3,
                      findLastIndex: 3,
                    },
                    'models',
                  ],
                  [
                    g,
                    {
                      keys: 1,
                      values: 1,
                      pairs: 1,
                      invert: 1,
                      pick: 0,
                      omit: 0,
                      chain: 1,
                      isEmpty: 1,
                    },
                    'attributes',
                  ],
                ],
                function (t) {
                  var e = t[0],
                    n = t[1],
                    o = t[2];
                  (e.mixin = function (t) {
                    var n = i.reduce(
                      i.functions(t),
                      function (t, e) {
                        return (t[e] = 0), t;
                      },
                      {}
                    );
                    z(e, t, n, o);
                  }),
                    z(e, i, n, o);
                }
              ),
                (e.sync = function (t, n, o) {
                  var s = j[t];
                  i.defaults(o || (o = {}), {
                    emulateHTTP: e.emulateHTTP,
                    emulateJSON: e.emulateJSON,
                  });
                  var r = {
                    type: s,
                    dataType: 'json',
                  };
                  if (
                    (o.url || (r.url = i.result(n, 'url') || U()),
                    null != o.data ||
                      !n ||
                      ('create' !== t && 'update' !== t && 'patch' !== t) ||
                      ((r.contentType = 'application/json'),
                      (r.data = JSON.stringify(o.attrs || n.toJSON(o)))),
                    o.emulateJSON &&
                      ((r.contentType = 'application/x-www-form-urlencoded'),
                      (r.data = r.data
                        ? {
                            model: r.data,
                          }
                        : {})),
                    o.emulateHTTP &&
                      ('PUT' === s || 'DELETE' === s || 'PATCH' === s))
                  ) {
                    (r.type = 'POST'), o.emulateJSON && (r.data._method = s);
                    var a = o.beforeSend;
                    o.beforeSend = function (t) {
                      if ((t.setRequestHeader('X-HTTP-Method-Override', s), a))
                        return a.apply(this, arguments);
                    };
                  }
                  'GET' === r.type || o.emulateJSON || (r.processData = !1);
                  var l = o.error;
                  o.error = function (t, e, i) {
                    (o.textStatus = e),
                      (o.errorThrown = i),
                      l && l.call(o.context, t, e, i);
                  };
                  var c = (o.xhr = e.ajax(i.extend(r, o)));
                  return n.trigger('request', n, c, o), c;
                });
              var j = {
                create: 'POST',
                update: 'PUT',
                patch: 'PATCH',
                delete: 'DELETE',
                read: 'GET',
              };
              e.ajax = function () {
                return e.$.ajax.apply(e.$, arguments);
              };
              var P = (e.Router = function (t) {
                  t || (t = {}),
                    this.preinitialize.apply(this, arguments),
                    t.routes && (this.routes = t.routes),
                    this._bindRoutes(),
                    this.initialize.apply(this, arguments);
                }),
                E = /\((.*?)\)/g,
                H = /(\(\?)?:\w+/g,
                F = /\*\w+/g,
                L = /[\-{}\[\]+?.,\\\^$|#\s]/g;
              i.extend(P.prototype, a, {
                preinitialize: function () {},
                initialize: function () {},
                route: function (t, n, o) {
                  i.isRegExp(t) || (t = this._routeToRegExp(t)),
                    i.isFunction(n) && ((o = n), (n = '')),
                    o || (o = this[n]);
                  var s = this;
                  return (
                    e.history.route(t, function (i) {
                      var r = s._extractParameters(t, i);
                      !1 !== s.execute(o, r, n) &&
                        (s.trigger.apply(s, ['route:' + n].concat(r)),
                        s.trigger('route', n, r),
                        e.history.trigger('route', s, n, r));
                    }),
                    this
                  );
                },
                execute: function (t, e, i) {
                  t && t.apply(this, e);
                },
                navigate: function (t, i) {
                  return e.history.navigate(t, i), this;
                },
                _bindRoutes: function () {
                  if (this.routes) {
                    this.routes = i.result(this, 'routes');
                    for (
                      var t, e = i.keys(this.routes);
                      null != (t = e.pop());

                    )
                      this.route(t, this.routes[t]);
                  }
                },
                _routeToRegExp: function (t) {
                  return (
                    (t = t
                      .replace(L, '\\$&')
                      .replace(E, '(?:$1)?')
                      .replace(H, function (t, e) {
                        return e ? t : '([^/?]+)';
                      })
                      .replace(F, '([^?]*?)')),
                    new RegExp('^' + t + '(?:\\?([\\s\\S]*))?$')
                  );
                },
                _extractParameters: function (t, e) {
                  var n = t.exec(e).slice(1);
                  return i.map(n, function (t, e) {
                    return e === n.length - 1
                      ? t || null
                      : t
                      ? decodeURIComponent(t)
                      : null;
                  });
                },
              });
              var N = (e.History = function () {
                  (this.handlers = []),
                    (this.checkUrl = this.checkUrl.bind(this)),
                    'undefined' != typeof window &&
                      ((this.location = window.location),
                      (this.history = window.history));
                }),
                R = /^[#\/]|\s+$/g,
                D = /^\/+|\/+$/g,
                W = /#.*$/;
              (N.started = !1),
                i.extend(N.prototype, a, {
                  interval: 50,
                  atRoot: function () {
                    return (
                      this.location.pathname.replace(/[^\/]$/, '$&/') ===
                        this.root && !this.getSearch()
                    );
                  },
                  matchRoot: function () {
                    return (
                      this.decodeFragment(this.location.pathname).slice(
                        0,
                        this.root.length - 1
                      ) +
                        '/' ===
                      this.root
                    );
                  },
                  decodeFragment: function (t) {
                    return decodeURI(t.replace(/%25/g, '%2525'));
                  },
                  getSearch: function () {
                    var t = this.location.href.replace(/#.*/, '').match(/\?.+/);
                    return t ? t[0] : '';
                  },
                  getHash: function (t) {
                    var e = (t || this).location.href.match(/#(.*)$/);
                    return e ? e[1] : '';
                  },
                  getPath: function () {
                    var t = this.decodeFragment(
                      this.location.pathname + this.getSearch()
                    ).slice(this.root.length - 1);
                    return '/' === t.charAt(0) ? t.slice(1) : t;
                  },
                  getFragment: function (t) {
                    return (
                      null == t &&
                        (t =
                          this._usePushState || !this._wantsHashChange
                            ? this.getPath()
                            : this.getHash()),
                      t.replace(R, '')
                    );
                  },
                  start: function (t) {
                    if (N.started)
                      throw new Error(
                        'Backbone.history has already been started'
                      );
                    if (
                      ((N.started = !0),
                      (this.options = i.extend(
                        {
                          root: '/',
                        },
                        this.options,
                        t
                      )),
                      (this.root = this.options.root),
                      (this._wantsHashChange = !1 !== this.options.hashChange),
                      (this._hasHashChange =
                        'onhashchange' in window &&
                        (void 0 === document.documentMode ||
                          document.documentMode > 7)),
                      (this._useHashChange =
                        this._wantsHashChange && this._hasHashChange),
                      (this._wantsPushState = !!this.options.pushState),
                      (this._hasPushState = !(
                        !this.history || !this.history.pushState
                      )),
                      (this._usePushState =
                        this._wantsPushState && this._hasPushState),
                      (this.fragment = this.getFragment()),
                      (this.root = ('/' + this.root + '/').replace(D, '/')),
                      this._wantsHashChange && this._wantsPushState)
                    ) {
                      if (!this._hasPushState && !this.atRoot()) {
                        var e = this.root.slice(0, -1) || '/';
                        return (
                          this.location.replace(e + '#' + this.getPath()), !0
                        );
                      }
                      this._hasPushState &&
                        this.atRoot() &&
                        this.navigate(this.getHash(), {
                          replace: !0,
                        });
                    }
                    if (
                      !this._hasHashChange &&
                      this._wantsHashChange &&
                      !this._usePushState
                    ) {
                      (this.iframe = document.createElement('iframe')),
                        (this.iframe.src = 'javascript:0'),
                        (this.iframe.style.display = 'none'),
                        (this.iframe.tabIndex = -1);
                      var n = document.body,
                        o = n.insertBefore(
                          this.iframe,
                          n.firstChild
                        ).contentWindow;
                      o.document.open(),
                        o.document.close(),
                        (o.location.hash = '#' + this.fragment);
                    }
                    var s =
                      window.addEventListener ||
                      function (t, e) {
                        return attachEvent('on' + t, e);
                      };
                    if (
                      (this._usePushState
                        ? s('popstate', this.checkUrl, !1)
                        : this._useHashChange && !this.iframe
                        ? s('hashchange', this.checkUrl, !1)
                        : this._wantsHashChange &&
                          (this._checkUrlInterval = setInterval(
                            this.checkUrl,
                            this.interval
                          )),
                      !this.options.silent)
                    )
                      return this.loadUrl();
                  },
                  stop: function () {
                    var t =
                      window.removeEventListener ||
                      function (t, e) {
                        return detachEvent('on' + t, e);
                      };
                    this._usePushState
                      ? t('popstate', this.checkUrl, !1)
                      : this._useHashChange &&
                        !this.iframe &&
                        t('hashchange', this.checkUrl, !1),
                      this.iframe &&
                        (document.body.removeChild(this.iframe),
                        (this.iframe = null)),
                      this._checkUrlInterval &&
                        clearInterval(this._checkUrlInterval),
                      (N.started = !1);
                  },
                  route: function (t, e) {
                    this.handlers.unshift({
                      route: t,
                      callback: e,
                    });
                  },
                  checkUrl: function (t) {
                    var e = this.getFragment();
                    if (
                      (e === this.fragment &&
                        this.iframe &&
                        (e = this.getHash(this.iframe.contentWindow)),
                      e === this.fragment)
                    )
                      return !1;
                    this.iframe && this.navigate(e), this.loadUrl();
                  },
                  loadUrl: function (t) {
                    return (
                      !!this.matchRoot() &&
                      ((t = this.fragment = this.getFragment(t)),
                      i.some(this.handlers, function (e) {
                        if (e.route.test(t)) return e.callback(t), !0;
                      }))
                    );
                  },
                  navigate: function (t, e) {
                    if (!N.started) return !1;
                    (e && !0 !== e) ||
                      (e = {
                        trigger: !!e,
                      }),
                      (t = this.getFragment(t || ''));
                    var i = this.root;
                    ('' !== t && '?' !== t.charAt(0)) ||
                      (i = i.slice(0, -1) || '/');
                    var n = i + t;
                    t = t.replace(W, '');
                    var o = this.decodeFragment(t);
                    if (this.fragment !== o) {
                      if (((this.fragment = o), this._usePushState))
                        this.history[e.replace ? 'replaceState' : 'pushState'](
                          {},
                          document.title,
                          n
                        );
                      else {
                        if (!this._wantsHashChange)
                          return this.location.assign(n);
                        if (
                          (this._updateHash(this.location, t, e.replace),
                          this.iframe &&
                            t !== this.getHash(this.iframe.contentWindow))
                        ) {
                          var s = this.iframe.contentWindow;
                          e.replace || (s.document.open(), s.document.close()),
                            this._updateHash(s.location, t, e.replace);
                        }
                      }
                      return e.trigger ? this.loadUrl(t) : void 0;
                    }
                  },
                  _updateHash: function (t, e, i) {
                    if (i) {
                      var n = t.href.replace(/(javascript:|#).*$/, '');
                      t.replace(n + '#' + e);
                    } else t.hash = '#' + e;
                  },
                }),
                (e.history = new N()),
                (g.extend =
                  y.extend =
                  P.extend =
                  O.extend =
                  N.extend =
                    function (t, e) {
                      var n,
                        o = this;
                      return (
                        (n =
                          t && i.has(t, 'constructor')
                            ? t.constructor
                            : function () {
                                return o.apply(this, arguments);
                              }),
                        i.extend(n, o, e),
                        (n.prototype = i.create(o.prototype, t)),
                        (n.prototype.constructor = n),
                        (n.__super__ = o.prototype),
                        n
                      );
                    });
              var U = function () {
                  throw new Error(
                    'A "url" property or function must be specified'
                  );
                },
                B = function (t, e) {
                  var i = e.error;
                  e.error = function (n) {
                    i && i.call(e.context, t, n, e),
                      t.trigger('error', t, n, e);
                  };
                };
              return e;
            })(r, i, t, e);
          }.apply(e, o)) || (t.exports = s);
    }.call(this, i(6)));
  },
  function (t, e, i) {
    'use strict';
    var n = ['interactive', 'complete'],
      o = function (t, e) {
        return new Promise(function (i) {
          t && 'function' != typeof t && ((e = t), (t = null)),
            (e = e || window.document);
          var o = function () {
            return i(void (t && setTimeout(t)));
          };
          -1 !== n.indexOf(e.readyState)
            ? o()
            : e.addEventListener('DOMContentLoaded', o);
        });
      };
    (o.resume = function (t) {
      return function (e) {
        return o(t).then(function () {
          return e;
        });
      };
    }),
      (e.a = o);
  },
  function (t, e, i) {
    var n, o, s;
    !(function (r) {
      'use strict';
      (o = [i(0)]),
        void 0 ===
          (s =
            'function' ==
            typeof (n = function (t, e) {
              function i(t) {
                var i;
                (this.observe = function (n, o) {
                  e
                    ? (i = i || new e(t)).observe(n, o)
                    : (i = setInterval(t, 50));
                }),
                  (this.disconnect = function () {
                    i && (e ? i.disconnect() : clearInterval(i));
                  });
              }

              function n(e, i, n) {
                (this.callback = e),
                  (this.conditions = i),
                  (this.multi = n || !1),
                  (this.cbid = a++),
                  (this.processed = t([]));
              }

              function o(e) {
                var i = {};
                return (
                  e.attributes &&
                    t.each(e.attributes, function (t, e) {
                      i[e.name] = e.value;
                    }),
                  i
                );
              }

              function s(e, i) {
                var n = [];
                return (
                  t.each(e, function (t, e) {
                    (void 0 === i[t] || e !== i[t]) &&
                      n.push({
                        attributeName: t,
                      });
                  }),
                  t.each(i, function (t) {
                    void 0 === e[t] &&
                      n.push({
                        attributeName: t,
                      });
                  }),
                  n
                );
              }

              function r(t, e, i) {
                var n = t.attributeName,
                  o = e.attr(n),
                  s = i.conditions || !1,
                  r = !!s && s[0],
                  a = !(!s || !s[1]) && s[1];
                return (!r || r.indexOf(n) > -1) && (!a || o.search(a) >= 0);
              }
              t || (t = t.fn.jquery ? t : jQuery),
                e ||
                  (e =
                    window.MutationObserver ||
                    window.WebKitMutationObserver ||
                    window.MozMutationObserver ||
                    !1);
              var a = 0,
                l = 'create',
                c = 'modify',
                d = 'text',
                u = {
                  attach: function (a) {
                    var u = a.type,
                      h = a.callback,
                      p = a.multi || !1,
                      f = a.conditions;
                    this.data('onMutate') ||
                      this.data('onMutate', {
                        create: {
                          callbacks: [],
                          ignore: !1,
                        },
                        modify: {
                          callbacks: [],
                          ignore: !1,
                        },
                        text: {
                          callbacks: [],
                          ignore: !1,
                        },
                      });
                    var v = this.data('onMutate')[u],
                      m = v.callbacks,
                      g = new n(h, f, p);
                    m.unshift(g),
                      e || u !== c || (v.attributeMap = o(this[0])),
                      u === d && (v.text = this.text());
                    var y,
                      w,
                      b = this,
                      $ = (v.mutcallback =
                        v.mutcallback ||
                        function (i) {
                          if (((m = v.callbacks), !v.ignore)) {
                            v.ignore = !0;
                            var n = u === l ? t(f, b) : b;
                            if (n.length > 0) {
                              var a, h;
                              for (
                                u === c && (a = o(b[0])),
                                  u === d && (h = b.text()),
                                  y = m.length - 1;
                                y >= 0;
                                y--
                              ) {
                                var p = m[y].processed,
                                  g = n.not(p);
                                if (u === c) {
                                  (w = !1), e || (i = s(a, v.attributeMap));
                                  for (var $ = 0; $ < i.length; $++)
                                    w = w || r(i[$], b, m[y]);
                                }
                                if (u === d) {
                                  w = !1;
                                  var k = m[y].conditions;
                                  h !== v.text && (w = !k || h.search(k) > -1);
                                }
                                g.length > 0 &&
                                  (u === l || w) &&
                                  (u === l && (p = p.add(g)),
                                  (m[y].processed = p),
                                  m[y].callback.call(b, g),
                                  m[y].multi || m.splice(y, 1));
                              }
                              u === c && (v.attributeMap = o(b[0])),
                                u === d && (v.text = b.text());
                            }
                            if (
                              (v.ignore &&
                                setTimeout(function () {
                                  v.ignore = !1;
                                }, 1),
                              0 === m.length)
                            ) {
                              if (!S) return !0;
                              S.disconnect();
                            }
                          }
                        });
                    if (u === l && $()) return this;
                    var k,
                      S = (v.observer = v.observer || new i($));
                    switch (u) {
                      case l:
                        k = {
                          childList: !0,
                          subtree: !0,
                        };
                        break;
                      case c:
                        (k = {
                          attributes: !0,
                        }),
                          f && (k.attributeFilter = f[0].split(' '));
                        break;
                      case d:
                        k = {
                          childList: !0,
                          characterData: !0,
                          subtree: !0,
                        };
                    }
                    return S.observe(b[0], k), this;
                  },
                  detach: function (t) {
                    if (!this.data('onMutate')) return this;
                    var e = t.type,
                      i = this.data('onMutate')[e],
                      n = i.callbacks,
                      o = t.callback;
                    if (o)
                      for (var s = n.length - 1; s >= 0; s--)
                        n[s].callback.prototype.cbid === o.prototype.cbid &&
                          n.splice(s, s + 1);
                    else i.callbacks = [];
                    return n.length || i.observer.disconnect(), this;
                  },
                };
              t.fn.extend({
                onCreate: function () {
                  var t = Array.prototype.slice.call(arguments);
                  return 'string' != typeof t[0]
                    ? this
                    : 'detach' === t[0]
                    ? u.detach.call(this, {
                        type: l,
                        callback: t[1],
                      })
                    : 'string' == typeof t[0] && 'function' == typeof t[1]
                    ? u.attach.call(this, {
                        type: l,
                        conditions: t[0],
                        callback: t[1],
                        multi: t[2],
                      })
                    : this;
                },
                onModify: function () {
                  var t,
                    e = Array.prototype.slice.call(arguments);
                  if (
                    ((t = u[e[0]] ? e.shift() : 'attach'),
                    'function' == typeof e[0])
                  )
                    return u[t].call(this, {
                      type: c,
                      callback: e[0],
                      multi: e[1],
                    });
                  if ('string' == typeof e[0]) {
                    if ('function' == typeof e[1])
                      return u[t].call(this, {
                        type: c,
                        conditions: [e[0]],
                        callback: e[1],
                        multi: e[2],
                      });
                    if ('string' == typeof e[1] || e[1] instanceof RegExp)
                      return u[t].call(this, {
                        type: c,
                        conditions: [e[0], e[1]],
                        callback: e[2],
                        multi: e[3],
                      });
                  } else {
                    if ('attach' === t) return this;
                    u[t].call(this, {
                      type: c,
                    });
                  }
                },
                onText: function () {
                  if (0 === this.length) return this;
                  var t,
                    e = Array.prototype.slice.call(arguments);
                  return (
                    (t = u[e[0]] ? e.shift() : 'attach'),
                    'function' == typeof e[0]
                      ? u[t].call(this, {
                          type: d,
                          callback: e[0],
                          multi: e[1],
                        })
                      : 'string' == typeof e[0] ||
                        (e[0] instanceof RegExp && 'function' == typeof e[1])
                      ? u[t].call(this, {
                          type: d,
                          conditions: e[0],
                          callback: e[1],
                          multi: e[2],
                        })
                      : 'attach' === t
                      ? this
                      : void u[t].call(this, {
                          type: d,
                        })
                  );
                },
              }),
                (t.onCreate = function (e, i, n) {
                  t(document).onCreate(e, i, n);
                });
            })
              ? n.apply(e, o)
              : n) || (t.exports = s);
    })();
  },
  function (t, e) {
    function i(t) {
      return (i =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            })(t);
    }

    function n(e) {
      return (
        'function' == typeof Symbol && 'symbol' === i(Symbol.iterator)
          ? (t.exports = n =
              function (t) {
                return i(t);
              })
          : (t.exports = n =
              function (t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : i(t);
              }),
        n(e)
      );
    }
    t.exports = n;
  },
  function (t, e) {
    var i;
    i = (function () {
      return this;
    })();
    try {
      i = i || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (i = window);
    }
    t.exports = i;
  },
  function (t, e, i) {
    'use strict';
    var n = i(5),
      o = i.n(n),
      s = i(0),
      r = i.n(s),
      a = i(2),
      l = i.n(a).a.View.extend({
        initialize: function (t) {
          (this.productJSON = t.productJSON),
            (this.prefix = t.prefix),
            void 0 !== this.productJSON &&
              (this.watchVariantStock(),
              this.initImages(),
              this.initOptionSelectors());
        },
        initOptionSelectors: function () {
          function t(t) {
            var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : '';
            (this.product = t),
              (this.prefix = e),
              (this.$form = r()(
                ''
                  .concat(this.prefix, ' form[data-product-id="')
                  .concat(this.product.id, '"]')
              )),
              (this.$ = this.$form.find.bind(this.$form)),
              (this.$id = this.$('select[name="id"]')),
              (this.$finalSale = this.$('input[data-final-sale]')),
              (this.$finalSale.$badge = this.$('span.final_sale')),
              (this.$price = this.$('.variant-price')),
              (this.$quadpayPrice = this.$('.qp-variant-price')),
              (this.$compareAtPrice = this.$('.comparePrice')),
              (this.$promoBadge = this.$('.price-promo')),
              (this.swatches = {
                $colors: this.$('label[aria-label^="Color"] > input'),
                $sizes: this.$('label[aria-label^="Size"] > input'),
              }),
              (this.swatches.$colors.length || this.swatches.$sizes.length) &&
                this.$id.val(''),
              (this.swatches.$colors.$select = this.$(
                '.product-form-bottom .select.colors'
              )),
              (this.swatches.$sizes.$select = this.$(
                '.product-form-bottom .select.sizes'
              )),
              (this.swatches.$colors.name = this.swatches.$colors.attr('name')),
              (this.swatches.$sizes.name = this.swatches.$sizes.attr('name')),
              (this.swatches.$colors.optionIndex =
                this.product.options.findIndex(function (t) {
                  return /color/i.test(t);
                })),
              (this.swatches.$sizes.optionIndex =
                this.product.options.findIndex(function (t) {
                  return /size/i.test(t);
                })),
              this.sortSwatches();
            var i = this.swatches.$colors.has('input:checked');
            i.length || (i = this.swatches.$colors.first()),
              i.length || (i = this.swatches.$sizes.first()),
              i.length && i.get(0).click(),
              i.closest('.swatch-element').addClass('selected'),
              (this.fitAndFabric = {
                $custom: r()(''.concat(this.prefix, ' #fit-fabric-custom')),
                $regular: r()(''.concat(this.prefix, ' #fit-fabric-regular')),
              }),
              this.tryTriggerVariantChanged(i.val() || this.$id.val())
                .watchSwatchInputs()
                .tryAutoselectPlusSizeVariant();
          }
          (t.variantSizes = {
            xs: 'Extra Small',
            s: 'Small',
            m: 'Medium',
            l: 'Large',
            xl: 'Extra Large',
          }),
            (t.prototype.formatFinalSaleBadgeForVariant = function () {
              var t =
                this.getVariantById().options[
                  this.swatches.$colors.optionIndex
                ];

              return t
                ? (this.product.tags
                    .map(function (t) {
                      return t.toLowerCase();
                    })
                    .includes('final_sale')
                    ? (this.$finalSale.$badge.text(
                        '#side-cart' === this.prefix
                          ? 'Final Sale'
                          : 'FINAL SALE: '.concat(this.$finalSale.data('value'))
                      ),
                      this.$finalSale
                        .attr('name', this.$finalSale.data('name'))
                        .attr('value', this.$finalSale.data('value')))
                    : (this.$finalSale.$badge.empty(),
                      this.$finalSale.attr('name', null).attr('value', null)),
                  this)
                : this;
            }),
            (t.prototype.formatFitAndFabric = function () {
              var t = this,
                e = this.getVariantById();
              return (
                this.fitAndFabric.$custom.empty().hide(),
                +e.id != +this.$id.val()
                  ? (this.fitAndFabric.$regular.show(), this)
                  : (r.a
                      .get(
                        '/products/'.concat(this.product.handle) +
                          '?view=fit_fabric_variant&variant='.concat(e.id)
                      )
                      .done(function (e) {
                        (e = e.trim()).length
                          ? (t.fitAndFabric.$regular.hide(),
                            t.fitAndFabric.$custom.html(e).show())
                          : t.fitAndFabric.$regular.show();
                      }),
                    this)
              );
            }),
            (t.prototype.formatSizeSwatchesForColorVariant = function (t) {
              var e = this,
                i =
                  this.getVariantById(t).options[
                    this.swatches.$colors.optionIndex
                  ];
              if (!i) return this;
              var n = this.swatches.$sizes.$select.find('.select-option');
              return (
                this.swatches.$sizes.each(function (t, o) {
                  var s = r()(o).closest('.swatch-element'),
                    a = n.eq(t),
                    l = e.getVariantByOptions(i, o.title);
                  l
                    ? ((o.value = l.id),
                      s.show(),
                      a.show(),
                      l.available
                        ? (s.removeClass('soldout'), a.removeClass('soldout'))
                        : (s.addClass('soldout'), a.addClass('soldout')))
                    : ((o.value = ''),
                      s.hide(),
                      a.hide(),
                      s.addClass('soldout'),
                      a.addClass('soldout'));
                }),
                this
              );
            }),
            (t.prototype.formatMoney = function (t) {
              return window.Shopify.formatMoney(
                t,
                window.Shopify.money_format
              ).replace('.00', '').replace('$', FORMAT_MONEY_SYMBOL);;
            }),
            (t.prototype.formatProductPriceForVariant = function () {
              var t = this,
                e = this.getVariantById(),
                i = e.compare_at_price,
                n = e.options,
                o = e.price;
              if (
                (this.$price.removeClass('red'),
                this.$quadpayPrice.closest('#quadPayCalculatorWidget').show(),
                this.$promoBadge.show(),
                +e.id == +this.$id.val())
              )
                return (
                  this.$price.html(this.formatMoney(o)),
                  this.$quadpayPrice.html(this.formatMoney(o / 4)),
                  i > o
                    ? (this.$compareAtPrice.html(this.formatMoney(i)),
                      this.$price.addClass('red'))
                    : this.$compareAtPrice.empty(),
                  this
                );
              var s = n[this.swatches.$colors.optionIndex],
                r = this.product.variants
                  .filter(function (e) {
                    return e.options[t.swatches.$colors.optionIndex] === s;
                  })
                  .map(function (t) {
                    return t.price;
                  }),
                a = Math.min.apply(null, r),
                l = Math.max.apply(null, r);
              return (
                a === l
                  ? (this.$price.html(this.formatMoney(o)),
                    this.$quadpayPrice.html(this.formatMoney(o / 4)),
                    i > o
                      ? (this.$compareAtPrice.html(this.formatMoney(i)),
                        this.$price.addClass('red'))
                      : this.$compareAtPrice.empty())
                  : (this.$price.html(
                      '\n          '
                        .concat(this.formatMoney(a), ' &ndash; ')
                        .concat(this.formatMoney(l), '\n        ')
                        .trim()
                    ),
                    this.$quadpayPrice
                      .empty()
                      .closest('#quadPayCalculatorWidget')
                      .hide(),
                    this.$compareAtPrice.empty()),
                this
              );
            }),
            (t.prototype.formatSwatchHeadings = function () {
              for (var e = 0, i = ['color', 'size']; e < i.length; e++) {
                var n = i[e],
                  o = this.getSelectedOption(n),
                  s = this.swatches['$'.concat(n, 's')].optionIndex,
                  r = o ? this.getVariantById(o.value).options[s] : '';
                (r = r.replace(/\w*(?=\/|$)/g, function (e) {
                  return t.variantSizes[e.toLowerCase()] || e;
                })),
                  this.$('.swatch[data-option-index="'.concat(s, '"]'))
                    .find('.variant-name,.variant-size')
                    .text(r);
              }
              return this;
            }),
            (t.prototype.getSelectedOption = function (t) {
              var e = this;
              return this.$form.serializeArray().find(function (i) {
                var n = i.name,
                  o = i.value;
                return n === e.swatches['$'.concat(t, 's')].name && o;
              });
            }),
            (t.prototype.getVariantById = function (t) {
              return (
                (t =
                  t ||
                  this.getSelectedOption('size') ||
                  this.getSelectedOption('color') ||
                  this.$id.val()),
                'object' === o()(t) && (t = t.value),
                this.product.variants.find(function (e) {
                  return +e.id == +t;
                }) || this.product.variants[0]
              );
            }),
            (t.prototype.getVariantByOptions = function (t, e) {
              var i = this;
              return this.product.variants.find(function (n) {
                var o = n.options;
                return (
                  o[i.swatches.$colors.optionIndex] === t &&
                  o[i.swatches.$sizes.optionIndex] === e
                );
              });
            }),
            (t.prototype.sortSwatches = function () {
              var t = ['xs', 's', 'm', 'l', 'xl']
                  .map(function (t) {
                    return new RegExp('^'.concat(t), 'i');
                  })
                  .reverse(),
                e = this.swatches.$sizes.closest('.actual-swatches');
              e.children()
                .detach()
                .sort(function (e, i) {
                  var n = [e, i].map(function (e) {
                    var i = r()(e).data('value');
                    return (
                      /^\d/.test(i) ||
                        (i = -t.findIndex(function (t) {
                          return t.test(i);
                        })),
                      parseInt(i)
                    );
                  });
                  return n[0] - n[1];
                })
                .appendTo(e);
            }),
            (t.prototype.tryAutoselectPlusSizeVariant = function () {
              var t = this;
              if (
                !this.$form.closest('#product-wrap').is('[data-plus-size-item]')
              )
                return this;
              var e = this.product.variants.find(function (e) {
                return (
                  e.available && /\dx/i.test(e[t.swatches.$sizes.optionIndex])
                );
              });
              if (!e) return this;
              var i = e.options[this.swatches.$colors.optionIndex];
              this.swatches.$colors
                .filter(function (t, e) {
                  return e.title === i;
                })
                .click();
              var n = e.options[this.swatches.$sizes.optionIndex];
              return (
                this.swatches.$sizes
                  .filter(function (t, e) {
                    return e.title === n;
                  })
                  .click(),
                this
              );
            }),
            (t.prototype.tryTriggerVariantChanged = function (t) {
              var e = this.product.variants.find(function (e) {
                return +e.id == +t;
              });
              return e
                ? (this.formatSizeSwatchesForColorVariant(),
                  this.$form.trigger('variant-changed', [
                    this.product.id,
                    e,
                    !this.swatches.$sizes.length ||
                      Boolean(this.getSelectedOption('size')),
                  ]),
                  this.$id.val() !== t &&
                    this.$id.val(
                      this.swatches.$sizes.length
                        ? this.getSelectedOption('size')
                          ? t
                          : ''
                        : this.getSelectedOption('color').value
                    ),
                  this.formatFitAndFabric()
                    .tryUpdateSelects()
                    .formatSwatchHeadings()
                    .formatProductPriceForVariant()
                    .formatFinalSaleBadgeForVariant(),
                  this)
                : this;
            }),
            (t.prototype.tryUpdateSelects = function () {
              for (var t = 0, e = ['color', 'size']; t < e.length; t++) {
                var i = e[t],
                  n = this.getSelectedOption(i),
                  o = this.swatches['$'.concat(i, 's')],
                  s = o.optionIndex,
                  r = o.$select,
                  a = n ? this.getVariantById(n.value).options[s] : '';
                r.trigger('select.select', [i, a]);
              }
              return this;
            }),
            (t.prototype.watchSwatchInputs = function () {
              var t = this;
              return (
                this.swatches.$colors.on('change', function (e) {
                  t.formatSizeSwatchesForColorVariant(e.currentTarget.value);
                  var i = t.getSelectedOption('color').value,
                    n = t.getSelectedOption('size')
                      ? t.getSelectedOption('size').value
                      : t.swatches.$sizes.filter('[value!=""]').first().val();
                  t.tryTriggerVariantChanged(n || i),
                    r()(e.currentTarget)
                      .closest('.swatch-element')
                      .addClass('selected')
                      .siblings()
                      .removeClass('selected');
                }),
                this.swatches.$sizes.on('change', function (e) {
                  t.tryTriggerVariantChanged(e.currentTarget.value),
                    r()(e.currentTarget)
                      .closest('.swatch-element')
                      .addClass('selected')
                      .siblings()
                      .removeClass('selected');
                }),
                this.swatches.$colors.$select.on(
                  'change select',
                  function (e, i) {
                    t.swatches.$colors
                      .filter('[title="'.concat(i, '"]'))
                      .click();
                  }
                ),
                this.swatches.$sizes.$select.on(
                  'change select',
                  function (e, i) {
                    t.swatches.$sizes
                      .filter('[title="'.concat(i, '"]'))
                      .click();
                  }
                ),
                this.$id.on('change', function (e) {
                  t.tryTriggerVariantChanged(e.currentTarget.value);
                }),
                this
              );
            }),
            (this.optionSelectors = new t(this.productJSON, this.prefix));
        },
        watchVariantStock: function () {
          var t = this,
            e = r()(
              ''
                .concat(this.prefix, ' #add-to-cart-button-')
                .concat(this.productJSON.id)
            );
          e.closest('form').on('variant-changed', function (i, n, o, s) {
            +n == +t.productJSON.id &&
              (s && o.available
                ? (e.attr('disabled', null), e.text(e.data('copy-add')))
                : (e.attr('disabled', ''),
                  e.text(e.data(s ? 'copy-stock' : 'copy-select'))));
          });
        },
        initImages: function () {
          var t = this,
            e = r()(
              ''
                .concat(this.prefix, ' form[data-product-id="')
                .concat(this.productJSON.id, '"]')
            ),
            i = e.find('.product-images');
          e.on('variant-changed', function (e, n, o, s) {
            +n == +t.productJSON.id &&
              i
                .find('[data-color="'.concat(o.option1, '"]'))
                .first()
                .removeClass('hide')
                .siblings()
                .addClass('hide');
          });
        },
        destroy: function () {
          this.undelegateEvents();
        },
      }),
      c = {
        init: function (t) {
          return new l(t);
        },
      };
    e.a = c;
  },
  function (t, e) {
    window.matchMedia ||
      (window.matchMedia = (function () {
        'use strict';
        var t = window.styleMedia || window.media;
        if (!t) {
          var e,
            i = document.createElement('style'),
            n = document.getElementsByTagName('script')[0];
          (i.type = 'text/css'),
            (i.id = 'matchmediajs-test'),
            n.parentNode.insertBefore(i, n),
            (e =
              ('getComputedStyle' in window &&
                window.getComputedStyle(i, null)) ||
              i.currentStyle),
            (t = {
              matchMedium: function (t) {
                var n =
                  '@media ' + t + '{ #matchmediajs-test { width: 1px; } }';
                return (
                  i.styleSheet
                    ? (i.styleSheet.cssText = n)
                    : (i.textContent = n),
                  '1px' === e.width
                );
              },
            });
        }
        return function (e) {
          return {
            matches: t.matchMedium(e || 'all'),
            media: e || 'all',
          };
        };
      })()),
      (function () {
        if (window.matchMedia && window.matchMedia('all').addListener)
          return !1;
        var t = window.matchMedia,
          e = t('only all').matches,
          i = !1,
          n = 0,
          o = [],
          s = function (e) {
            clearTimeout(n),
              (n = setTimeout(function () {
                for (var e = 0, i = o.length; e < i; e++) {
                  var n = o[e].mql,
                    s = o[e].listeners || [],
                    r = t(n.media).matches;
                  if (r !== n.matches) {
                    n.matches = r;
                    for (var a = 0, l = s.length; a < l; a++)
                      s[a].call(window, n);
                  }
                }
              }, 30));
          };
        window.matchMedia = function (n) {
          var r = t(n),
            a = [],
            l = 0;
          return (
            (r.addListener = function (t) {
              e &&
                (i || ((i = !0), window.addEventListener('resize', s, !0)),
                0 === l &&
                  (l = o.push({
                    mql: r,
                    listeners: a,
                  })),
                a.push(t));
            }),
            (r.removeListener = function (t) {
              for (var e = 0, i = a.length; e < i; e++)
                a[e] === t && a.splice(e, 1);
            }),
            r
          );
        };
      })(),
      (window.mediaCheck = function (t) {
        var e;

        function i(t, e) {
          t.matches
            ? 'function' == typeof e.entry && e.entry()
            : 'function' == typeof e.exit && e.exit();
        }
        (e = window.matchMedia(t.media)).addListener(function () {
          i(e, t);
        }),
          i(e, t);
      });
  },
  function (t, e) {
    t.exports = function (t) {
      return (
        t.webpackPolyfill ||
          ((t.deprecate = function () {}),
          (t.paths = []),
          t.children || (t.children = []),
          Object.defineProperty(t, 'loaded', {
            enumerable: !0,
            get: function () {
              return t.l;
            },
          }),
          Object.defineProperty(t, 'id', {
            enumerable: !0,
            get: function () {
              return t.i;
            },
          }),
          (t.webpackPolyfill = 1)),
        t
      );
    };
  },
  function (t, e) {
    t.exports = function (t) {
      if (!t.webpackPolyfill) {
        var e = Object.create(t);
        e.children || (e.children = []),
          Object.defineProperty(e, 'loaded', {
            enumerable: !0,
            get: function () {
              return e.l;
            },
          }),
          Object.defineProperty(e, 'id', {
            enumerable: !0,
            get: function () {
              return e.i;
            },
          }),
          Object.defineProperty(e, 'exports', {
            enumerable: !0,
          }),
          (e.webpackPolyfill = 1);
      }
      return e;
    };
  },
  function (t, e) {
    (function (e) {
      t.exports = e;
    }.call(this, {}));
  },
  function (t, e) {
    var i, n;
    if(window.innerWidth <= 899 ){return false;}
    (i = window.jQuery);
      (n = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: 'mouseover',
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1,
      }),
      (i.zoom = function (t, e, n, o) {
        var s,
          r,
          a,
          l,
          c,
          d,
          u,
          h = i(t).css('position'),
          p = i(e);
        return (
          (t.style.position = /(absolute|fixed)/.test(h) ? h : 'relative'),
          (t.style.overflow = 'hidden'),
          (n.style.width = n.style.height = ''),
          i(n)
            .addClass('zoomImg')
            .css({
              position: 'absolute',
              top: 0,
              left: 0,
              opacity: 0,
              width: n.width * o,
              height: n.height * o,
              border: 'none',
              maxWidth: 'none',
              maxHeight: 'none',
            })
            .attr('loading','lazy')
            .appendTo(t),
          {
            init: function () {
              (r = i(t).outerWidth()),
                (s = i(t).outerHeight()),
                e === t
                  ? ((l = r), (a = s))
                  : ((l = p.outerWidth()), (a = p.outerHeight())),
                (c = (n.width - r) / l),
                (d = (n.height - s) / a),
                (u = p.offset());
            },
            move: function (t) {
              var e = t.pageX - u.left,
                i = t.pageY - u.top;
              (i = Math.max(Math.min(i, a), 0)),
                (e = Math.max(Math.min(e, l), 0)),
                (n.style.left = e * -c + 'px'),
                (n.style.top = i * -d + 'px');
            },
          }
        );
      }),
      (i.fn.zoom = function (t) {
        return this.each(function () {
          var e,
            o,
            s,
            r = i.extend({}, n, t || {}),
            a = r.target || this,
            l = this,
            c = i(l),
            d = document.createElement('img'),
            u = i(d),
            h = 'mousemove.zoom',
            p = !1,
            f = !1;
          (r.url ||
            ((e = c.find('img'))[0] && (r.url = e.data('src') || e.attr('src')),
            r.url)) &&
            ((o = a.style.position),
            (s = a.style.overflow),
            c.one('zoom.destroy', function () {
              c.off('.zoom'),
                (a.style.position = o),
                (a.style.overflow = s),
                u.remove();
            }),
            (d.onload = function () {
              function t(t) {
                n.init(),
                  n.move(t),
                  u
                    .stop()
                    .fadeTo(
                      i.support.opacity ? r.duration : 0,
                      1,
                      !!i.isFunction(r.onZoomIn) && r.onZoomIn.call(d)
                    );
              }

              function e() {
                u.stop().fadeTo(
                  r.duration,
                  0,
                  !!i.isFunction(r.onZoomOut) && r.onZoomOut.call(d)
                );
              }
              var n = i.zoom(a, l, d, r.magnify);
              'grab' === r.on
                ? c.on('mousedown.zoom', function (o) {
                    1 === o.which &&
                      (i(document).one('mouseup.zoom', function () {
                        e(), i(document).off(h, n.move);
                      }),
                      t(o),
                      i(document).on(h, n.move),
                      o.preventDefault());
                  })
                : 'click' === r.on
                ? c.on('click.zoom', function (o) {
                    return p
                      ? void 0
                      : ((p = !0),
                        t(o),
                        i(document).on(h, n.move),
                        i(document).one('click.zoom', function () {
                          e(), (p = !1), i(document).off(h, n.move);
                        }),
                        !1);
                  })
                : 'toggle' === r.on
                ? c.on('click.zoom', function (i) {
                    p ? e() : t(i), (p = !p);
                  })
                : 'mouseover' === r.on &&
                  (n.init(),
                  c
                    .on('mouseenter.zoom', t)
                    .on('mouseleave.zoom', e)
                    .on(h, n.move)),
                r.touch &&
                  c
                    .on('touchstart.zoom', function (i) {
                      i.preventDefault(),
                        f
                          ? ((f = !1), e())
                          : ((f = !0),
                            t(
                              i.originalEvent.touches[0] ||
                                i.originalEvent.changedTouches[0]
                            ));
                    })
                    .on('touchmove.zoom', function (t) {
                      t.preventDefault(),
                        n.move(
                          t.originalEvent.touches[0] ||
                            t.originalEvent.changedTouches[0]
                        );
                    }),
                i.isFunction(r.callback) && r.callback.call(d);
            }),
            (d.src = r.url));
        });
      }),
      (i.fn.zoom.defaults = n);
  },
  function (t, e) {
    t.exports = tingle;
  },
  function (t, e, i) {
    t.exports = i(22);
  },
  function (t, e) {
    !(function (t) {
      function e() {}
      for (
        var i,
          n =
            'assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn'.split(
              ','
            );
        (i = n.pop());

      )
        t[i] = t[i] || e;
    })(
      (function () {
        try {
          return console.log(), window.console;
        } catch (t) {
          return (window.console = {});
        }
      })()
    );
  },
  function (t, e, i) {
    'use strict';
    (function (t) {
      var e = i(5),
        n = i.n(e);
      !(function (e) {
        if ('function' == typeof define && i(11)) define(e);
        else if (
          'object' ==
          ('undefined' == typeof exports ? 'undefined' : n()(exports))
        )
          t.exports = e();
        else {
          var o = window.Cookies,
            s = (window.Cookies = e());
          s.noConflict = function () {
            return (window.Cookies = o), s;
          };
        }
      })(function () {
        function t() {
          for (var t = 0, e = {}; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i) e[n] = i[n];
          }
          return e;
        }
        return (function e(i) {
          function n(e, o, s) {
            var r;
            if (arguments.length > 1) {
              if (
                'number' ==
                typeof (s = t(
                  {
                    path: '/',
                  },
                  n.defaults,
                  s
                )).expires
              ) {
                var a = new Date();
                a.setMilliseconds(a.getMilliseconds() + 864e5 * s.expires),
                  (s.expires = a);
              }
              try {
                (r = JSON.stringify(o)), /^[\{\[]/.test(r) && (o = r);
              } catch (t) {}
              return (
                (o = (o = encodeURIComponent(String(o))).replace(
                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                  decodeURIComponent
                )),
                (e = (e = (e = encodeURIComponent(String(e))).replace(
                  /%(23|24|26|2B|5E|60|7C)/g,
                  decodeURIComponent
                )).replace(/[\(\)]/g, escape)),
                (document.cookie = [
                  e,
                  '=',
                  o,
                  s.expires && '; expires=' + s.expires.toUTCString(),
                  s.path && '; path=' + s.path,
                  s.domain && '; domain=' + s.domain,
                  s.secure ? '; secure' : '',
                ].join(''))
              );
            }
            e || (r = {});
            for (
              var l = document.cookie ? document.cookie.split('; ') : [],
                c = /(%[0-9A-Z]{2})+/g,
                d = 0;
              d < l.length;
              d++
            ) {
              var u = l[d].split('='),
                h = u[0].replace(c, decodeURIComponent),
                p = u.slice(1).join('=');
              '"' === p.charAt(0) && (p = p.slice(1, -1));
              try {
                if (
                  ((p = (i && i(p, h)) || p.replace(c, decodeURIComponent)),
                  this.json)
                )
                  try {
                    p = JSON.parse(p);
                  } catch (t) {}
                if (e === h) {
                  r = p;
                  break;
                }
                e || (r[h] = p);
              } catch (t) {}
            }
            return r;
          }
          return (
            (n.get = n.set = n),
            (n.getJSON = function () {
              return n.apply(
                {
                  json: !0,
                },
                [].slice.call(arguments)
              );
            }),
            (n.defaults = {}),
            (n.remove = function (e, i) {
              n(
                e,
                '',
                t(i, {
                  expires: -1,
                })
              );
            }),
            (n.withConverter = e),
            n
          );
        })();
      });
    }.call(this, i(10)(t)));
  },
  function (t, e) {
    var i;
    (i = jQuery).fn.hoverIntent = function (t, e) {
      var n,
        o,
        s,
        r,
        a = {
          sensitivity: 7,
          interval: 100,
          timeout: 0,
        };
      a = i.extend(
        a,
        e
          ? {
              over: t,
              out: e,
            }
          : t
      );
      var l = function (t) {
          (n = t.pageX), (o = t.pageY);
        },
        c = function (t) {
          var e = jQuery.extend({}, t),
            c = this;
          c.hoverIntent_t && (c.hoverIntent_t = clearTimeout(c.hoverIntent_t)),
            'mouseenter' == t.type
              ? ((s = e.pageX),
                (r = e.pageY),
                i(c).bind('mousemove', l),
                1 != c.hoverIntent_s &&
                  (c.hoverIntent_t = setTimeout(function () {
                    !(function t(e, c) {
                      if (
                        ((c.hoverIntent_t = clearTimeout(c.hoverIntent_t)),
                        Math.abs(s - n) + Math.abs(r - o) < a.sensitivity)
                      )
                        return (
                          i(c).unbind('mousemove', l),
                          (c.hoverIntent_s = 1),
                          a.over.apply(c, [e])
                        );
                      (s = n),
                        (r = o),
                        (c.hoverIntent_t = setTimeout(function () {
                          t(e, c);
                        }, a.interval));
                    })(e, c);
                  }, a.interval)))
              : (i(c).unbind('mousemove', l),
                1 == c.hoverIntent_s &&
                  (c.hoverIntent_t = setTimeout(function () {
                    !(function (t, e) {
                      (e.hoverIntent_t = clearTimeout(e.hoverIntent_t)),
                        (e.hoverIntent_s = 0),
                        a.out.apply(e, [t]);
                    })(e, c);
                  }, a.timeout)));
        };
      return this.bind('mouseenter', c).bind('mouseleave', c);
    };
  },
  function (t, e, i) {
    'use strict';
    (function (t) {
      var e = i(5),
        n = i.n(e);
      ('function' == typeof define && i(11)
        ? define
        : function (e, n) {
            t.exports ? (t.exports = n(i(0))) : n(jQuery);
          })(['jquery'], function (t) {
        var e = (t.scrollTo = function (e, i, n) {
          return t(window).scrollTo(e, i, n);
        });

        function i(e) {
          return (
            !e.nodeName ||
            -1 !==
              t.inArray(e.nodeName.toLowerCase(), [
                'iframe',
                '#document',
                'html',
                'body',
              ])
          );
        }

        function o(e) {
          return t.isFunction(e) || t.isPlainObject(e)
            ? e
            : {
                top: e,
                left: e,
              };
        }
        return (
          (e.defaults = {
            axis: 'xy',
            duration: 0,
            limit: !0,
          }),
          (t.fn.scrollTo = function (s, r, a) {
            'object' === n()(r) && ((a = r), (r = 0)),
              'function' == typeof a &&
                (a = {
                  onAfter: a,
                }),
              'max' === s && (s = 9e9),
              (a = t.extend({}, e.defaults, a)),
              (r = r || a.duration);
            var l = a.queue && a.axis.length > 1;
            return (
              l && (r /= 2),
              (a.offset = o(a.offset)),
              (a.over = o(a.over)),
              this.each(function () {
                if (null !== s) {
                  var c,
                    d = i(this),
                    u = d ? this.contentWindow || window : this,
                    h = t(u),
                    p = s,
                    f = {};
                  switch (n()(p)) {
                    case 'number':
                    case 'string':
                      if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(p)) {
                        p = o(p);
                        break;
                      }
                      if (!(p = d ? t(p) : t(p, u)).length) return;
                    case 'object':
                      (p.is || p.style) && (c = (p = t(p)).offset());
                  }
                  var v =
                    (t.isFunction(a.offset) && a.offset(u, p)) || a.offset;
                  t.each(a.axis.split(''), function (t, i) {
                    var n = 'x' === i ? 'Left' : 'Top',
                      o = n.toLowerCase(),
                      s = 'scroll' + n,
                      r = h[s](),
                      g = e.max(u, i);
                    if (c)
                      (f[s] = c[o] + (d ? 0 : r - h.offset()[o])),
                        a.margin &&
                          ((f[s] -= parseInt(p.css('margin' + n), 10) || 0),
                          (f[s] -=
                            parseInt(p.css('border' + n + 'Width'), 10) || 0)),
                        (f[s] += v[o] || 0),
                        a.over[o] &&
                          (f[s] +=
                            p['x' === i ? 'width' : 'height']() * a.over[o]);
                    else {
                      var y = p[o];
                      f[s] =
                        y.slice && '%' === y.slice(-1)
                          ? (parseFloat(y) / 100) * g
                          : y;
                    }
                    a.limit &&
                      /^\d+$/.test(f[s]) &&
                      (f[s] = f[s] <= 0 ? 0 : Math.min(f[s], g)),
                      !t &&
                        a.axis.length > 1 &&
                        (r === f[s]
                          ? (f = {})
                          : l && (m(a.onAfterFirst), (f = {})));
                  }),
                    m(a.onAfter);
                }

                function m(e) {
                  var i = t.extend({}, a, {
                    queue: !0,
                    duration: r,
                    complete:
                      e &&
                      function () {
                        e.call(u, p, a);
                      },
                  });
                  h.animate(f, i);
                }
              })
            );
          }),
          (e.max = function (e, n) {
            var o = 'x' === n ? 'Width' : 'Height',
              s = 'scroll' + o;
            if (!i(e)) return e[s] - t(e)[o.toLowerCase()]();
            var r = 'client' + o,
              a = e.ownerDocument || e.document,
              l = a.documentElement,
              c = a.body;
            return Math.max(l[s], c[s]) - Math.min(l[r], c[r]);
          }),
          (t.Tween.propHooks.scrollLeft = t.Tween.propHooks.scrollTop =
            {
              get: function (e) {
                return t(e.elem)[e.prop]();
              },
              set: function (e) {
                var i = this.get(e);
                if (e.options.interrupt && e._last && e._last !== i)
                  return t(e.elem).stop();
                var n = Math.round(e.now);
                i !== n && (t(e.elem)[e.prop](n), (e._last = this.get(e)));
              },
            }),
          e
        );
      });
    }.call(this, i(10)(t)));
  },
  function (t, e, i) {
    var n, o, s;
    !(function (r) {
      'use strict';
      (o = [i(0)]),
        void 0 ===
          (s =
            'function' ==
            typeof (n = function (t) {
              var e,
                i = window.Slick;
              (((e = 0),
              (i = function (i, n) {
                var o,
                  s = this;
                (s.defaults = {
                  accessibility: !0,
                  adaptiveHeight: !1,
                  appendArrows: t(i),
                  appendDots: t(i),
                  arrows: !0,
                  asNavFor: null,
                  prevArrow:
                    '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                  nextArrow:
                    '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                  autoplay: !1,
                  autoplaySpeed: 3e3,
                  centerMode: !1,
                  centerPadding: '50px',
                  cssEase: 'ease',
                  customPaging: function (e, i) {
                    return t(
                      '<button type="button" data-role="none" role="button" tabindex="0" />'
                    ).text(i + 1);
                  },
                  dots: !1,
                  dotsClass: 'slick-dots',
                  draggable: !0,
                  easing: 'linear',
                  edgeFriction: 0.35,
                  fade: !1,
                  focusOnSelect: !1,
                  infinite: !0,
                  initialSlide: 0,
                  lazyLoad: 'ondemand',
                  mobileFirst: !1,
                  pauseOnHover: !0,
                  pauseOnFocus: !0,
                  pauseOnDotsHover: !1,
                  respondTo: 'window',
                  responsive: null,
                  rows: 1,
                  rtl: !1,
                  slide: '',
                  slidesPerRow: 1,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  speed: 500,
                  swipe: !0,
                  swipeToSlide: !1,
                  touchMove: !0,
                  touchThreshold: 5,
                  useCSS: !0,
                  useTransform: !0,
                  variableWidth: !1,
                  vertical: !1,
                  verticalSwiping: !1,
                  waitForAnimate: !0,
                  zIndex: 1e3,
                }),
                  (s.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                  }),
                  t.extend(s, s.initials),
                  (s.activeBreakpoint = null),
                  (s.animType = null),
                  (s.animProp = null),
                  (s.breakpoints = []),
                  (s.breakpointSettings = []),
                  (s.cssTransitions = !1),
                  (s.focussed = !1),
                  (s.interrupted = !1),
                  (s.hidden = 'hidden'),
                  (s.paused = !0),
                  (s.positionProp = null),
                  (s.respondTo = null),
                  (s.rowCount = 1),
                  (s.shouldClick = !0),
                  (s.$slider = t(i)),
                  (s.$slidesCache = null),
                  (s.transformType = null),
                  (s.transitionType = null),
                  (s.visibilityChange = 'visibilitychange'),
                  (s.windowWidth = 0),
                  (s.windowTimer = null),
                  (o = t(i).data('slick') || {}),
                  (s.options = t.extend({}, s.defaults, n, o)),
                  (s.currentSlide = s.options.initialSlide),
                  (s.originalSettings = s.options),
                  void 0 !== document.mozHidden
                    ? ((s.hidden = 'mozHidden'),
                      (s.visibilityChange = 'mozvisibilitychange'))
                    : void 0 !== document.webkitHidden &&
                      ((s.hidden = 'webkitHidden'),
                      (s.visibilityChange = 'webkitvisibilitychange')),
                  (s.autoPlay = t.proxy(s.autoPlay, s)),
                  (s.autoPlayClear = t.proxy(s.autoPlayClear, s)),
                  (s.autoPlayIterator = t.proxy(s.autoPlayIterator, s)),
                  (s.changeSlide = t.proxy(s.changeSlide, s)),
                  (s.clickHandler = t.proxy(s.clickHandler, s)),
                  (s.selectHandler = t.proxy(s.selectHandler, s)),
                  (s.setPosition = t.proxy(s.setPosition, s)),
                  (s.swipeHandler = t.proxy(s.swipeHandler, s)),
                  (s.dragHandler = t.proxy(s.dragHandler, s)),
                  (s.keyHandler = t.proxy(s.keyHandler, s)),
                  (s.instanceUid = e++),
                  (s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                  s.registerBreakpoints(),
                  s.init(!0);
              })).prototype.activateADA = function () {
                this.$slideTrack
                  .find('.slick-active')
                  .attr({
                    'aria-hidden': 'false',
                  })
                  .find('a, input, button, select')
                  .attr({
                    tabindex: '0',
                  });
              }),
                (i.prototype.addSlide = i.prototype.slickAdd =
                  function (e, i, n) {
                    var o = this;
                    if ('boolean' == typeof i) (n = i), (i = null);
                    else if (i < 0 || i >= o.slideCount) return !1;
                    o.unload(),
                      'number' == typeof i
                        ? 0 === i && 0 === o.$slides.length
                          ? t(e).appendTo(o.$slideTrack)
                          : n
                          ? t(e).insertBefore(o.$slides.eq(i))
                          : t(e).insertAfter(o.$slides.eq(i))
                        : !0 === n
                        ? t(e).prependTo(o.$slideTrack)
                        : t(e).appendTo(o.$slideTrack),
                      (o.$slides = o.$slideTrack.children(this.options.slide)),
                      o.$slideTrack.children(this.options.slide).detach(),
                      o.$slideTrack.append(o.$slides),
                      o.$slides.each(function (e, i) {
                        t(i).attr('data-slick-index', e);
                      }),
                      (o.$slidesCache = o.$slides),
                      o.reinit();
                  }),
                (i.prototype.animateHeight = function () {
                  var t = this;
                  if (
                    1 === t.options.slidesToShow &&
                    !0 === t.options.adaptiveHeight &&
                    !1 === t.options.vertical
                  ) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.animate(
                      {
                        height: e,
                      },
                      t.options.speed
                    );
                  }
                }),
                (i.prototype.animateSlide = function (e, i) {
                  var n = {},
                    o = this;
                  o.animateHeight(),
                    !0 === o.options.rtl &&
                      !1 === o.options.vertical &&
                      (e = -e),
                    !1 === o.transformsEnabled
                      ? !1 === o.options.vertical
                        ? o.$slideTrack.animate(
                            {
                              left: e,
                            },
                            o.options.speed,
                            o.options.easing,
                            i
                          )
                        : o.$slideTrack.animate(
                            {
                              top: e,
                            },
                            o.options.speed,
                            o.options.easing,
                            i
                          )
                      : !1 === o.cssTransitions
                      ? (!0 === o.options.rtl &&
                          (o.currentLeft = -o.currentLeft),
                        t({
                          animStart: o.currentLeft,
                        }).animate(
                          {
                            animStart: e,
                          },
                          {
                            duration: o.options.speed,
                            easing: o.options.easing,
                            step: function (t) {
                              (t = Math.ceil(t)),
                                !1 === o.options.vertical
                                  ? ((n[o.animType] =
                                      'translate(' + t + 'px, 0px)'),
                                    o.$slideTrack.css(n))
                                  : ((n[o.animType] =
                                      'translate(0px,' + t + 'px)'),
                                    o.$slideTrack.css(n));
                            },
                            complete: function () {
                              i && i.call();
                            },
                          }
                        ))
                      : (o.applyTransition(),
                        (e = Math.ceil(e)),
                        !1 === o.options.vertical
                          ? (n[o.animType] =
                              'translate3d(' + e + 'px, 0px, 0px)')
                          : (n[o.animType] =
                              'translate3d(0px,' + e + 'px, 0px)'),
                        o.$slideTrack.css(n),
                        i &&
                          setTimeout(function () {
                            o.disableTransition(), i.call();
                          }, o.options.speed));
                }),
                (i.prototype.getNavTarget = function () {
                  var e = this.options.asNavFor;
                  return e && null !== e && (e = t(e).not(this.$slider)), e;
                }),
                (i.prototype.asNavFor = function (e) {
                  var i = this.getNavTarget();
                  null !== i &&
                    'object' == typeof i &&
                    i.each(function () {
                      var i = t(this).slick('getSlick');
                      i.unslicked || i.slideHandler(e, !0);
                    });
                }),
                (i.prototype.applyTransition = function (t) {
                  var e = this,
                    i = {};
                  !1 === e.options.fade
                    ? (i[e.transitionType] =
                        e.transformType +
                        ' ' +
                        e.options.speed +
                        'ms ' +
                        e.options.cssEase)
                    : (i[e.transitionType] =
                        'opacity ' +
                        e.options.speed +
                        'ms ' +
                        e.options.cssEase),
                    !1 === e.options.fade
                      ? e.$slideTrack.css(i)
                      : e.$slides.eq(t).css(i);
                }),
                (i.prototype.autoPlay = function () {
                  var t = this;
                  t.autoPlayClear(),
                    t.slideCount > t.options.slidesToShow &&
                      (t.autoPlayTimer = setInterval(
                        t.autoPlayIterator,
                        t.options.autoplaySpeed
                      ));
                }),
                (i.prototype.autoPlayClear = function () {
                  this.autoPlayTimer && clearInterval(this.autoPlayTimer);
                }),
                (i.prototype.autoPlayIterator = function () {
                  var t = this,
                    e = t.currentSlide + t.options.slidesToScroll;
                  t.paused ||
                    t.interrupted ||
                    t.focussed ||
                    (!1 === t.options.infinite &&
                      (1 === t.direction &&
                      t.currentSlide + 1 === t.slideCount - 1
                        ? (t.direction = 0)
                        : 0 === t.direction &&
                          ((e = t.currentSlide - t.options.slidesToScroll),
                          t.currentSlide - 1 == 0 && (t.direction = 1))),
                    t.slideHandler(e));
                }),
                (i.prototype.buildArrows = function () {
                  var e = this;
                  !0 === e.options.arrows &&
                    ((e.$prevArrow = t(e.options.prevArrow).addClass(
                      'slick-arrow'
                    )),
                    (e.$nextArrow = t(e.options.nextArrow).addClass(
                      'slick-arrow'
                    )),
                    e.slideCount > e.options.slidesToShow
                      ? (e.$prevArrow
                          .removeClass('slick-hidden')
                          .removeAttr('aria-hidden tabindex'),
                        e.$nextArrow
                          .removeClass('slick-hidden')
                          .removeAttr('aria-hidden tabindex'),
                        e.htmlExpr.test(e.options.prevArrow) &&
                          e.$prevArrow.prependTo(e.options.appendArrows),
                        e.htmlExpr.test(e.options.nextArrow) &&
                          e.$nextArrow.appendTo(e.options.appendArrows),
                        !0 !== e.options.infinite &&
                          e.$prevArrow
                            .addClass('slick-disabled')
                            .attr('aria-disabled', 'true'))
                      : e.$prevArrow
                          .add(e.$nextArrow)
                          .addClass('slick-hidden')
                          .attr({
                            'aria-disabled': 'true',
                            tabindex: '-1',
                          }));
                }),
                (i.prototype.buildDots = function () {
                  var e,
                    i,
                    n = this;
                  if (
                    !0 === n.options.dots &&
                    n.slideCount > n.options.slidesToShow
                  ) {
                    for (
                      n.$slider.addClass('slick-dotted'),
                        i = t('<ul />').addClass(n.options.dotsClass),
                        e = 0;
                      e <= n.getDotCount();
                      e += 1
                    )
                      i.append(
                        t('<li />').append(
                          n.options.customPaging.call(this, n, e)
                        )
                      );
                    (n.$dots = i.appendTo(n.options.appendDots)),
                      n.$dots
                        .find('li')
                        .first()
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');
                  }
                }),
                (i.prototype.buildOut = function () {
                  var e = this;
                  (e.$slides = e.$slider
                    .children(e.options.slide + ':not(.slick-cloned)')
                    .addClass('slick-slide')),
                    (e.slideCount = e.$slides.length),
                    e.$slides.each(function (e, i) {
                      t(i)
                        .attr('data-slick-index', e)
                        .data('originalStyling', t(i).attr('style') || '');
                    }),
                    e.$slider.addClass('slick-slider'),
                    (e.$slideTrack =
                      0 === e.slideCount
                        ? t('<div class="slick-track"/>').appendTo(e.$slider)
                        : e.$slides
                            .wrapAll('<div class="slick-track"/>')
                            .parent()),
                    (e.$list = e.$slideTrack
                      .wrap('<div aria-live="polite" class="slick-list"/>')
                      .parent()),
                    e.$slideTrack.css('opacity', 0),
                    (!0 !== e.options.centerMode &&
                      !0 !== e.options.swipeToSlide) ||
                      (e.options.slidesToScroll = 1),
                    t('img[data-lazy]', e.$slider)
                      .not('[src]')
                      .addClass('slick-loading'),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.buildDots(),
                    e.updateDots(),
                    e.setSlideClasses(
                      'number' == typeof e.currentSlide ? e.currentSlide : 0
                    ),
                    !0 === e.options.draggable && e.$list.addClass('draggable');
                }),
                (i.prototype.buildRows = function () {
                  var t,
                    e,
                    i,
                    n,
                    o,
                    s,
                    r,
                    a = this;
                  if (
                    ((n = document.createDocumentFragment()),
                    (s = a.$slider.children()),
                    a.options.rows > 1)
                  ) {
                    for (
                      r = a.options.slidesPerRow * a.options.rows,
                        o = Math.ceil(s.length / r),
                        t = 0;
                      t < o;
                      t++
                    ) {
                      var l = document.createElement('div');
                      for (e = 0; e < a.options.rows; e++) {
                        var c = document.createElement('div');
                        for (i = 0; i < a.options.slidesPerRow; i++) {
                          var d = t * r + (e * a.options.slidesPerRow + i);
                          s.get(d) && c.appendChild(s.get(d));
                        }
                        l.appendChild(c);
                      }
                      n.appendChild(l);
                    }
                    a.$slider.empty().append(n),
                      a.$slider
                        .children()
                        .children()
                        .children()
                        .css({
                          width: 100 / a.options.slidesPerRow + '%',
                          display: 'inline-block',
                        });
                  }
                }),
                (i.prototype.checkResponsive = function (e, i) {
                  var n,
                    o,
                    s,
                    r = this,
                    a = !1,
                    l = r.$slider.width(),
                    c = window.innerWidth || t(window).width();
                  if (
                    ('window' === r.respondTo
                      ? (s = c)
                      : 'slider' === r.respondTo
                      ? (s = l)
                      : 'min' === r.respondTo && (s = Math.min(c, l)),
                    r.options.responsive &&
                      r.options.responsive.length &&
                      null !== r.options.responsive)
                  ) {
                    for (n in ((o = null), r.breakpoints))
                      r.breakpoints.hasOwnProperty(n) &&
                        (!1 === r.originalSettings.mobileFirst
                          ? s < r.breakpoints[n] && (o = r.breakpoints[n])
                          : s > r.breakpoints[n] && (o = r.breakpoints[n]));
                    null !== o
                      ? null !== r.activeBreakpoint
                        ? (o !== r.activeBreakpoint || i) &&
                          ((r.activeBreakpoint = o),
                          'unslick' === r.breakpointSettings[o]
                            ? r.unslick(o)
                            : ((r.options = t.extend(
                                {},
                                r.originalSettings,
                                r.breakpointSettings[o]
                              )),
                              !0 === e &&
                                (r.currentSlide = r.options.initialSlide),
                              r.refresh(e)),
                          (a = o))
                        : ((r.activeBreakpoint = o),
                          'unslick' === r.breakpointSettings[o]
                            ? r.unslick(o)
                            : ((r.options = t.extend(
                                {},
                                r.originalSettings,
                                r.breakpointSettings[o]
                              )),
                              !0 === e &&
                                (r.currentSlide = r.options.initialSlide),
                              r.refresh(e)),
                          (a = o))
                      : null !== r.activeBreakpoint &&
                        ((r.activeBreakpoint = null),
                        (r.options = r.originalSettings),
                        !0 === e && (r.currentSlide = r.options.initialSlide),
                        r.refresh(e),
                        (a = o)),
                      e || !1 === a || r.$slider.trigger('breakpoint', [r, a]);
                  }
                }),
                (i.prototype.changeSlide = function (e, i) {
                  var n,
                    o,
                    s = this,
                    r = t(e.currentTarget);
                  switch (
                    (r.is('a') && e.preventDefault(),
                    r.is('li') || (r = r.closest('li')),
                    (n =
                      s.slideCount % s.options.slidesToScroll != 0
                        ? 0
                        : (s.slideCount - s.currentSlide) %
                          s.options.slidesToScroll),
                    e.data.message)
                  ) {
                    case 'previous':
                      (o =
                        0 === n
                          ? s.options.slidesToScroll
                          : s.options.slidesToShow - n),
                        s.slideCount > s.options.slidesToShow &&
                          s.slideHandler(s.currentSlide - o, !1, i);
                      break;
                    case 'next':
                      (o = 0 === n ? s.options.slidesToScroll : n),
                        s.slideCount > s.options.slidesToShow &&
                          s.slideHandler(s.currentSlide + o, !1, i);
                      break;
                    case 'index':
                      var a =
                        0 === e.data.index
                          ? 0
                          : e.data.index ||
                            r.index() * s.options.slidesToScroll;
                      s.slideHandler(s.checkNavigable(a), !1, i),
                        r.children().trigger('focus');
                      break;
                    default:
                      return;
                  }
                }),
                (i.prototype.checkNavigable = function (t) {
                  var e, i;
                  if (
                    ((i = 0),
                    t > (e = this.getNavigableIndexes())[e.length - 1])
                  )
                    t = e[e.length - 1];
                  else
                    for (var n in e) {
                      if (t < e[n]) {
                        t = i;
                        break;
                      }
                      i = e[n];
                    }
                  return t;
                }),
                (i.prototype.cleanUpEvents = function () {
                  var e = this;
                  e.options.dots &&
                    null !== e.$dots &&
                    t('li', e.$dots)
                      .off('click.slick', e.changeSlide)
                      .off('mouseenter.slick', t.proxy(e.interrupt, e, !0))
                      .off('mouseleave.slick', t.proxy(e.interrupt, e, !1)),
                    e.$slider.off('focus.slick blur.slick'),
                    !0 === e.options.arrows &&
                      e.slideCount > e.options.slidesToShow &&
                      (e.$prevArrow &&
                        e.$prevArrow.off('click.slick', e.changeSlide),
                      e.$nextArrow &&
                        e.$nextArrow.off('click.slick', e.changeSlide)),
                    e.$list.off(
                      'touchstart.slick mousedown.slick',
                      e.swipeHandler
                    ),
                    e.$list.off(
                      'touchmove.slick mousemove.slick',
                      e.swipeHandler
                    ),
                    e.$list.off('touchend.slick mouseup.slick', e.swipeHandler),
                    e.$list.off(
                      'touchcancel.slick mouseleave.slick',
                      e.swipeHandler
                    ),
                    e.$list.off('click.slick', e.clickHandler),
                    t(document).off(e.visibilityChange, e.visibility),
                    e.cleanUpSlideEvents(),
                    !0 === e.options.accessibility &&
                      e.$list.off('keydown.slick', e.keyHandler),
                    !0 === e.options.focusOnSelect &&
                      t(e.$slideTrack)
                        .children()
                        .off('click.slick', e.selectHandler),
                    t(window).off(
                      'orientationchange.slick.slick-' + e.instanceUid,
                      e.orientationChange
                    ),
                    t(window).off(
                      'resize.slick.slick-' + e.instanceUid,
                      e.resize
                    ),
                    t('[draggable!=true]', e.$slideTrack).off(
                      'dragstart',
                      e.preventDefault
                    ),
                    t(window).off(
                      'load.slick.slick-' + e.instanceUid,
                      e.setPosition
                    ),
                    t(document).off(
                      'ready.slick.slick-' + e.instanceUid,
                      e.setPosition
                    );
                }),
                (i.prototype.cleanUpSlideEvents = function () {
                  var e = this;
                  e.$list.off('mouseenter.slick', t.proxy(e.interrupt, e, !0)),
                    e.$list.off(
                      'mouseleave.slick',
                      t.proxy(e.interrupt, e, !1)
                    );
                }),
                (i.prototype.cleanUpRows = function () {
                  var t,
                    e = this;
                  e.options.rows > 1 &&
                    ((t = e.$slides.children().children()).removeAttr('style'),
                    e.$slider.empty().append(t));
                }),
                (i.prototype.clickHandler = function (t) {
                  !1 === this.shouldClick &&
                    (t.stopImmediatePropagation(),
                    t.stopPropagation(),
                    t.preventDefault());
                }),
                (i.prototype.destroy = function (e) {
                  var i = this;
                  i.autoPlayClear(),
                    (i.touchObject = {}),
                    i.cleanUpEvents(),
                    t('.slick-cloned', i.$slider).detach(),
                    i.$dots && i.$dots.remove(),
                    i.$prevArrow &&
                      i.$prevArrow.length &&
                      (i.$prevArrow
                        .removeClass('slick-disabled slick-arrow slick-hidden')
                        .removeAttr('aria-hidden aria-disabled tabindex')
                        .css('display', ''),
                      i.htmlExpr.test(i.options.prevArrow) &&
                        i.$prevArrow.remove()),
                    i.$nextArrow &&
                      i.$nextArrow.length &&
                      (i.$nextArrow
                        .removeClass('slick-disabled slick-arrow slick-hidden')
                        .removeAttr('aria-hidden aria-disabled tabindex')
                        .css('display', ''),
                      i.htmlExpr.test(i.options.nextArrow) &&
                        i.$nextArrow.remove()),
                    i.$slides &&
                      (i.$slides
                        .removeClass(
                          'slick-slide slick-active slick-center slick-visible slick-current'
                        )
                        .removeAttr('aria-hidden')
                        .removeAttr('data-slick-index')
                        .each(function () {
                          t(this).attr(
                            'style',
                            t(this).data('originalStyling')
                          );
                        }),
                      i.$slideTrack.children(this.options.slide).detach(),
                      i.$slideTrack.detach(),
                      i.$list.detach(),
                      i.$slider.append(i.$slides)),
                    i.cleanUpRows(),
                    i.$slider.removeClass('slick-slider'),
                    i.$slider.removeClass('slick-initialized'),
                    i.$slider.removeClass('slick-dotted'),
                    (i.unslicked = !0),
                    e || i.$slider.trigger('destroy', [i]);
                }),
                (i.prototype.disableTransition = function (t) {
                  var e = this,
                    i = {};
                  (i[e.transitionType] = ''),
                    !1 === e.options.fade
                      ? e.$slideTrack.css(i)
                      : e.$slides.eq(t).css(i);
                }),
                (i.prototype.fadeSlide = function (t, e) {
                  var i = this;
                  !1 === i.cssTransitions
                    ? (i.$slides.eq(t).css({
                        zIndex: i.options.zIndex,
                      }),
                      i.$slides.eq(t).animate(
                        {
                          opacity: 1,
                        },
                        i.options.speed,
                        i.options.easing,
                        e
                      ))
                    : (i.applyTransition(t),
                      i.$slides.eq(t).css({
                        opacity: 1,
                        zIndex: i.options.zIndex,
                      }),
                      e &&
                        setTimeout(function () {
                          i.disableTransition(t), e.call();
                        }, i.options.speed));
                }),
                (i.prototype.fadeSlideOut = function (t) {
                  var e = this;
                  !1 === e.cssTransitions
                    ? e.$slides.eq(t).animate(
                        {
                          opacity: 0,
                          zIndex: e.options.zIndex - 2,
                        },
                        e.options.speed,
                        e.options.easing
                      )
                    : (e.applyTransition(t),
                      e.$slides.eq(t).css({
                        opacity: 0,
                        zIndex: e.options.zIndex - 2,
                      }));
                }),
                (i.prototype.filterSlides = i.prototype.slickFilter =
                  function (t) {
                    var e = this;
                    null !== t &&
                      ((e.$slidesCache = e.$slides),
                      e.unload(),
                      e.$slideTrack.children(this.options.slide).detach(),
                      e.$slidesCache.filter(t).appendTo(e.$slideTrack),
                      e.reinit());
                  }),
                (i.prototype.focusHandler = function () {
                  var e = this;
                  e.$slider
                    .off('focus.slick blur.slick')
                    .on(
                      'focus.slick blur.slick',
                      '*:not(.slick-arrow)',
                      function (i) {
                        i.stopImmediatePropagation();
                        var n = t(this);
                        setTimeout(function () {
                          e.options.pauseOnFocus &&
                            ((e.focussed = n.is(':focus')), e.autoPlay());
                        }, 0);
                      }
                    );
                }),
                (i.prototype.getCurrent = i.prototype.slickCurrentSlide =
                  function () {
                    return this.currentSlide;
                  }),
                (i.prototype.getDotCount = function () {
                  var t = this,
                    e = 0,
                    i = 0,
                    n = 0;
                  if (!0 === t.options.infinite)
                    for (; e < t.slideCount; )
                      ++n,
                        (e = i + t.options.slidesToScroll),
                        (i +=
                          t.options.slidesToScroll <= t.options.slidesToShow
                            ? t.options.slidesToScroll
                            : t.options.slidesToShow);
                  else if (!0 === t.options.centerMode) n = t.slideCount;
                  else if (t.options.asNavFor)
                    for (; e < t.slideCount; )
                      ++n,
                        (e = i + t.options.slidesToScroll),
                        (i +=
                          t.options.slidesToScroll <= t.options.slidesToShow
                            ? t.options.slidesToScroll
                            : t.options.slidesToShow);
                  else
                    n =
                      1 +
                      Math.ceil(
                        (t.slideCount - t.options.slidesToShow) /
                          t.options.slidesToScroll
                      );
                  return n - 1;
                }),
                (i.prototype.getLeft = function (t) {
                  var e,
                    i,
                    n,
                    o = this,
                    s = 0;
                  return (
                    (o.slideOffset = 0),
                    (i = o.$slides.first().outerHeight(!0)),
                    !0 === o.options.infinite
                      ? (o.slideCount > o.options.slidesToShow &&
                          ((o.slideOffset =
                            o.slideWidth * o.options.slidesToShow * -1),
                          (s = i * o.options.slidesToShow * -1)),
                        o.slideCount % o.options.slidesToScroll != 0 &&
                          t + o.options.slidesToScroll > o.slideCount &&
                          o.slideCount > o.options.slidesToShow &&
                          (t > o.slideCount
                            ? ((o.slideOffset =
                                (o.options.slidesToShow - (t - o.slideCount)) *
                                o.slideWidth *
                                -1),
                              (s =
                                (o.options.slidesToShow - (t - o.slideCount)) *
                                i *
                                -1))
                            : ((o.slideOffset =
                                (o.slideCount % o.options.slidesToScroll) *
                                o.slideWidth *
                                -1),
                              (s =
                                (o.slideCount % o.options.slidesToScroll) *
                                i *
                                -1))))
                      : t + o.options.slidesToShow > o.slideCount &&
                        ((o.slideOffset =
                          (t + o.options.slidesToShow - o.slideCount) *
                          o.slideWidth),
                        (s = (t + o.options.slidesToShow - o.slideCount) * i)),
                    o.slideCount <= o.options.slidesToShow &&
                      ((o.slideOffset = 0), (s = 0)),
                    !0 === o.options.centerMode && !0 === o.options.infinite
                      ? (o.slideOffset +=
                          o.slideWidth *
                            Math.floor(o.options.slidesToShow / 2) -
                          o.slideWidth)
                      : !0 === o.options.centerMode &&
                        ((o.slideOffset = 0),
                        (o.slideOffset +=
                          o.slideWidth *
                          Math.floor(o.options.slidesToShow / 2))),
                    (e =
                      !1 === o.options.vertical
                        ? t * o.slideWidth * -1 + o.slideOffset
                        : t * i * -1 + s),
                    !0 === o.options.variableWidth &&
                      ((n =
                        o.slideCount <= o.options.slidesToShow ||
                        !1 === o.options.infinite
                          ? o.$slideTrack.children('.slick-slide').eq(t)
                          : o.$slideTrack
                              .children('.slick-slide')
                              .eq(t + o.options.slidesToShow)),
                      (e =
                        !0 === o.options.rtl
                          ? n[0]
                            ? -1 *
                              (o.$slideTrack.width() -
                                n[0].offsetLeft -
                                n.width())
                            : 0
                          : n[0]
                          ? -1 * n[0].offsetLeft
                          : 0),
                      !0 === o.options.centerMode &&
                        ((n =
                          o.slideCount <= o.options.slidesToShow ||
                          !1 === o.options.infinite
                            ? o.$slideTrack.children('.slick-slide').eq(t)
                            : o.$slideTrack
                                .children('.slick-slide')
                                .eq(t + o.options.slidesToShow + 1)),
                        (e =
                          !0 === o.options.rtl
                            ? n[0]
                              ? -1 *
                                (o.$slideTrack.width() -
                                  n[0].offsetLeft -
                                  n.width())
                              : 0
                            : n[0]
                            ? -1 * n[0].offsetLeft
                            : 0),
                        (e += (o.$list.width() - n.outerWidth()) / 2))),
                    e
                  );
                }),
                (i.prototype.getOption = i.prototype.slickGetOption =
                  function (t) {
                    return this.options[t];
                  }),
                (i.prototype.getNavigableIndexes = function () {
                  var t,
                    e = this,
                    i = 0,
                    n = 0,
                    o = [];
                  for (
                    !1 === e.options.infinite
                      ? (t = e.slideCount)
                      : ((i = -1 * e.options.slidesToScroll),
                        (n = -1 * e.options.slidesToScroll),
                        (t = 2 * e.slideCount));
                    i < t;

                  )
                    o.push(i),
                      (i = n + e.options.slidesToScroll),
                      (n +=
                        e.options.slidesToScroll <= e.options.slidesToShow
                          ? e.options.slidesToScroll
                          : e.options.slidesToShow);
                  return o;
                }),
                (i.prototype.getSlick = function () {
                  return this;
                }),
                (i.prototype.getSlideCount = function () {
                  var e,
                    i,
                    n = this;
                  return (
                    (i =
                      !0 === n.options.centerMode
                        ? n.slideWidth * Math.floor(n.options.slidesToShow / 2)
                        : 0),
                    !0 === n.options.swipeToSlide
                      ? (n.$slideTrack
                          .find('.slick-slide')
                          .each(function (o, s) {
                            if (
                              s.offsetLeft - i + t(s).outerWidth() / 2 >
                              -1 * n.swipeLeft
                            )
                              return (e = s), !1;
                          }),
                        Math.abs(
                          t(e).attr('data-slick-index') - n.currentSlide
                        ) || 1)
                      : n.options.slidesToScroll
                  );
                }),
                (i.prototype.goTo = i.prototype.slickGoTo =
                  function (t, e) {
                    this.changeSlide(
                      {
                        data: {
                          message: 'index',
                          index: parseInt(t),
                        },
                      },
                      e
                    );
                  }),
                (i.prototype.init = function (e) {
                  var i = this;
                  t(i.$slider).hasClass('slick-initialized') ||
                    (t(i.$slider).addClass('slick-initialized'),
                    i.buildRows(),
                    i.buildOut(),
                    i.setProps(),
                    i.startLoad(),
                    i.loadSlider(),
                    i.initializeEvents(),
                    i.updateArrows(),
                    i.updateDots(),
                    i.checkResponsive(!0),
                    i.focusHandler()),
                    e && i.$slider.trigger('init', [i]),
                    !0 === i.options.accessibility && i.initADA(),
                    i.options.autoplay && ((i.paused = !1), i.autoPlay());
                }),
                (i.prototype.initADA = function () {
                  var e = this;
                  e.$slides
                    .add(e.$slideTrack.find('.slick-cloned'))
                    .attr({
                      'aria-hidden': 'true',
                      tabindex: '-1',
                    })
                    .find('a, input, button, select')
                    .attr({
                      tabindex: '-1',
                    }),
                    e.$slideTrack.attr('role', 'listbox'),
                    e.$slides
                      .not(e.$slideTrack.find('.slick-cloned'))
                      .each(function (i) {
                        t(this).attr({
                          role: 'option',
                          'aria-describedby': 'slick-slide' + e.instanceUid + i,
                        });
                      }),
                    null !== e.$dots &&
                      e.$dots
                        .attr('role', 'tablist')
                        .find('li')
                        .each(function (i) {
                          t(this).attr({
                            role: 'presentation',
                            'aria-selected': 'false',
                            'aria-controls': 'navigation' + e.instanceUid + i,
                            id: 'slick-slide' + e.instanceUid + i,
                          });
                        })
                        .first()
                        .attr('aria-selected', 'true')
                        .end()
                        .find('button')
                        .attr('role', 'button')
                        .end()
                        .closest('div')
                        .attr('role', 'toolbar'),
                    e.activateADA();
                }),
                (i.prototype.initArrowEvents = function () {
                  var t = this;
                  !0 === t.options.arrows &&
                    t.slideCount > t.options.slidesToShow &&
                    (t.$prevArrow.off('click.slick').on(
                      'click.slick',
                      {
                        message: 'previous',
                      },
                      t.changeSlide
                    ),
                    t.$nextArrow.off('click.slick').on(
                      'click.slick',
                      {
                        message: 'next',
                      },
                      t.changeSlide
                    ));
                }),
                (i.prototype.initDotEvents = function () {
                  var e = this;
                  !0 === e.options.dots &&
                    e.slideCount > e.options.slidesToShow &&
                    t('li', e.$dots).on(
                      'click.slick',
                      {
                        message: 'index',
                      },
                      e.changeSlide
                    ),
                    !0 === e.options.dots &&
                      !0 === e.options.pauseOnDotsHover &&
                      t('li', e.$dots)
                        .on('mouseenter.slick', t.proxy(e.interrupt, e, !0))
                        .on('mouseleave.slick', t.proxy(e.interrupt, e, !1));
                }),
                (i.prototype.initSlideEvents = function () {
                  var e = this;
                  e.options.pauseOnHover &&
                    (e.$list.on(
                      'mouseenter.slick',
                      t.proxy(e.interrupt, e, !0)
                    ),
                    e.$list.on(
                      'mouseleave.slick',
                      t.proxy(e.interrupt, e, !1)
                    ));
                }),
                (i.prototype.initializeEvents = function () {
                  var e = this;
                  e.initArrowEvents(),
                    e.initDotEvents(),
                    e.initSlideEvents(),
                    e.$list.on(
                      'touchstart.slick mousedown.slick',
                      {
                        action: 'start',
                      },
                      e.swipeHandler
                    ),
                    e.$list.on(
                      'touchmove.slick mousemove.slick',
                      {
                        action: 'move',
                      },
                      e.swipeHandler
                    ),
                    e.$list.on(
                      'touchend.slick mouseup.slick',
                      {
                        action: 'end',
                      },
                      e.swipeHandler
                    ),
                    e.$list.on(
                      'touchcancel.slick mouseleave.slick',
                      {
                        action: 'end',
                      },
                      e.swipeHandler
                    ),
                    e.$list.on('click.slick', e.clickHandler),
                    t(document).on(
                      e.visibilityChange,
                      t.proxy(e.visibility, e)
                    ),
                    !0 === e.options.accessibility &&
                      e.$list.on('keydown.slick', e.keyHandler),
                    !0 === e.options.focusOnSelect &&
                      t(e.$slideTrack)
                        .children()
                        .on('click.slick', e.selectHandler),
                    t(window).on(
                      'orientationchange.slick.slick-' + e.instanceUid,
                      t.proxy(e.orientationChange, e)
                    ),
                    t(window).on(
                      'resize.slick.slick-' + e.instanceUid,
                      t.proxy(e.resize, e)
                    ),
                    t('[draggable!=true]', e.$slideTrack).on(
                      'dragstart',
                      e.preventDefault
                    ),
                    t(window).on(
                      'load.slick.slick-' + e.instanceUid,
                      e.setPosition
                    ),
                    t(document).on(
                      'ready.slick.slick-' + e.instanceUid,
                      e.setPosition
                    );
                }),
                (i.prototype.initUI = function () {
                  var t = this;
                  !0 === t.options.arrows &&
                    t.slideCount > t.options.slidesToShow &&
                    (t.$prevArrow.show(), t.$nextArrow.show()),
                    !0 === t.options.dots &&
                      t.slideCount > t.options.slidesToShow &&
                      t.$dots.show();
                }),
                (i.prototype.keyHandler = function (t) {
                  var e = this;
                  t.target.tagName.match('TEXTAREA|INPUT|SELECT') ||
                    (37 === t.keyCode && !0 === e.options.accessibility
                      ? e.changeSlide({
                          data: {
                            message: !0 === e.options.rtl ? 'next' : 'previous',
                          },
                        })
                      : 39 === t.keyCode &&
                        !0 === e.options.accessibility &&
                        e.changeSlide({
                          data: {
                            message: !0 === e.options.rtl ? 'previous' : 'next',
                          },
                        }));
                }),
                (i.prototype.lazyLoad = function () {
                  var e,
                    i,
                    n = this;

                  function o(e) {
                    t('img[data-lazy]', e).each(function () {
                      var e = t(this),
                        i = t(this).attr('data-lazy'),
                        o = document.createElement('img');
                      (o.onload = function () {
                        e.animate(
                          {
                            opacity: 0,
                          },
                          100,
                          function () {
                            e.attr('src', i).animate(
                              {
                                opacity: 1,
                              },
                              200,
                              function () {
                                e.removeAttr('data-lazy').removeClass(
                                  'slick-loading'
                                );
                              }
                            ),
                              n.$slider.trigger('lazyLoaded', [n, e, i]);
                          }
                        );
                      }),
                        (o.onerror = function () {
                          e
                            .removeAttr('data-lazy')
                            .removeClass('slick-loading')
                            .addClass('slick-lazyload-error'),
                            n.$slider.trigger('lazyLoadError', [n, e, i]);
                        }),
                        (o.src = i);
                    });
                  }
                  !0 === n.options.centerMode
                    ? !0 === n.options.infinite
                      ? (i =
                          (e =
                            n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                          n.options.slidesToShow +
                          2)
                      : ((e = Math.max(
                          0,
                          n.currentSlide - (n.options.slidesToShow / 2 + 1)
                        )),
                        (i =
                          n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
                    : ((e = n.options.infinite
                        ? n.options.slidesToShow + n.currentSlide
                        : n.currentSlide),
                      (i = Math.ceil(e + n.options.slidesToShow)),
                      !0 === n.options.fade &&
                        (e > 0 && e--, i <= n.slideCount && i++)),
                    o(n.$slider.find('.slick-slide').slice(e, i)),
                    n.slideCount <= n.options.slidesToShow
                      ? o(n.$slider.find('.slick-slide'))
                      : n.currentSlide >= n.slideCount - n.options.slidesToShow
                      ? o(
                          n.$slider
                            .find('.slick-cloned')
                            .slice(0, n.options.slidesToShow)
                        )
                      : 0 === n.currentSlide &&
                        o(
                          n.$slider
                            .find('.slick-cloned')
                            .slice(-1 * n.options.slidesToShow)
                        );
                }),
                (i.prototype.loadSlider = function () {
                  var t = this;
                  t.setPosition(),
                    t.$slideTrack.css({
                      opacity: 1,
                    }),
                    t.$slider.removeClass('slick-loading'),
                    t.initUI(),
                    'progressive' === t.options.lazyLoad &&
                      t.progressiveLazyLoad();
                }),
                (i.prototype.next = i.prototype.slickNext =
                  function () {
                    this.changeSlide({
                      data: {
                        message: 'next',
                      },
                    });
                  }),
                (i.prototype.orientationChange = function () {
                  this.checkResponsive(), this.setPosition();
                }),
                (i.prototype.pause = i.prototype.slickPause =
                  function () {
                    this.autoPlayClear(), (this.paused = !0);
                  }),
                (i.prototype.play = i.prototype.slickPlay =
                  function () {
                    var t = this;
                    t.autoPlay(),
                      (t.options.autoplay = !0),
                      (t.paused = !1),
                      (t.focussed = !1),
                      (t.interrupted = !1);
                  }),
                (i.prototype.postSlide = function (t) {
                  var e = this;
                  e.unslicked ||
                    (e.$slider.trigger('afterChange', [e, t]),
                    (e.animating = !1),
                    e.setPosition(),
                    (e.swipeLeft = null),
                    e.options.autoplay && e.autoPlay(),
                    !0 === e.options.accessibility && e.initADA());
                }),
                (i.prototype.prev = i.prototype.slickPrev =
                  function () {
                    this.changeSlide({
                      data: {
                        message: 'previous',
                      },
                    });
                  }),
                (i.prototype.preventDefault = function (t) {
                  t.preventDefault();
                }),
                (i.prototype.progressiveLazyLoad = function (e) {
                  e = e || 1;
                  var i,
                    n,
                    o,
                    s = this,
                    r = t('img[data-lazy]', s.$slider);
                  r.length
                    ? ((i = r.first()),
                      (n = i.attr('data-lazy')),
                      ((o = document.createElement('img')).onload =
                        function () {
                          i
                            .attr('src', n)
                            .removeAttr('data-lazy')
                            .removeClass('slick-loading'),
                            !0 === s.options.adaptiveHeight && s.setPosition(),
                            s.$slider.trigger('lazyLoaded', [s, i, n]),
                            s.progressiveLazyLoad();
                        }),
                      (o.onerror = function () {
                        e < 3
                          ? setTimeout(function () {
                              s.progressiveLazyLoad(e + 1);
                            }, 500)
                          : (i
                              .removeAttr('data-lazy')
                              .removeClass('slick-loading')
                              .addClass('slick-lazyload-error'),
                            s.$slider.trigger('lazyLoadError', [s, i, n]),
                            s.progressiveLazyLoad());
                      }),
                      (o.src = n))
                    : s.$slider.trigger('allImagesLoaded', [s]);
                }),
                (i.prototype.refresh = function (e) {
                  var i,
                    n,
                    o = this;
                  (n = o.slideCount - o.options.slidesToShow),
                    !o.options.infinite &&
                      o.currentSlide > n &&
                      (o.currentSlide = n),
                    o.slideCount <= o.options.slidesToShow &&
                      (o.currentSlide = 0),
                    (i = o.currentSlide),
                    o.destroy(!0),
                    t.extend(o, o.initials, {
                      currentSlide: i,
                    }),
                    o.init(),
                    e ||
                      o.changeSlide(
                        {
                          data: {
                            message: 'index',
                            index: i,
                          },
                        },
                        !1
                      );
                }),
                (i.prototype.registerBreakpoints = function () {
                  var e,
                    i,
                    n,
                    o = this,
                    s = o.options.responsive || null;
                  if ('array' === t.type(s) && s.length) {
                    for (e in ((o.respondTo = o.options.respondTo || 'window'),
                    s))
                      if (
                        ((n = o.breakpoints.length - 1),
                        (i = s[e].breakpoint),
                        s.hasOwnProperty(e))
                      ) {
                        for (; n >= 0; )
                          o.breakpoints[n] &&
                            o.breakpoints[n] === i &&
                            o.breakpoints.splice(n, 1),
                            n--;
                        o.breakpoints.push(i),
                          (o.breakpointSettings[i] = s[e].settings);
                      }
                    o.breakpoints.sort(function (t, e) {
                      return o.options.mobileFirst ? t - e : e - t;
                    });
                  }
                }),
                (i.prototype.reinit = function () {
                  var e = this;
                  (e.$slides = e.$slideTrack
                    .children(e.options.slide)
                    .addClass('slick-slide')),
                    (e.slideCount = e.$slides.length),
                    e.currentSlide >= e.slideCount &&
                      0 !== e.currentSlide &&
                      (e.currentSlide =
                        e.currentSlide - e.options.slidesToScroll),
                    e.slideCount <= e.options.slidesToShow &&
                      (e.currentSlide = 0),
                    e.registerBreakpoints(),
                    e.setProps(),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.updateArrows(),
                    e.initArrowEvents(),
                    e.buildDots(),
                    e.updateDots(),
                    e.initDotEvents(),
                    e.cleanUpSlideEvents(),
                    e.initSlideEvents(),
                    e.checkResponsive(!1, !0),
                    !0 === e.options.focusOnSelect &&
                      t(e.$slideTrack)
                        .children()
                        .on('click.slick', e.selectHandler),
                    e.setSlideClasses(
                      'number' == typeof e.currentSlide ? e.currentSlide : 0
                    ),
                    e.setPosition(),
                    e.focusHandler(),
                    (e.paused = !e.options.autoplay),
                    e.autoPlay(),
                    e.$slider.trigger('reInit', [e]);
                }),
                (i.prototype.resize = function () {
                  var e = this;
                  t(window).width() !== e.windowWidth &&
                    (clearTimeout(e.windowDelay),
                    (e.windowDelay = window.setTimeout(function () {
                      (e.windowWidth = t(window).width()),
                        e.checkResponsive(),
                        e.unslicked || e.setPosition();
                    }, 50)));
                }),
                (i.prototype.removeSlide = i.prototype.slickRemove =
                  function (t, e, i) {
                    var n = this;
                    if (
                      ((t =
                        'boolean' == typeof t
                          ? !0 === (e = t)
                            ? 0
                            : n.slideCount - 1
                          : !0 === e
                          ? --t
                          : t),
                      n.slideCount < 1 || t < 0 || t > n.slideCount - 1)
                    )
                      return !1;
                    n.unload(),
                      !0 === i
                        ? n.$slideTrack.children().remove()
                        : n.$slideTrack
                            .children(this.options.slide)
                            .eq(t)
                            .remove(),
                      (n.$slides = n.$slideTrack.children(this.options.slide)),
                      n.$slideTrack.children(this.options.slide).detach(),
                      n.$slideTrack.append(n.$slides),
                      (n.$slidesCache = n.$slides),
                      n.reinit();
                  }),
                (i.prototype.setCSS = function (t) {
                  var e,
                    i,
                    n = this,
                    o = {};
                  !0 === n.options.rtl && (t = -t),
                    (e =
                      'left' == n.positionProp ? Math.ceil(t) + 'px' : '0px'),
                    (i = 'top' == n.positionProp ? Math.ceil(t) + 'px' : '0px'),
                    (o[n.positionProp] = t),
                    !1 === n.transformsEnabled
                      ? n.$slideTrack.css(o)
                      : ((o = {}),
                        !1 === n.cssTransitions
                          ? ((o[n.animType] =
                              'translate(' + e + ', ' + i + ')'),
                            n.$slideTrack.css(o))
                          : ((o[n.animType] =
                              'translate3d(' + e + ', ' + i + ', 0px)'),
                            n.$slideTrack.css(o)));
                }),
                (i.prototype.setDimensions = function () {
                  var t = this;
                  !1 === t.options.vertical
                    ? !0 === t.options.centerMode &&
                      t.$list.css({
                        padding: '0px ' + t.options.centerPadding,
                      })
                    : (t.$list.height(
                        t.$slides.first().outerHeight(!0) *
                          t.options.slidesToShow
                      ),
                      !0 === t.options.centerMode &&
                        t.$list.css({
                          padding: t.options.centerPadding + ' 0px',
                        })),
                    (t.listWidth = t.$list.width()),
                    (t.listHeight = t.$list.height()),
                    !1 === t.options.vertical && !1 === t.options.variableWidth
                      ? ((t.slideWidth = Math.ceil(
                          t.listWidth / t.options.slidesToShow
                        )),
                        t.$slideTrack.width(
                          Math.ceil(
                            t.slideWidth *
                              t.$slideTrack.children('.slick-slide').length
                          )
                        ))
                      : !0 === t.options.variableWidth
                      ? t.$slideTrack.width(5e3 * t.slideCount)
                      : ((t.slideWidth = Math.ceil(t.listWidth)),
                        t.$slideTrack.height(
                          Math.ceil(
                            t.$slides.first().outerHeight(!0) *
                              t.$slideTrack.children('.slick-slide').length
                          )
                        ));
                  var e =
                    t.$slides.first().outerWidth(!0) -
                    t.$slides.first().width();
                  !1 === t.options.variableWidth &&
                    t.$slideTrack
                      .children('.slick-slide')
                      .width(t.slideWidth - e);
                }),
                (i.prototype.setFade = function () {
                  var e,
                    i = this;
                  i.$slides.each(function (n, o) {
                    (e = i.slideWidth * n * -1),
                      !0 === i.options.rtl
                        ? t(o).css({
                            position: 'relative',
                            right: e,
                            top: 0,
                            zIndex: i.options.zIndex - 2,
                            opacity: 0,
                          })
                        : t(o).css({
                            position: 'relative',
                            left: e,
                            top: 0,
                            zIndex: i.options.zIndex - 2,
                            opacity: 0,
                          });
                  }),
                    i.$slides.eq(i.currentSlide).css({
                      zIndex: i.options.zIndex - 1,
                      opacity: 1,
                    });
                }),
                (i.prototype.setHeight = function () {
                  var t = this;
                  if (
                    1 === t.options.slidesToShow &&
                    !0 === t.options.adaptiveHeight &&
                    !1 === t.options.vertical
                  ) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.css('height', e);
                  }
                }),
                (i.prototype.setOption = i.prototype.slickSetOption =
                  function () {
                    var e,
                      i,
                      n,
                      o,
                      s,
                      r = this,
                      a = !1;
                    if (
                      ('object' === t.type(arguments[0])
                        ? ((n = arguments[0]),
                          (a = arguments[1]),
                          (s = 'multiple'))
                        : 'string' === t.type(arguments[0]) &&
                          ((n = arguments[0]),
                          (o = arguments[1]),
                          (a = arguments[2]),
                          'responsive' === arguments[0] &&
                          'array' === t.type(arguments[1])
                            ? (s = 'responsive')
                            : void 0 !== arguments[1] && (s = 'single')),
                      'single' === s)
                    )
                      r.options[n] = o;
                    else if ('multiple' === s)
                      t.each(n, function (t, e) {
                        r.options[t] = e;
                      });
                    else if ('responsive' === s)
                      for (i in o)
                        if ('array' !== t.type(r.options.responsive))
                          r.options.responsive = [o[i]];
                        else {
                          for (e = r.options.responsive.length - 1; e >= 0; )
                            r.options.responsive[e].breakpoint ===
                              o[i].breakpoint &&
                              r.options.responsive.splice(e, 1),
                              e--;
                          r.options.responsive.push(o[i]);
                        }
                    a && (r.unload(), r.reinit());
                  }),
                (i.prototype.setPosition = function () {
                  var t = this;
                  t.setDimensions(),
                    t.setHeight(),
                    !1 === t.options.fade
                      ? t.setCSS(t.getLeft(t.currentSlide))
                      : t.setFade(),
                    t.$slider.trigger('setPosition', [t]);
                }),
                (i.prototype.setProps = function () {
                  var t = this,
                    e = document.body.style;
                  (t.positionProp = !0 === t.options.vertical ? 'top' : 'left'),
                    'top' === t.positionProp
                      ? t.$slider.addClass('slick-vertical')
                      : t.$slider.removeClass('slick-vertical'),
                    (void 0 === e.WebkitTransition &&
                      void 0 === e.MozTransition &&
                      void 0 === e.msTransition) ||
                      (!0 === t.options.useCSS && (t.cssTransitions = !0)),
                    t.options.fade &&
                      ('number' == typeof t.options.zIndex
                        ? t.options.zIndex < 3 && (t.options.zIndex = 3)
                        : (t.options.zIndex = t.defaults.zIndex)),
                    void 0 !== e.OTransform &&
                      ((t.animType = 'OTransform'),
                      (t.transformType = '-o-transform'),
                      (t.transitionType = 'OTransition'),
                      void 0 === e.perspectiveProperty &&
                        void 0 === e.webkitPerspective &&
                        (t.animType = !1)),
                    void 0 !== e.MozTransform &&
                      ((t.animType = 'MozTransform'),
                      (t.transformType = '-moz-transform'),
                      (t.transitionType = 'MozTransition'),
                      void 0 === e.perspectiveProperty &&
                        void 0 === e.MozPerspective &&
                        (t.animType = !1)),
                    void 0 !== e.webkitTransform &&
                      ((t.animType = 'webkitTransform'),
                      (t.transformType = '-webkit-transform'),
                      (t.transitionType = 'webkitTransition'),
                      void 0 === e.perspectiveProperty &&
                        void 0 === e.webkitPerspective &&
                        (t.animType = !1)),
                    void 0 !== e.msTransform &&
                      ((t.animType = 'msTransform'),
                      (t.transformType = '-ms-transform'),
                      (t.transitionType = 'msTransition'),
                      void 0 === e.msTransform && (t.animType = !1)),
                    void 0 !== e.transform &&
                      !1 !== t.animType &&
                      ((t.animType = 'transform'),
                      (t.transformType = 'transform'),
                      (t.transitionType = 'transition')),
                    (t.transformsEnabled =
                      t.options.useTransform &&
                      null !== t.animType &&
                      !1 !== t.animType);
                }),
                (i.prototype.setSlideClasses = function (t) {
                  var e,
                    i,
                    n,
                    o,
                    s = this;
                  (i = s.$slider
                    .find('.slick-slide')
                    .removeClass('slick-active slick-center slick-current')
                    .attr('aria-hidden', 'true')),
                    s.$slides.eq(t).addClass('slick-current'),
                    !0 === s.options.centerMode
                      ? ((e = Math.floor(s.options.slidesToShow / 2)),
                        !0 === s.options.infinite &&
                          (t >= e && t <= s.slideCount - 1 - e
                            ? s.$slides
                                .slice(t - e, t + e + 1)
                                .addClass('slick-active')
                                .attr('aria-hidden', 'false')
                            : ((n = s.options.slidesToShow + t),
                              i
                                .slice(n - e + 1, n + e + 2)
                                .addClass('slick-active')
                                .attr('aria-hidden', 'false')),
                          0 === t
                            ? i
                                .eq(i.length - 1 - s.options.slidesToShow)
                                .addClass('slick-center')
                            : t === s.slideCount - 1 &&
                              i
                                .eq(s.options.slidesToShow)
                                .addClass('slick-center')),
                        s.$slides.eq(t).addClass('slick-center'))
                      : t >= 0 && t <= s.slideCount - s.options.slidesToShow
                      ? s.$slides
                          .slice(t, t + s.options.slidesToShow)
                          .addClass('slick-active')
                          .attr('aria-hidden', 'false')
                      : i.length <= s.options.slidesToShow
                      ? i.addClass('slick-active').attr('aria-hidden', 'false')
                      : ((o = s.slideCount % s.options.slidesToShow),
                        (n =
                          !0 === s.options.infinite
                            ? s.options.slidesToShow + t
                            : t),
                        s.options.slidesToShow == s.options.slidesToScroll &&
                        s.slideCount - t < s.options.slidesToShow
                          ? i
                              .slice(n - (s.options.slidesToShow - o), n + o)
                              .addClass('slick-active')
                              .attr('aria-hidden', 'false')
                          : i
                              .slice(n, n + s.options.slidesToShow)
                              .addClass('slick-active')
                              .attr('aria-hidden', 'false')),
                    'ondemand' === s.options.lazyLoad && s.lazyLoad();
                }),
                (i.prototype.setupInfinite = function () {
                  var e,
                    i,
                    n,
                    o = this;
                  if (
                    (!0 === o.options.fade && (o.options.centerMode = !1),
                    !0 === o.options.infinite &&
                      !1 === o.options.fade &&
                      ((i = null), o.slideCount > o.options.slidesToShow))
                  ) {
                    for (
                      n =
                        !0 === o.options.centerMode
                          ? o.options.slidesToShow + 1
                          : o.options.slidesToShow,
                        e = o.slideCount;
                      e > o.slideCount - n;
                      e -= 1
                    )
                      (i = e - 1),
                        t(o.$slides[i])
                          .clone(!0)
                          .attr('id', '')
                          .attr('data-slick-index', i - o.slideCount)
                          .prependTo(o.$slideTrack)
                          .addClass('slick-cloned');
                    for (e = 0; e < n; e += 1)
                      (i = e),
                        t(o.$slides[i])
                          .clone(!0)
                          .attr('id', '')
                          .attr('data-slick-index', i + o.slideCount)
                          .appendTo(o.$slideTrack)
                          .addClass('slick-cloned');
                    o.$slideTrack
                      .find('.slick-cloned')
                      .find('[id]')
                      .each(function () {
                        t(this).attr('id', '');
                      });
                  }
                }),
                (i.prototype.interrupt = function (t) {
                  t || this.autoPlay(), (this.interrupted = t);
                }),
                (i.prototype.selectHandler = function (e) {
                  var i = this,
                    n = t(e.target).is('.slick-slide')
                      ? t(e.target)
                      : t(e.target).parents('.slick-slide'),
                    o = parseInt(n.attr('data-slick-index'));
                  if ((o || (o = 0), i.slideCount <= i.options.slidesToShow))
                    return i.setSlideClasses(o), void i.asNavFor(o);
                  i.slideHandler(o);
                }),
                (i.prototype.slideHandler = function (t, e, i) {
                  var n,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c = this;
                  if (
                    ((e = e || !1),
                    (!0 !== c.animating || !0 !== c.options.waitForAnimate) &&
                      !(
                        (!0 === c.options.fade && c.currentSlide === t) ||
                        c.slideCount <= c.options.slidesToShow
                      ))
                  )
                    if (
                      (!1 === e && c.asNavFor(t),
                      (n = t),
                      (a = c.getLeft(n)),
                      (r = c.getLeft(c.currentSlide)),
                      (c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft),
                      !1 === c.options.infinite &&
                        !1 === c.options.centerMode &&
                        (t < 0 ||
                          t > c.getDotCount() * c.options.slidesToScroll))
                    )
                      !1 === c.options.fade &&
                        ((n = c.currentSlide),
                        !0 !== i
                          ? c.animateSlide(r, function () {
                              c.postSlide(n);
                            })
                          : c.postSlide(n));
                    else if (
                      !1 === c.options.infinite &&
                      !0 === c.options.centerMode &&
                      (t < 0 || t > c.slideCount - c.options.slidesToScroll)
                    )
                      !1 === c.options.fade &&
                        ((n = c.currentSlide),
                        !0 !== i
                          ? c.animateSlide(r, function () {
                              c.postSlide(n);
                            })
                          : c.postSlide(n));
                    else {
                      if (
                        (c.options.autoplay && clearInterval(c.autoPlayTimer),
                        (o =
                          n < 0
                            ? c.slideCount % c.options.slidesToScroll != 0
                              ? c.slideCount -
                                (c.slideCount % c.options.slidesToScroll)
                              : c.slideCount + n
                            : n >= c.slideCount
                            ? c.slideCount % c.options.slidesToScroll != 0
                              ? 0
                              : n - c.slideCount
                            : n),
                        (c.animating = !0),
                        c.$slider.trigger('beforeChange', [
                          c,
                          c.currentSlide,
                          o,
                        ]),
                        (s = c.currentSlide),
                        (c.currentSlide = o),
                        c.setSlideClasses(c.currentSlide),
                        c.options.asNavFor &&
                          (l = (l = c.getNavTarget()).slick('getSlick'))
                            .slideCount <= l.options.slidesToShow &&
                          l.setSlideClasses(c.currentSlide),
                        c.updateDots(),
                        c.updateArrows(),
                        !0 === c.options.fade)
                      )
                        return (
                          !0 !== i
                            ? (c.fadeSlideOut(s),
                              c.fadeSlide(o, function () {
                                c.postSlide(o);
                              }))
                            : c.postSlide(o),
                          void c.animateHeight()
                        );
                      !0 !== i
                        ? c.animateSlide(a, function () {
                            c.postSlide(o);
                          })
                        : c.postSlide(o);
                    }
                }),
                (i.prototype.startLoad = function () {
                  var t = this;
                  !0 === t.options.arrows &&
                    t.slideCount > t.options.slidesToShow &&
                    (t.$prevArrow.hide(), t.$nextArrow.hide()),
                    !0 === t.options.dots &&
                      t.slideCount > t.options.slidesToShow &&
                      t.$dots.hide(),
                    t.$slider.addClass('slick-loading');
                }),
                (i.prototype.swipeDirection = function () {
                  var t,
                    e,
                    i,
                    n,
                    o = this;
                  return (
                    (t = o.touchObject.startX - o.touchObject.curX),
                    (e = o.touchObject.startY - o.touchObject.curY),
                    (i = Math.atan2(e, t)),
                    (n = Math.round((180 * i) / Math.PI)) < 0 &&
                      (n = 360 - Math.abs(n)),
                    n <= 45 && n >= 0
                      ? !1 === o.options.rtl
                        ? 'left'
                        : 'right'
                      : n <= 360 && n >= 315
                      ? !1 === o.options.rtl
                        ? 'left'
                        : 'right'
                      : n >= 135 && n <= 225
                      ? !1 === o.options.rtl
                        ? 'right'
                        : 'left'
                      : !0 === o.options.verticalSwiping
                      ? n >= 35 && n <= 135
                        ? 'down'
                        : 'up'
                      : 'vertical'
                  );
                }),
                (i.prototype.swipeEnd = function (t) {
                  var e,
                    i,
                    n = this;
                  if (
                    ((n.dragging = !1),
                    (n.interrupted = !1),
                    (n.shouldClick = !(n.touchObject.swipeLength > 10)),
                    void 0 === n.touchObject.curX)
                  )
                    return !1;
                  if (
                    (!0 === n.touchObject.edgeHit &&
                      n.$slider.trigger('edge', [n, n.swipeDirection()]),
                    n.touchObject.swipeLength >= n.touchObject.minSwipe)
                  ) {
                    switch ((i = n.swipeDirection())) {
                      case 'left':
                      case 'down':
                        (e = n.options.swipeToSlide
                          ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                          : n.currentSlide + n.getSlideCount()),
                          (n.currentDirection = 0);
                        break;
                      case 'right':
                      case 'up':
                        (e = n.options.swipeToSlide
                          ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                          : n.currentSlide - n.getSlideCount()),
                          (n.currentDirection = 1);
                    }
                    'vertical' != i &&
                      (n.slideHandler(e),
                      (n.touchObject = {}),
                      n.$slider.trigger('swipe', [n, i]));
                  } else
                    n.touchObject.startX !== n.touchObject.curX &&
                      (n.slideHandler(n.currentSlide), (n.touchObject = {}));
                }),
                (i.prototype.swipeHandler = function (t) {
                  var e = this;
                  if (
                    !(
                      !1 === e.options.swipe ||
                      ('ontouchend' in document && !1 === e.options.swipe) ||
                      (!1 === e.options.draggable &&
                        -1 !== t.type.indexOf('mouse'))
                    )
                  )
                    switch (
                      ((e.touchObject.fingerCount =
                        t.originalEvent && void 0 !== t.originalEvent.touches
                          ? t.originalEvent.touches.length
                          : 1),
                      (e.touchObject.minSwipe =
                        e.listWidth / e.options.touchThreshold),
                      !0 === e.options.verticalSwiping &&
                        (e.touchObject.minSwipe =
                          e.listHeight / e.options.touchThreshold),
                      t.data.action)
                    ) {
                      case 'start':
                        e.swipeStart(t);
                        break;
                      case 'move':
                        e.swipeMove(t);
                        break;
                      case 'end':
                        e.swipeEnd(t);
                    }
                }),
                (i.prototype.swipeMove = function (t) {
                  var e,
                    i,
                    n,
                    o,
                    s,
                    r = this;
                  return (
                    (s =
                      void 0 !== t.originalEvent
                        ? t.originalEvent.touches
                        : null),
                    !(!r.dragging || (s && 1 !== s.length)) &&
                      ((e = r.getLeft(r.currentSlide)),
                      (r.touchObject.curX =
                        void 0 !== s ? s[0].pageX : t.clientX),
                      (r.touchObject.curY =
                        void 0 !== s ? s[0].pageY : t.clientY),
                      (r.touchObject.swipeLength = Math.round(
                        Math.sqrt(
                          Math.pow(r.touchObject.curX - r.touchObject.startX, 2)
                        )
                      )),
                      !0 === r.options.verticalSwiping &&
                        (r.touchObject.swipeLength = Math.round(
                          Math.sqrt(
                            Math.pow(
                              r.touchObject.curY - r.touchObject.startY,
                              2
                            )
                          )
                        )),
                      'vertical' !== (i = r.swipeDirection())
                        ? (void 0 !== t.originalEvent &&
                            r.touchObject.swipeLength > 4 &&
                            t.preventDefault(),
                          (o =
                            (!1 === r.options.rtl ? 1 : -1) *
                            (r.touchObject.curX > r.touchObject.startX
                              ? 1
                              : -1)),
                          !0 === r.options.verticalSwiping &&
                            (o =
                              r.touchObject.curY > r.touchObject.startY
                                ? 1
                                : -1),
                          (n = r.touchObject.swipeLength),
                          (r.touchObject.edgeHit = !1),
                          !1 === r.options.infinite &&
                            ((0 === r.currentSlide && 'right' === i) ||
                              (r.currentSlide >= r.getDotCount() &&
                                'left' === i)) &&
                            ((n =
                              r.touchObject.swipeLength *
                              r.options.edgeFriction),
                            (r.touchObject.edgeHit = !0)),
                          !1 === r.options.vertical
                            ? (r.swipeLeft = e + n * o)
                            : (r.swipeLeft =
                                e + n * (r.$list.height() / r.listWidth) * o),
                          !0 === r.options.verticalSwiping &&
                            (r.swipeLeft = e + n * o),
                          !0 !== r.options.fade &&
                            !1 !== r.options.touchMove &&
                            (!0 === r.animating
                              ? ((r.swipeLeft = null), !1)
                              : void r.setCSS(r.swipeLeft)))
                        : void 0)
                  );
                }),
                (i.prototype.swipeStart = function (t) {
                  var e,
                    i = this;
                  if (
                    ((i.interrupted = !0),
                    1 !== i.touchObject.fingerCount ||
                      i.slideCount <= i.options.slidesToShow)
                  )
                    return (i.touchObject = {}), !1;
                  void 0 !== t.originalEvent &&
                    void 0 !== t.originalEvent.touches &&
                    (e = t.originalEvent.touches[0]),
                    (i.touchObject.startX = i.touchObject.curX =
                      void 0 !== e ? e.pageX : t.clientX),
                    (i.touchObject.startY = i.touchObject.curY =
                      void 0 !== e ? e.pageY : t.clientY),
                    (i.dragging = !0);
                }),
                (i.prototype.unfilterSlides = i.prototype.slickUnfilter =
                  function () {
                    var t = this;
                    null !== t.$slidesCache &&
                      (t.unload(),
                      t.$slideTrack.children(this.options.slide).detach(),
                      t.$slidesCache.appendTo(t.$slideTrack),
                      t.reinit());
                  }),
                (i.prototype.unload = function () {
                  var e = this;
                  t('.slick-cloned', e.$slider).remove(),
                    e.$dots && e.$dots.remove(),
                    e.$prevArrow &&
                      e.htmlExpr.test(e.options.prevArrow) &&
                      e.$prevArrow.remove(),
                    e.$nextArrow &&
                      e.htmlExpr.test(e.options.nextArrow) &&
                      e.$nextArrow.remove(),
                    e.$slides
                      .removeClass(
                        'slick-slide slick-active slick-visible slick-current'
                      )
                      .attr('aria-hidden', 'true')
                      .css('width', '');
                }),
                (i.prototype.unslick = function (t) {
                  var e = this;
                  e.$slider.trigger('unslick', [e, t]), e.destroy();
                }),
                (i.prototype.updateArrows = function () {
                  var t = this;
                  Math.floor(t.options.slidesToShow / 2),
                    !0 === t.options.arrows &&
                      t.slideCount > t.options.slidesToShow &&
                      !t.options.infinite &&
                      (t.$prevArrow
                        .removeClass('slick-disabled')
                        .attr('aria-disabled', 'false'),
                      t.$nextArrow
                        .removeClass('slick-disabled')
                        .attr('aria-disabled', 'false'),
                      0 === t.currentSlide
                        ? (t.$prevArrow
                            .addClass('slick-disabled')
                            .attr('aria-disabled', 'true'),
                          t.$nextArrow
                            .removeClass('slick-disabled')
                            .attr('aria-disabled', 'false'))
                        : t.currentSlide >=
                            t.slideCount - t.options.slidesToShow &&
                          !1 === t.options.centerMode
                        ? (t.$nextArrow
                            .addClass('slick-disabled')
                            .attr('aria-disabled', 'true'),
                          t.$prevArrow
                            .removeClass('slick-disabled')
                            .attr('aria-disabled', 'false'))
                        : t.currentSlide >= t.slideCount - 1 &&
                          !0 === t.options.centerMode &&
                          (t.$nextArrow
                            .addClass('slick-disabled')
                            .attr('aria-disabled', 'true'),
                          t.$prevArrow
                            .removeClass('slick-disabled')
                            .attr('aria-disabled', 'false')));
                }),
                (i.prototype.updateDots = function () {
                  var t = this;
                  null !== t.$dots &&
                    (t.$dots
                      .find('li')
                      .removeClass('slick-active')
                      .attr('aria-hidden', 'true'),
                    t.$dots
                      .find('li')
                      .eq(Math.floor(t.currentSlide / t.options.slidesToScroll))
                      .addClass('slick-active')
                      .attr('aria-hidden', 'false'));
                }),
                (i.prototype.visibility = function () {
                  var t = this;
                  t.options.autoplay &&
                    (document[t.hidden]
                      ? (t.interrupted = !0)
                      : (t.interrupted = !1));
                }),
                (t.fn.slick = function () {
                  var t,
                    e,
                    n = this,
                    o = arguments[0],
                    s = Array.prototype.slice.call(arguments, 1),
                    r = n.length;
                  for (t = 0; t < r; t++)
                    if (
                      ('object' == typeof o || void 0 === o
                        ? (n[t].slick = new i(n[t], o))
                        : (e = n[t].slick[o].apply(n[t].slick, s)),
                      void 0 !== e)
                    )
                      return e;
                  return n;
                });
            })
              ? n.apply(e, o)
              : n) || (t.exports = s);
    })();
  },
  ,
  ,
  function (t, e, i) {
    'use strict';
    i.r(e), i(8);
    var n = i(0),
      o = i.n(n),
      s = (i(4), i(3)),
      r = i(1),
      a = i.n(r),
      l = i(2),
      c = i.n(l),
      d = i(7),
      u =
        (i(15),
        i(16),
        i(17),
        i(18),
        c.a.View.extend({
          initialize: function (t) {
            var e = this;
            (e.$body = e.$el),
              (e.selectors = {
                productJson: '[data-product-json]',
              }),
              (e.$header = o()('header #header')),
              (e.$footer = o()('footer #footer')),
              (e.$sideCart = e.$body.find('#side-cart')),
              (e.$page = o()('#page')),
              (e.$loadingOverlay = o()('#loading-overlay')),
              (e.$sideCartUpsell = e.$sideCart.find('.sidecart-upsell')),
              (e.$mobileMenu = o()('#menu-mobile')),
              (e.$compression = o()('.compression-levels')),
              setTimeout(function () {
                o()('.content-wrapper').css('padding-top', e.$header.height()),
                  o()(window).resize(function () {
                    o()('.content-wrapper').css(
                      'padding-top',
                      e.$header.height()
                    );
                  });
              }, 200),
              ORW.utilities.isMobile() || e.$body.addClass('isNotMobile'),
              e.addToBag(),
              e.$sideCart.length > 0 && e.sideCartInit(),
              e.$sideCartUpsell.length > 0 && e.upsellAddToCart(),
              e.mobileMenuInit();
          },
          events: {
            'click .compression-levels .submenu': 'compressionSubmenu',
            'click .compression-levels a.open-close': 'compressionToggle',
            'click .compression-levels .info': 'compressionToggleInfo',
            'click .compression-levels .level': 'compressionLevelClick',
            'click #swym-notification-title .swym-redirect': 'openSwymModal',
            'click #swym-notification-content .swym-redirect': 'openSwymModal',
          },
          openSwymModal: function (t) {
            t.preventDefault(), window._swat.notepad.openNotepad();
          },
          addToBag: function () {
            var t = this,
              e = o()('.header .cart-wrap span.count');
            n();
            var i = {
              'submit .add-to-cart-form': function (e) {
                return (
                  (function (t) {
                    if ('' == t.find('input[name=id]').val()) {
                      var e;
                      if (
                        (t.find('.single-option-selector').length > 0
                          ? ((e = !0),
                            t.find('.single-option-selector').each(function () {
                              if ('' == o()(this).val()) return (e = !1), !1;
                            }))
                          : (e = !1),
                        e)
                      ) {
                        var i = t.find('.validation-msg').text();
                        i
                          ? alert(i)
                          : alert('The selected variant is sold out.');
                      } else {
                        var n = [];
                        t.find('.options label').each(function (t, e) {
                          n.push(o()(e).text().replace(':', '').trim());
                        }),
                          alert('You must select a ' + n.join('/') + '.');
                      }
                      return !1;
                    }
                    return !0;
                  })(o()(e.currentTarget)) &&
                    (function (e) {
                      t.$loadingOverlay.show(), modal && modal.close();
                      // ATC Code.
                      var i = e.closest('.initialized').data('product-js');
                      // format ATC how we want it.
                      const form = $(e)[0];
                      // console.log(form);
                      let formData = new FormData(form);
                      const formParams = new URLSearchParams(formData);
                      const tempObject = Object.fromEntries(formParams);
                      let formDataJSON = {};
                      const accepted_keys = ['id', 'quantity', 'properties', 'selling_plan']
                      for (let key in tempObject) {
                        // check if key starts with one of the accepted keys and the value is not empty
                        if (accepted_keys.some(accepted_key => key.startsWith(accepted_key)) && tempObject[key] !== "") {
                          if (key.startsWith('properties')) {
                            if (!formDataJSON['properties']) {
                              formDataJSON['properties'] = {};
                            }
                            let innerKey = key.split('[')[1].split(']')[0];
                            // check if value is not empty
                            if (tempObject[key] !== "") {
                              formDataJSON['properties'][innerKey] = tempObject[key];
                            }
                          } else {
                            formDataJSON[key] = tempObject[key];
                          }
                        }
                      }
                      const items_added = [formDataJSON];
                      const sendData = { items: items_added };
                      // set event data
                      let eventLocation = "";
                      const sideCartUpsell = form.closest('.sidecart-upsell');
                      const quickView = form.closest('.tingle-modal.quick-view');
                      if(sideCartUpsell){
                        // if the form is inside a .sidecart-upsell, it's a cart upsell.
                        eventLocation = "mini_cart_upsell";
                      } else if(quickView){
                        // if the form is inside a quickview, we know it's a quickview. Use liquid in snippets/datalayer to determine what kind of page the quick view was on.
                        eventLocation = "quick_view";
                      }
                      let eventData = {
                        eventType: eventLocation
                      }
                      i &&
                        o()(document).trigger('addToCart', [
                          i.getProduct(),
                          i.getCurrentVariant(),
                        ]),
                        o.a.ajax({
                          type: 'POST',
                          url: `${window.Shopify.routes.cart_add_url}.js`,
                          data: sendData,
                          dataType: 'json',
                          error: l,
                          success: function(res){
                            // dispatch our event.
                            document.dispatchEvent(new CustomEvent("cart:item:added", { detail: {
                              'response': res,
                              'items_added': items_added,
                              'event': eventData
                            }}));
                            r();
                          },
                          cache: !1,
                        });
                    })(o()(e.currentTarget)),
                  !1
                );
              },
              'change #side-cart input[type=number]': function (t) {
                // if the numerical input of a quantity changes, run the cart update code.
                s(t);
              },
              'click #side-cart .remove': function (t) {
                // when we click remove, then run the cart update code.
                return (
                  s(t),
                  !1
                );
              },
            };

            function n() {
              var t = 0;
              o.a
                .getJSON(`${window.Shopify.routes.cart_url}.js`, function (t) {})
                .done(function (i) {
                  (t = i.item_count), e.html(t);
                });
            }

            function s(event) { // update general cart quantities and re-render the cart.
              // console.log("cart quantities update function s() ran.", event.target);
              const targetElement = event.target;
              const removeButton = targetElement.closest('.remove');
              const isQuantityInput = targetElement.classList.contains('quantity-input');
              if(!(removeButton || isQuantityInput)) return
              const item = targetElement.closest('.item');
              // console.log("item: ", item);
              const itemKey = item.dataset.key;
              let previousQuantity = 0;
              let itemQuantity = 0;
              if(removeButton){
                previousQuantity = parseInt(item.querySelector('.quantity-input').value);
                itemQuantity = 0;
              } else {
                previousQuantity = parseInt(targetElement.dataset.previousQuantity);
                itemQuantity = parseInt(targetElement.value);
              }
              if(itemQuantity == previousQuantity) return;
              // console.log(`Product quantity has changed from ${previousQuantity} to ${itemQuantity}`);
              targetElement.setAttribute('data-previous-quantity', itemQuantity);
              t.$loadingOverlay.show();
              // cart/update.js cannot modify line item properties, we only need to send this.
              const sendData = {updates:{}};
              sendData.updates[itemKey] = parseInt(itemQuantity);
              // console.log(sendData);
              let eventType = "";
              let itemChangedQuantity = 0;
              if(itemQuantity == 0){
                eventType = "mini-cart-item-remove";
                itemChangedQuantity = previousQuantity;
              } else if(itemQuantity > previousQuantity){
                eventType = "mini-cart-item-quantity-add";
                itemChangedQuantity = (itemQuantity - previousQuantity);
              } else {
                eventType = "mini-cart-item-quantity-remove";
                itemChangedQuantity = (previousQuantity - itemQuantity);
              }
              const dataLayerInfo = {
                eventType: eventType,
                itemQuantity: itemChangedQuantity
              }
              if(eventType == "mini-cart-item-remove"){
                let cartBeforeRemoval = null;
                o.a.ajax({
                  url: `${window.Shopify.routes.cart_url}.js`,
                  dataType: "json",
                  success: function success(fetchCart) {
                    cartBeforeRemoval = fetchCart;
                    o.a.ajax({
                      type: 'POST',
                      url: `${window.Shopify.routes.cart_update_url}.js`,
                      data: sendData,
                      async: false,
                      cache: false,
                      dataType: 'json',
                      success: function () {
                        document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
                          response: cartBeforeRemoval,
                          event: dataLayerInfo,
                          item_changed: {
                            quantity: itemQuantity,
                            id: itemKey
                          }
                        }}));
                        // update the item's quantity element's previous quantity to the new quantity.
                        targetElement.setAttribute('data-previous-quantity', itemQuantity);
                        n();
                        r();
                        o()('#add-cart-overlay').fadeOut();
                      }
                    });
                  }
                });
              } else {
                o.a.ajax({
                  type: 'POST',
                  url: `${window.Shopify.routes.cart_update_url}.js`,
                  data: sendData,
                  dataType: 'json',
                  error: function () {
                    console.log('cart error');
                  },
                  success: function (res) {
                    document.dispatchEvent(new CustomEvent("cart:item:updated", { detail: {
                      response: res,
                      event: dataLayerInfo,
                      item_changed: {
                        quantity: itemQuantity,
                        id: itemKey
                      },
                    }}));
                    // update the item's quantity element's previous quantity to the new quantity.
                    targetElement.setAttribute('data-previous-quantity', itemQuantity);
                    n();
                    r();
                    o()('#add-cart-overlay').fadeOut();
                  },
                });
              }
            }

            function r(e, i, s) {
              var r;
              (r = c),
                giftID
                  ? o.a.ajax({
                      url: `${window.Shopify.routes.cart_url}.json`,
                      dataType: 'json',
                      success: function (e) {
                        var i,
                          n = !1,
                          s = !1;
                        o.a.each(e.items, function () {
                          this.variant_id == giftID &&
                          this.properties.GIFT &&
                          'Free' == this.properties.GIFT
                            ? (n = !0)
                            : 'Gift Card' != this.product_type && (s = !0);
                        }),
                          !n && s
                            ? o.a.ajax({
                                type: 'POST',
                                url: `${window.Shopify.routes.cart_add_url}.js`,
                                dataType: 'json',
                                data:
                                  'id=' + giftID + '&properties%5BGIFT%5D=Free',
                                success: function () {
                                  console.log('successful ATC from themeMain.js line ~6625');
                                  r();
                                },
                              })
                            : n && !s
                            ? ((i = giftID),
                              t.$loadingOverlay.show(),
                              t.$sideCart.remove(),
                              o.a.ajax({
                                type: 'POST',
                                url: `${window.Shopify.routes.cart_change_url}.js`,
                                data: {
                                  id: i,
                                  quantity: 0,
                                },
                                dataType: 'json',
                                error: function () {
                                  c(), t.$loadingOverlay.hide();
                                },
                                success: function () {
                                  console.log('Successful cart change themeMain.js ~6697', res);
                                  c();
                                  t.$loadingOverlay.hide();
                                },
                                cache: !1,
                              }))
                            : r();
                      },
                    })
                  : r(),
                n();
            }

            function l(e, i, n) {
              var s = o.a.parseJSON(e.responseText);
              t.$loadingOverlay.hide();
              var r = new tingle.modal({
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: 'Close',
                cssClass: ['message'],
              });
              r.setContent(
                '<div class="error-itemincart">' + s.description + '</div>'
              ),
                r.open();
            }

            function c() {
              o.a.ajax({
                type: 'GET',
                url: `${window.Shopify.routes.cart_url}?view=side-cart`,
                cache: !1,
                success: function (e) {
                  t.$loadingOverlay.hide();
                  var i = !0;
                  t.$sideCart.width() > 0 &&
                    t.$sideCart.hasClass('open') &&
                    (i = !1),
                    setTimeout(function () {
                      o()('#side-cart.upsell .ups').addClass('open');
                    }, 500),
                    t.$sideCart.remove(),
                    t.$page.append(e),
                    (t.$sideCart = t.$body.find('#side-cart')),
                    i || t.$sideCart.removeClass('ease-animation-med'),
                    t.$sideCartUpsell.length > 0 && t.upsellAddToCart(),
                    modal && modal.close(),
                    t.showSideCart(i);
                },
              }),
                n();
            }
            document.addEventListener('activateMiniCart', () => {
              console.log('WHAT is happending');
              c();
            });
            a.a.extend(t.events, i), t.delegateEvents();
          },
          sideCartInit: function () {
            var t = this,
              e = {
                click: function (e) {
                  !o()(e.target).closest('#side-cart').length &&
                    'loading-overlay' != o()(event.target).attr('id') &&
                    t.$sideCart.hasClass('open') &&
                    t.hideSideCart();
                },
                'click .header .cart-wrap': function (e) {
                  return t.showSideCart(!0), !1;
                },
                'click #side-cart .reg .close': function (e) {
                  e.preventDefault(), t.hideSideCart();
                },
                'click #side-cart .btn-continue': function (e) {
                  e.preventDefault(), t.hideSideCart();
                },
                'click #side-cart a.remove-from-cart': function (t) {
                  var e = o()(t.currentTarget).attr('href').replace('#', '');
                  return removeItemFromCart(e), !1;
                },
              };
            a.a.extend(t.events, e), t.delegateEvents();
          },
          showSideCart: function (t) {
            var e = this;
            o()('body, html').css({
              overflow: 'hidden',
            }),
              e.$page.addClass('mode-overlay'),
              t
                ? (setTimeout(function () {
                    e.$sideCart.addClass('open');
                  }, 100),
                  setTimeout(function () {
                    o()('#side-cart.upsell .ups').addClass('open');
                  }, 500))
                : (e.$sideCart.addClass('open'),
                  setTimeout(function () {
                    e.$sideCart.addClass('ease-animation-med');
                  }, 200)),
              setTimeout(function () {
                var t =
                  '0px' == e.$sideCart.find('.sticky').css('bottom')
                    ? '1px'
                    : '0px';
                e.$sideCart.find('.sticky').css('bottom', t),
                  e.$sideCart.find('.sticky').css('margin-bottom', '-' + t);
              }, 500),
              Simplistic.trapFocus({
                $container: e.$sideCart,
                namespace: 'side-cart',
              });
          },
          hideSideCart: function () {
            this.$sideCart.removeClass('open'),
              this.$page.removeClass('mode-overlay'),
              o()('body, html').css({
                overflow: '',
              }),
              Simplistic.removeTrapFocus({
                $container: this.$sideCart,
                namespace: 'side-cart',
              });
          },
          upsellAddToCart: function () {
            var t = this,
              e = t.$sideCartUpsell.find('.content .item');
            a.a.each(e, function (e) {
              var i = JSON.parse(o()(e).find(t.selectors.productJson).html());
              void 0 !== i &&
                d.a.init({
                  productJSON: i,
                  prefix: '#side-cart',
                });
            });
          },
          mobileMenuInit: function () {
            var t = this,
              e = {
                'click .menu-mobile-button': function (e) {
                  t.openMobileMenu();
                },
                'click #menu-mobile .close': function (e) {
                  t.closeMobileMenu();
                },
                'click #menu-mobile .has-dropdown .icon-toggle': function (e) {
                  t.expandMobileSubMenu(e.currentTarget);
                },
              };
            a.a.extend(t.events, e),
              t.delegateEvents(),
              o()(document).on(
                'keydown',
                '#menu-mobile .menu-mobile .has-dropdown a:focus',
                function (t) {
                  32 == t.which &&
                    (t.preventDefault(),
                    o()(this).parent().toggleClass('active'),
                    o()(this).parent().find('.submenu:first').slideToggle()),
                    40 == t.which &&
                      (t.preventDefault(),
                      o()(this).parent().toggleClass('active'),
                      o()(this).parent().find('.submenu:first').slideDown()),
                    38 == t.which &&
                      (t.preventDefault(),
                      o()(this).parent().toggleClass('active'),
                      o()(this).parent().find('.submenu:first').slideUp());
                }
              );
          },
          openMobileMenu: function () {
            this.$mobileMenu.toggleClass('open'),
              o()('body, html').css({
                overflow: 'hidden',
              }),
              this.$page.addClass('mode-overlay anim'),
              Simplistic.trapFocus({
                $container: this.$mobileMenu,
                namespace: 'menu-mobile',
              });
          },
          closeMobileMenu: function () {
            this.$mobileMenu.removeClass('open'),
              o()('body, html').css({
                overflow: 'auto',
              }),
              this.$page.removeClass('mode-overlay anim'),
              Simplistic.removeTrapFocus({
                $container: this.$mobileMenu,
                namespace: 'menu-mobile',
              });
          },
          expandMobileSubMenu: function (t) {
            o()(t).closest('.has-dropdown').toggleClass('active'),
              o()(t)
                .closest('.has-dropdown')
                .find('.submenu:first')
                .slideToggle();
          },
          compressionSubmenu: function (t) {
            var e = o()(t.currentTarget),
              i = e.find('.popup');
            i.is(':visible')
              ? (i.hide(), e.find('.current').removeClass('popupOpened'))
              : (e.find('.current').addClass('popupOpened'), i.show());
          },
          compressionToggle: function (t) {
            var e = o()(t.currentTarget).closest('.compression-levels');
            e.find('.submenu').slideToggle(),
              e
                .find('i')
                .toggleClass('fa-angle-up')
                .toggleClass('fa-angle-down'),
              e.find('.infoWrapper .popup').slideToggle(),
              e.find('.info').toggleClass('active');
          },
          compressionToggleInfo: function (t) {
            var e = o()(t.currentTarget).closest('.compression-levels');
            e.find('.popup').slideToggle(), e.toggleClass('active');
          },
          compressionFilterHover: function (t) {
            var e = o()(t.currentTarget).closest('.compression-levels'),
              i = e.find('.levels').index(t.currentTarget);
            e.find('.level:lt(' + i + ')').addClass('hover'),
              o()(t.currentTarget).addClass('hover'),
              (i = e.find('.levels').index(t.currentTarget)),
              e.find('.level:lt(' + i + ')').addClass('hover'),
              o()(t.currentTarget).addClass('hover');
          },
          compressionFilterHoverOut: function (t) {
            o()(t.currentTarget)
              .closest('.compression-levels')
              .find('.hover')
              .removeClass('hover');
          },
          compressionLevelClick: function (t) {
            if (!this.$body.hasClass('templateProduct')) {
              var e = o()(t.currentTarget),
                i = e.closest('.compression-levels');
              if ((e.removeClass('selected'), e.hasClass('active')))
                e.removeClass('active');
              else {
                var n = e.index(e);
                i.find('.level:lt(' + n + ')').addClass('selected'),
                  e.removeClass('active'),
                  e.addClass('active');
              }
            }
          },
          isMobile: function () {
            return 'large' != ORW.responsive;
          },
          devTools: function () {
            var t = o()('#responsive-indicator'),
              e = o()('#preview-bar-iframe');
            if (void 0 !== Shopify.PreviewBarInjector)
              if (
                t.length > 0 &&
                e.length > 0 &&
                1 == Shopify.PreviewBarInjector.length
              ) {
                t.text('Preview: ' + Shopify.theme.name).removeClass('hide');
                var i = {
                  'click #responsive-indicator': function (i) {
                    t.toggleClass('active'), e.toggleClass('active');
                  },
                };
                a.a.extend(this.events, i), this.delegateEvents();
              } else t.addClass('hide');
          },
        }));
    o()(document).onCreate('body', function () {
      var t = o()('body');
      Object(s.a)(function () {
        ORW.Global = new u({
          el: t,
        });
      }),
        t.hasClass('templateIndex') && i(24),
        t.hasClass('templateProduct') && i(25),
        (t.hasClass('templateCollection') || t.hasClass('templateSearch')) &&
          i(26),
        t.hasClass('templateCart') && i(27);
    }),
      (ORW.utilities._ = i(1)),
      (ORW.utilities.mediaCheck = function (t, e) {
        t || (t = function () {}),
          e || (e = function () {}),
          mediaCheck({
            media: ORW.breakpoint,
            entry: t,
            exit: e,
          });
      }),
      ORW.utilities.mediaCheck(
        function () {
          ORW.responsive = 'large';
        },
        function () {
          ORW.responsive = 'small';
        }
      );
  },
  ,
  function (t, e, i) {
    'use strict';
    i.r(e);
    var n = i(0),
      o = i.n(n),
      s = i(3),
      r = (i(4), i(1), i(2)),
      a = i.n(r).a.View.extend({
        initialize: function (t) {
          (this.$content = this.$el), (this.$body = o()('body'));
        },
        events: {
          'mouseover .compression-levels li': 'compressionHover',
          'mouseout .compression-levels li': 'compressionLeave',
          'click .compression-levels li': 'compressionLevelClick',
        },
        compressionHover: function (t) {
          var e = o()(t.currentTarget);
          if (e.hasClass('animation')) {
            var i = o()('.compression-levels li.animation').index(
              t.currentTarget
            );
            o()('.compression-levels li.animation:lt(' + i + ')').addClass(
              'hover'
            ),
              e.addClass('hover');
          }
        },
        compressionLeave: function (t) {
          o()(t.currentTarget)
            .closest('.compression-levels')
            .find('.hover')
            .removeClass('hover');
        },
        compressionLevelClick: function (t) {
          var e = o()(t.currentTarget),
            i = e.closest('.compression-levels');
          if (e.hasClass('animation'))
            if (
              (i.find('li .popup').hide(),
              i.find('li').removeClass('selected'),
              e.hasClass('active'))
            )
              i.find('li').removeClass('active');
            else {
              var n = i.find('li').index(e);
              i.find('li.animation:lt(' + n + ')').addClass('selected'),
                i.find('li').removeClass('active'),
                e.addClass('active'),
                e.find('.popup').show().addClass('fadeInDown');
            }
        },
        destroy: function () {
          this.undelegateEvents();
        },
        responsive: function () {
          ORW.utilities.mediaCheck(
            function () {},
            function () {}
          );
        },
        isMobile: function () {
          return 'small' == ORW.responsive;
        },
      });
    Object(s.a)(function () {
      new a({
        el: o()('.templateIndex'),
      });
    });
  },
  function (t, e, i) {
    'use strict';
    i.r(e);
    var n = i(0),
      o = i.n(n),
      s = i(3),
      r = (i(4), i(1)),
      a = i.n(r),
      l = i(2),
      c = i.n(l),
      d = (i(12), i(7)),
      u = c.a.View.extend({
        selectors: {
          productJSON: '[data-product-json]',
          plusSizeItem: '[data-plus-size-item]',
          saleItem: '[data-sale-item]',
        },
        initialize: function (t) {
          (this.$body = o()('body')),
            (this.productJSON =
              t.productJSON ||
              (!!this.$(this.selectors.productJSON).length &&
                JSON.parse(this.$(this.selectors.productJSON).html()))),
            (this.$item = o()('#product-item-' + this.productJSON.id)),
            this.initFreeShippingTooltip(),
            this.watchVariantStock(),
            this.initGallery(),
            this.initSelects(),
            // this.initStickyAddToBag(),
            (this.addToCart = d.a.init({
              productJSON: this.productJSON,
              prefix: '#product-wrap',
            }));
          var e = this.addToCart.optionSelectors.swatches;
          this.$item.parent().is(this.selectors.plusSizeItem)
            ? this.autoselectVariant({
                test: function (t) {
                  return /^\d/.test(t);
                },
                field: ['options', e.$sizes.optionIndex],
                selectSize: !0,
              })
            : this.$item.parent().is(this.selectors.saleItem)
            ? this.autoselectVariant({
                test: function (t) {
                  return t.compare_at_price > t.price;
                },
                field: [],
                selectSize: !1,
              })
            : this.autoselectVariant({
                test: function () {
                  return !0;
                },
                field: [],
                selectSize: !1,
              });
        },
        events: {
          'click .size-chart-link': function (t) {
            t.preventDefault(), this.initSizeChart(t.currentTarget);
          },
        },
        autoselectVariant: function (t) {
          var e = t.test,
            i = t.field,
            n = t.selectSize,
            o = this.productJSON.variants.find(function (t) {
              var n = i.reduce(function (t, e) {
                return t[e];
              }, t);
              return e(n);
            }),
            s = this.addToCart.optionSelectors.swatches,
            r = s.$colors.filter(function () {
              return this.title === o.options[s.$colors.optionIndex];
            });
          if (r.length) {
            r.get(0).click();
            var a = s.$sizes.filter(function () {
              return this.title === o.options[s.$sizes.optionIndex];
            });
            a.length && n && a.get(0).click();
          }
        },
        initFreeShippingTooltip: function () {
          var t = this,
            e = o()('.free-shipping-note .has-tooltip'),
            i = e.find('.tooltip'),
            n = function () {
              i.addClass('closing'),
                setTimeout(function () {
                  return i.removeClass('active closing');
                }, 200);
            };
          e.children('a').on('click', function (e) {
            e.preventDefault(),
              e.stopPropagation(),
              i.addClass('active'),
              t.$body.on('click.free-shipping-tooltip', function (e) {
                o()(e.target).closest('.tooltip').length ||
                  (t.$body.off('click.free-shipping-tooltip'), n());
              });
          }),
            i.find('.close').on('click', n);
        },
        initSelects: function () {
          var t = this;

          function e(t, e) {
            (this.$item = t),
              (this.$select = o()(e)),
              (this.$selectTitle = this.$select.find('.select-title')),
              (this.$selectContent = this.$select.find('.select-content')),
              (this.$selectOptions =
                this.$selectContent.find('.select-option')),
              this.$selectTitle.on(
                'click.select',
                this.tryToggleSelect.bind(this)
              ),
              this.$selectOptions.on(
                'click.select',
                this.tryMakeSelection.bind(this)
              ),
              this.$select.on('select.select', this.handleSelected.bind(this)),
              this.$select.on('close.select', this.tryCloseSelect.bind(this)),
              o()(window).on('scroll.select', this.tryCloseSelect.bind(this));
          }
          (e.prototype.handleSelected = function (t, e, i) {
            i
              ? this.$selectOptions
                  .filter('[data-value="'.concat(i, '"]'))
                  .addClass('current')
                  .siblings()
                  .removeClass('current')
              : this.$selectOptions.removeClass('current');
            var n = this.$selectOptions.filter('.current'),
              o = (n.html() || e) + '<i class="fa fa-angle-down"></i>';
            return (
              this.$selectTitle.html() !== o && this.$selectTitle.html(o),
              this.$selectTitle[
                n.hasClass('soldout') ? 'addClass' : 'removeClass'
              ]('soldout'),
              this
            );
          }),
            (e.prototype.tryCloseSelect = function () {
              var t = this;
              if (
                1 !== this.$selectContent.find('.active').length &&
                this.$select.is('.open:not(.closing), .opening')
              )
                return (
                  this.$selectContent.stop(!0).slideToggle({
                    complete: function () {
                      t.$select.removeClass('opening closing open');
                    },
                  }),
                  this.$select
                    .removeClass('opening closing')
                    .addClass('closing'),
                  this
                );
            }),
            (e.prototype.tryToggleSelect = function () {
              var t = this,
                e =
                  !(arguments.length > 0 && void 0 !== arguments[0]) ||
                  arguments[0];
              if (1 !== this.$selectContent.find('.active').length) {
                var i = !this.$select.is('.open:not(.closing), .opening');
                return (
                  this.$selectContent.stop(!0).slideToggle({
                    complete: function () {
                      t.$select.removeClass('opening closing'),
                        t.$select[i ? 'addClass' : 'removeClass']('open');
                    },
                  }),
                  this.$select
                    .removeClass('opening closing')
                    .addClass(i ? 'opening' : 'closing'),
                  e &&
                    this.$select
                      .siblings('.select')
                      .triggerHandler('close.select'),
                  this
                );
              }
            }),
            (e.prototype.tryMakeSelection = function (t) {
              if (this.$select.is('.colors, .sizes')) {
                var e = o()(t.currentTarget).data('value');
                this.$select.trigger('change.select', [e]);
              }
              return this.tryToggleSelect();
            }),
            (this.selects = this.$item
              .find('.select')
              .has('.select-title + .select-content > .select-option')
              .map(function (i, n) {
                return new e(t.$item, n);
              }));
        },
        initStickyAddToBag: function () {
          var t = document.getElementById('header'),
            e = this.$item.find('.product-form-bottom > .flex');
          if (e.length) {
            var i = e.parent().get(0),
              n = function () {
                return (
                  i.getBoundingClientRect().bottom <=
                  t.getBoundingClientRect().bottom
                );
              },
              s = n();
            s && e.addClass('sticky'),
              o()(window).on(
                'scroll',
                a.a.throttle(function () {
                  n() !== s && e.toggleClass('sticky'), (s = n());
                }, 1e3 / 60)
              );
          }
        },
        watchVariantStock: function () {
          var t = this,
            e = o()('.lystrack_BIS'),
            i = o()('#add-to-cart-button'),
            n = i.closest('form'),
            s = i.closest('.product-form-bottom').find('select');
          n.on('variant-changed', function (n, o, r, a) {
            +o == +t.productJSON.id &&
              (e.addClass('hide'),
              a && r.available
                ? (s.add(i).attr('disabled', null), i.text(i.data('copy-add')))
                : (s.add(i).attr('disabled', ''),
                  a && e.removeClass('hide'),
                  i.text(i.data(a ? 'copy-stock' : 'copy-select'))));
          });
        },
        initGallery: function () {
          function t() {
            var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : '#product-gallery';
            (this.$parent = o()(t).closest('[id^="product-item-"]')),
              (this.$ = function (e) {
                return o()(t).find(e);
              }),
              (this.$thumbsWrapper = this.$('#thumbs')),
              (this.$productImage = this.$(
                '#active-wrapper .product-image img'
              )),
              this.$productImage.closest('a').on('click', !1),
              this.lazyload().initModelSelectors().initThumbsSlick(),
              this.$parent
                .find('form.add-to-cart-form')
                .on('variant-changed', this.handleVariantChanged.bind(this));
          }
          return (
            (t.sizes = ['xs', 's', 'm', 'l', 'xl']
              .map(function (t) {
                return new RegExp('^'.concat(t), 'i');
              })
              .reverse()),
            (t.compareSizes = function (e, i) {
              return !(
                [e, i]
                  .map(function (e) {
                    return (
                      parseInt(
                        /^\d/.test(e)
                          ? e
                          : -t.sizes.findIndex(function (t) {
                              return t.test(e);
                            })
                      ) + 4
                    );
                  })
                  .reduce(function (t, e) {
                    return e - t;
                  }, 0) < 0
              );
            }),
            (t.resizeImageUrl = function (t) {
              var e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : '';
              return t
                .replace(/_\d*x\d*\.(jpe?g|png|gif)/, '.$1')
                .replace(/\.(jpe?g)/, e ? '_'.concat(e, '$&') : '$&');
            }),
            (t.prototype.changeProductImage = function (e) {
              return (
                e || (e = this.getFirstThumb().find('a').attr('href')),
                this.$productImage
                  .attr('src', e)
                  .data('src', e)
                  .closest('a')
                  .attr('href', t.resizeImageUrl(e, '')),
                this.initZoom(),
                this
              );
            }),
            (t.prototype.handleModelChanged = function (t, e, i) {
              var n = o()(t.currentTarget);
              if (!n.is('.current')) {
                n.siblings().removeClass('current'), n.addClass('current');
                var s = n.data('model-info'),
                  r = s.color,
                  a = s.size,
                  l = s.name;
                r &&
                  this.filterThumbsSlick({
                    option1: r,
                    option2: a,
                    option4: l,
                  }) &&
                  this.changeProductImage(),
                  n
                    .closest('.models')
                    .siblings('.model-selector-title')
                    .triggerHandler('click');
              }
            }),
            (t.prototype.handleVariantChanged = function (t, e, i) {
              var n = this;
              new RegExp(e).test(this.$parent.attr('id')) &&
                (/usd/i.test(i.option1) ||
                  ((this.selectedColor && this.selectedColor === i.option1) ||
                    this.$modelSelectors
                      .removeClass('open opening closing')
                      .find('.models')
                      .css('display', 'none'),
                  (this.selectedColor = i.option1),
                  (this.selectedSize = i.option2),
                  this.selectedColor &&
                    this.filterThumbsSlick(i) &&
                    (this.changeProductImage(),
                    this.$modelSelectorOptions.each(function (t, e) {
                      n.filterModelSelectorOptions(e, i);
                    }))));
            }),
            (t.prototype.initModelSelectors = function () {
              var t = this;
              return (
                (this.$modelSelectors = this.$('.model-selector')),
                (this.$modelSelectorTitles = this.$modelSelectors.map(
                  function () {
                    return o()(this).find('.model-selector-title');
                  }
                )),
                (this.$modelSelectorOptions = this.$modelSelectors.map(
                  function () {
                    return o()(this).find('.model');
                  }
                )),
                this.$modelSelectors.length
                  ? ((this.modelsInfo = this.$modelSelectorOptions[0]
                      .map(function () {
                        return o()(this).data('model-info');
                      })
                      .get()),
                    this.$modelSelectorOptions.each(function (e, i) {
                      i.on('click', t.handleModelChanged.bind(t));
                    }),
                    this)
                  : ((this.modelsInfo = []), this)
              );
            }),
            (t.prototype.initThumbsSlick = function () {
              var e = this;
              return (
                this.$thumbsWrapper.on('swipe', function () {
                  $('#thumbs').find('.mobile-image').each(function () {
                    $(this).attr('loading','eager')
                  });
                }),
                this.$thumbsWrapper.on('init', function (i, n) {
                  n.$slider.removeClass('slick-pending'),
                    e.$modelSelectors.removeClass('hide'),
                    n.$slides.find('a').on('click', function (i) {
                      i.preventDefault();
                      var n = o()(i.currentTarget).attr('href');
                      t.resizeImageUrl(n, '') !==
                        t.resizeImageUrl(e.$productImage.data('src'), '') &&
                        e.changeProductImage(n);
                    });
                  var s = n.$slides.eq(0).find('a').attr('href');
                  e.changeProductImage(s);
                }),
                (this.$thumbsWrapper = this.$thumbsWrapper.slick({
                  arrows: !1,
                  vertical: !0,
                  verticalSwiping: !0,
                  autoplay: !1,
                  infinite: !1,
                  nextArrow: '<i class="lnr lnr-chevron-right slick-next"></i>',
                  prevArrow: '<i class="lnr lnr-chevron-left slick-prev"></i>',
                  responsive: [
                    {
                      breakpoint: ORW.responsiveSizes.large,
                      settings: {
                        arrows: !0,
                        infinite: !0,
                        slidesToShow: 1,
                        vertical: !1,
                        verticalSwiping: !1,
                      },
                    },
                  ],
                  slidesToScroll: 1,
                  slidesToShow: 6,
                  speed: 200,
                })),
                this
              );
            }),
            (t.prototype.initZoom = a.a.throttle(function () {
              if(window.innerWidth <= 899 ){return false;}
              var e = this,
                i = this.$productImage.data('src').replace('width=600','width=1200')
                n = function () {
                  return e.$productImage.closest('span');
                };
              return (
                n().trigger('zoom.destroy'),
                this.$productImage.find('img.zoomImg').remove(),
                n().zoom({
                  url: i,
                }),
                this
              );
            }, 100)),
            (t.prototype.filterThumbsSlick = function (e) {
              var i = e.option1,
                n = e.option2,
                s = e.option4,
                r = this.modelsInfo.filter(function (t) {
                  return t.color === i;
                }),
                l = r[0];
              if (void 0 !== s)
                l = r.find(function (t) {
                  return t.name === s;
                });
              else {
                var c = r.slice().sort(function (e, i) {
                  var n = e.size,
                    o = i.size;
                  return n === o ? 0 : t.compareSizes(o, n) ? 1 : -1;
                });
                a.a.isEqual(r, c) &&
                  (l =
                    r
                      .filter(function (e) {
                        return t.compareSizes(e.size, n);
                      })
                      .filter(function (t, e, i) {
                        var n = t.size;
                        return (
                          i.findIndex(function (t) {
                            return t.size === n;
                          }) === e
                        );
                      })
                      .pop() || r[0]),
                  (s = l && l.name);
              }
              n = l && l.size;
              var d = this.getFirstThumb().data('model-info'),
                u = d.color,
                h = d.size,
                p = d.name;
              if (u === i && h === n && p === s) {
                var f = this.$thumbsWrapper.slick('getSlick');
                if (
                  f.$slidesCache &&
                  f.$slidesCache.length !== f.$slides.length
                )
                  return !1;
              }
              return (
                this.$thumbsWrapper
                  .slick('slickUnfilter')
                  .slick('slickFilter', function () {
                    var t = o()(this).data('model-info'),
                      e = t.color,
                      r = t.size,
                      a = t.name;
                    return e === i && r === n && a === s;
                  }),
                this
              );
            }),
            (t.prototype.filterModelSelectorOptions = function (t, e) {
              var i = e.option1,
                n = (e.option2, this.getFirstThumb().data('model-info'));
              t
                .removeClass('active')
                .removeClass('current')
                .filter(function () {
                  var t = o()(this).data('model-info').color;
                  return new RegExp('^'.concat(t, '$'), 'i').test(i);
                })
                .addClass('active')
                .filter(function () {
                  var t = o()(this).data('model-info'),
                    e = t.name,
                    i = t.size;
                  return e === n.name && i === n.size;
                })
                .addClass('current'),
                t.is('.current') ||
                  t.filter('.active').first().addClass('current');
              var s = t.filter('.active');
              return (
                this.$modelSelectorTitles.each(function (t, e) {
                  var i = 1 === s.length ? s.text() : e.data('default-content');
                  e.html() !== i && e.html(i),
                    e.css('cursor', 1 === s.length ? 'default' : '');
                }),
                this
              );
            }),
            (t.prototype.getFirstThumb = function () {
              return this.$thumbsWrapper
                .find('.slick-slide')
                .filter(function (t, e) {
                  return e.dataset.slickIndex >= 0;
                })
                .first();
            }),
            (t.prototype.lazyload = function () {
              return (
                this.$('[data-src]').each(function () {
                  o()(this).attr('src', o()(this).data('src'));
                }),
                this.$('[data-srcset]').each(function () {
                  o()(this).attr('srcset', o()(this).data('srcset'));
                }),
                this
              );
            }),
            (window.Gallery = t),
            new t()
          );
        },
        initSizeChart: function (t) {
          var e = this,
            i = o()(t).attr('href');
          return (
            o()('#loading-overlay').show(),
            (modal = new tingle.modal({
              closeMethods: ['overlay', 'button', 'escape'],
              closeLabel: 'Close',
              cssClass: ['size-chart-popup'],
            })),
            o.a
              .ajax({
                url: i,
              })
              .success(function (t) {
                o()('#loading-overlay').hide(), modal.setContent(t);
                var i = e.productJSON.tags
                    .join(',')
                    .toLowerCase()
                    .replace('style:shapewear', '')
                    .match(/style:(\w+)/i),
                  n =
                    ".size-chart .nav .selector[data-tab='" +
                    (i
                      ? i[1]
                          .replace(/(tops|tees|camis|bodysuits)/, 'tanks')
                          .replace(/(pants)/, 'jeans')
                      : 'bottoms') +
                    "']";
                console.log('DATA TAB: ', n), modal.open(), o()(n).click();
              }),
            !1
          );
        },
        destroy: function () {
          this.undelegateEvents();
        },
        isMobile: function () {
          return 'small' === ORW.responsive;
        },
      });
    Object(s.a)(function () {
      new u({
        el: o()('#main-content'),
      });
    });
  },
  function (t, e, i) {
    'use strict';
    i.r(e);
    var n = i(0),
      o = i.n(n),
      s = i(3),
      r = (i(4), i(1)),
      a = i.n(r),
      l = i(2),
      c = i.n(l),
      d =
        (i(19),
        i(12),
        i(13),
        c.a.View.extend({
          initialize: function (t) {
            (this.$content = this.$el),
              (this.$body = o()('body')),
              (this.$loadingOverlay = o()('#loading-overlay')),
              this.quickShop(),
              (this.$bannerVideos = this.$content.find(
                '.collection-banner.video'
              )),
              (this.$compressionLevels = this.$content.find(
                '.compression-levels'
              )),
              this.$bannerVideos.length > 0 &&
                this.$bannerVideos.find('video').get(0).play(),
              this.hideFilterOnNoResults();
          },
          events: {
            'click .filters-toggle': function (t) {
              this.toggleFilter();
            },
          },
          toggleFilter: function () {
            console.log('custom filter toggle fired'),
              o()('.filters-toggle').find('i').toggleClass('hide'),
              o()('.filters-wrapper').slideToggle();
          },
          quickShop: function () {
            a.a.extend(this.events, {
              'click .quick-view-btn': function (t) {},
            }),
              this.delegateEvents();
          },
          showLoader: function () {
            this.$loadingOverlay.show();
          },
          hideLoader: function () {
            this.$loadingOverlay.hide();
          },
          hideFilterOnNoResults: function () {
            o()('body').onCreate(
              '.searchspring-no_results',
              function (t) {
                o()(
                  '.templateCollection .filters, .templateCollection .mobile-only'
                ).hide();
              },
              !0
            ),
              o()('.searchspring-no_results').length &&
                o()(
                  '.templateCollection .filters, .templateCollection .mobile-only'
                ).hide();
          },
          destroy: function () {
            this.undelegateEvents();
          },
          responsive: function () {
            ORW.utilities.mediaCheck(
              function () {},
              function () {}
            );
          },
          isMobile: function () {
            return 'small' == ORW.responsive;
          },
        }));
    Object(s.a)(function () {
      new d({
        el: o()('#main-content'),
      });
    });
  },
  function (t, e, i) {
    'use strict';
    i.r(e);
    var n = i(0),
      o = i.n(n),
      s = i(3),
      r = i(1),
      a = i.n(r),
      l = i(2),
      c = i.n(l).a.View.extend({
        initialize: function (t) {
          console.log('init Cart');
          var e = this;
          (e.$content = e.$el),
            (e.$body = o()('body')),
            (e.$loadingOverlay = o()('#loading-overlay')),
            (e.$qtyPopups = o()('#cart-wrap .item .actions .edit .popup')),
            e.initCartView(),
            o()(document).on('click', document, function () {
              e.closeCartQuantities(e.$qtyPopups);
            }),
            o()(document).on('click', '.cart-item-remove', function (event) {
              e.removeCartQty(event.currentTarget);
            });
        },
        events: {},
        initCartView: function () {
          var t = this,
            e = {
              'click #cart-wrap .item .actions .edit a': function (e) {
                e.stopPropagation(), t.toggleCartQty(e.currentTarget);
              },
              'change #cart-wrap .item .actions .edit .popup input': function (e) {
                t.updateCartQty(e.currentTarget);
              },
            };
          a.a.extend(t.events, e), t.delegateEvents();
        },
        toggleCartQty: function (t) {
          var e = !o()(t).next().is(':visible'),
            i = o()('#cart-wrap .item .actions .edit .popup:visible');
          if ((this.closeCartQuantities(i), e)) {
            o()(t).next().slideDown();
            var n = o()(t).next().find('input');
            n.focus().val(n.val());
          }
        },
        closeCartQuantities: function (t) {
          a.a.each(t, function (t) {
            o()(t).slideUp();
          });
        },
        updateCartQty: function (currentTarget) {
          if(!currentTarget) return;
          // console.log("updateCartQty called", currentTarget);
          const itemKey = currentTarget.dataset.key;
          const itemQuantity = currentTarget.value;
          const previousQuantity = currentTarget.dataset.previousQuantity;
          // console.log(`Product quantity has changed from ${previousQuantity} to ${itemQuantity}`);
          const sendData = {updates:{}};
          sendData.updates[itemKey] = parseInt(itemQuantity);
          // console.log(sendData);
          let eventType = "";
          let itemChangedQuantity = 0;
          if(itemQuantity == 0){
            eventType = "cart-page-item-remove";
            itemChangedQuantity = previousQuantity;
          } else if(itemQuantity > previousQuantity){
            eventType = "cart-page-item-quantity-add";
            itemChangedQuantity = (itemQuantity - previousQuantity);
          } else {
            eventType = "cart-page-item-quantity-remove";
            itemChangedQuantity = (previousQuantity - itemQuantity);
          }
          const dataLayerInfo = {
            eventType: eventType,
            itemQuantity: itemChangedQuantity
          }
          // console.log(dataLayerInfo);
          var t = this;
          t.$loadingOverlay.show();
          if(eventType == "cart-page-item-remove"){
            let cartBeforeRemoval = null;
            o.a.ajax({
              url: `${window.Shopify.routes.cart_url}.js`,
              dataType: "json",
              success: function success(fetchCart) {
                cartBeforeRemoval = fetchCart;
                o.a.ajax({
                  type: 'POST',
                  url: `${window.Shopify.routes.cart_update_url}.js`,
                  data: sendData,
                  async: false,
                  cache: false,
                  dataType: 'json',
                  success: function () {
                    document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
                      response: cartBeforeRemoval,
                      event: dataLayerInfo,
                      item_changed: {
                        quantity: itemQuantity,
                        id: itemKey
                      }
                    }}));
                    o.a.ajax({
                      url: `${window.Shopify.routes.cart_url}?view=ajax`,
                    })
                    .done(function (e) {
                      o()('#cart-wrap').html(e), t.$loadingOverlay.hide();
                    });
                  }
                });
              }
            });
          } else {
            o.a.ajax({
              type: 'POST',
              url: `${window.Shopify.routes.cart_update_url}.js`,
              data: sendData,
              dataType: 'json',
              error: function () {
                console.log('cart error');
              },
              success: function (res) {
                document.dispatchEvent(new CustomEvent("cart:item:updated", { detail: {
                  response: res,
                  event: dataLayerInfo,
                  item_changed: {
                    quantity: itemQuantity,
                    id: itemKey
                  },
                }}));
                o.a.ajax({
                  url: `${window.Shopify.routes.cart_url}?view=ajax`,
                })
                .done(function (e) {
                  o()('#cart-wrap').html(e), t.$loadingOverlay.hide();
                });
              },
            });
          }
        },
        removeCartQty: function (currentTarget){
          if(!currentTarget) return;
          // console.log(".cart-item-remove click event.", currentTarget);
          const item = currentTarget.closest('.item');
          const currentQuantity = parseInt(item.querySelector('.edit input[name="updates[]"]').value);
          const itemKey = currentTarget.dataset.key;
          const sendData = {updates:{}};
          sendData.updates[itemKey] = 0;
          const dataLayerInfo = {
            eventType: "cart-page-item-remove",
            itemQuantity: currentQuantity
          }
          let cartBeforeRemoval = null;
          o.a.ajax({
            url: `${window.Shopify.routes.cart_url}.js`,
            dataType: "json",
            success: function success(fetchCart) {
              cartBeforeRemoval = fetchCart;
              o.a.ajax({
                type: 'POST',
                url: `${window.Shopify.routes.cart_update_url}.js`,
                data: sendData,
                async: false,
                cache: false,
                dataType: 'json',
                success: function (postAddCart) {
                  document.dispatchEvent(new CustomEvent('cart:item:updated', { detail: {
                    response: cartBeforeRemoval,
                    event: dataLayerInfo,
                    item_changed: {
                      quantity: 0,
                      id: itemKey
                    }
                  }}));
                  o.a.ajax({
                    url: `${window.Shopify.routes.cart_url}?view=ajax`,
                  })
                  .done(function (e) {
                    o()('#cart-wrap').html(e);
                  });
                }
              });
            }
          });
        },
        destroy: function () {
          this.undelegateEvents();
        },
        responsive: function () {
          ORW.utilities.mediaCheck(
            function () {},
            function () {}
          );
        },
        isMobile: function () {
          return 'small' == ORW.responsive;
        },
      });
    Object(s.a)(function () {
      new c({
        el: o()('.templateCart'),
      });
    });
  },
]);
